// @ts-nocheck
import {
  AddSummaryComponentBtn,
  CalculatorFieldInput,
  CalculatorInput,
  // CancelBtn,
  DeleteBtn,
  DisableAutocompleteInput,
  DraperyHeader,
  // DuplicateBtn,
  // EditButton,
  HContainer,
  SummaryComponentTable,
  SummaryComponentTableCell,
  SummaryComponentTableRow,
  SummaryContainer,
  SummaryContent,
  SummaryInfoBlock,
  SummaryTable,
  SummaryTableCell,
  SummaryTableCol,
  SummaryTimeline,
  WorkOrderNumber,
  CalculatorFormField,
  CalculatorYardageInput,
  CalculatorFieldInputDesc,
  CalculatorInputDesc,
} from './styles';
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip-shadcn';
import HelpIcon from '../../assets/icons/info.svg';
import styled from '../../theme';
import { DraperyModule, WorkOrderModule } from '../../redux/modules/index';
import {
  DraperyOrderDesignEmbellishment,
  DraperyOrderFabric,
  EmbellishmentCheckInfo,
  FabricPatternItem,
} from './calculator';
import React, { ChangeEvent, PureComponent } from 'react';

import SelectList from '../UI/select-list';
import { ValidationErrorInfo } from './interfaces-common';
import { WorkOrderPdfContent } from '../../redux/modules/work_order';
import { FormFields } from '../../redux/modules/my-shop/form-fields-reducer';
import SelectInput from '../../ui_components/select/select';
import { getDraperyOrderPrice } from '../../api/drapery-order-price';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../reactDatePicker/ReactDatePicker.css';
import moment from 'moment';
import RedWarning from '../../assets/icons/red_warning.svg';
import { searchWorkroomSetting } from '../../api/workroom-setting';
import { formatSectionTotalPrice } from '../my-shop/helpers';
import { fabrication_type_prices_show } from './helper-functions';
import { WarningModal } from '../../modals/warning_modal';
import TextArea from '../../ui_components/textArea/textArea';
import { Checkbox } from '../ui/checkbox-shadcn';
import CheckmarkIcon from '../../assets/icons/checkmark.svg';
import OrderFeesSection from './order-fees-section';
import {
  hasExplicitSalesDescriptionSettings,
  resolveEstimateDescriptionLines,
} from '../../utils/estimate-description';
import { getAccount } from '../../api/account';
import { AccountDescriptionSettings } from '../../utils/description-settings';
import { ExternalLink } from 'lucide-react';
import { getReadOnlyEstimateSummary } from './estimate-summary-readonly';
import Notebook from '../notebook/Notebook';

const paidList = ['Not Created', 'Paid', 'Partial', 'Not Paid'];
const property = ['W:', 'VR:', 'HR:'];

const statusList = ['Not Created', 'Created', 'Exported to QB', 'Sent to Customer'];

const getNumericSihValue = (value: any): number => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

const getItemSihAmount = (item: any, yardage?: any): number => {
  const shippingCost = getNumericSihValue(item?.shippingCost);
  const sihCostType = (item?.sihCostType || '').toString().toLowerCase();

  if (sihCostType === 'cost-per-yard') {
    return shippingCost * getNumericSihValue(yardage);
  }

  if (sihCostType === 'cost-per-fabric') {
    return shippingCost;
  }

  const handlingFeeValue = getNumericSihValue(item?.handlingFeeValue);
  const cost = getNumericSihValue(item?.cost);

  switch (item?.handlingFeeMethod) {
    case 'markUpShippingCost':
      return shippingCost + (shippingCost * handlingFeeValue) / 100;
    case 'markUpProductCost':
      return shippingCost + (getNumericSihValue(yardage) * cost * handlingFeeValue) / 100;
    case 'rate':
      return shippingCost + handlingFeeValue;
    default:
      return shippingCost + handlingFeeValue;
  }
};

const getAdjustedSihAmount = (item: any, yardage: any, adjustmentPercent: number): string =>
  (getItemSihAmount(item, yardage) * (1 + adjustmentPercent / 100)).toFixed(2);

const WorkorderMeasure = styled.div`
  display: flex !important;
  justify-content: center !important;
  gap: 5px !important;
  font-size: 1rem !important;
  &.last-separator:last-of-type p span {
    display: none !important;
  }
`;

const WorkorderMeasureWrapper = styled.div`
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 5px !important;
`;

const SummaryComponentItemInfo = styled.p`
  font-size: 14px !important;
  margin-bottom: 2px !important;
  color: #6b6b6b !important;
`;

const DraftCheckBox = styled.div`
  display: flex !important;
  align-items: center !important;
  // accent-color: #fff !important;
  input[type='checkbox'] {
    margin-right: 5px !important;
    color: #438cac !important;
    border: 2px solid #3b97b1 !important;
    height: 15px !important;
    width: 15px !important;
    background-color: transparent !important;
    -webkit-appearance: none !important;
  }
  input[type='checkbox']:before {
    content: '' !important;
    display: block !important;
    transition: transform 200ms !important;
  }

  input[type='checkbox']:checked:before {
    width: 9px !important;
    height: 20px !important;
    margin: -10px 5px !important;
    border-bottom: 3px solid #28586f !important;
    border-right: 3px solid #28586f !important;
    transform: rotate(45deg) !important;
  }
  span {
    color: #000 !important;
    font-size: 14px !important;
    font-weight: 400 !important;
  }
`;
const Draft = styled.span`
  color: #e74f77 !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  font-style: italic !important;
`;
// const WOContainer = styled.div`
//     display: flex;
//     align-items: center;
// `;
const WorkOrderLink = styled.div`
  display: flex !important;
  gap: 7px !important;
`;
const TitleNotes = styled.h3`
  text-align: start !important;
  font-family: 'Poppins', Arial, Helvetica, sans-serif !important;
  font-weight: 400 !important;
  color: rgb(84, 84, 84) !important;
  font-size: 15px !important;
  margin-bottom: 5px !important;
`;
const Select = styled(SelectInput)`
  .select-root__select {
    border-radius: 5px !important;
    padding: 2px 30px 2px 2px !important;
    white-space: pre-line !important;
  }
`;
export const defaultDraperyOrderSummary = (): DraperyModule.DraperyOrderSummary => ({
  id: 0,
  planningJson: {
    isDesign: false,
    isFabrics: false,
    isMeasurements: false,
    isHardware: false,
  },
  estimateJson: {
    num: '',
    description: '',
    dateSent: '',
    status: '',
  },
  invoiceJson: {
    num: '',
    description: '',
    paid: '',
  },
  componentsJson: {
    ordered: '',
    received: '',
  },
  productionJson: {},
  installationJson: {},
  notes: '',
  totalPerUnit: null,
  headrailPerUnit: null,
});

export const defaultHeadRailSummaryComponent = (item: string) => {
  return {
    id: 0,
    item,
    draperyOrderSummaryId: 0,
    isDeleted: false,
  };
};

export const defaultHardwareSummaryComponent = (item: string) => {
  return {
    id: 0,
    item,
    draperyOrderFabricId: null,
    isStaticHardware: true,
    draperyOrderSummaryId: 0,
    isDeleted: false,
  };
};

export const defaultHeadRail = () => {
  return {
    id: 0,
    draperyOrderId: 0,
    name: 'HEADRAIL',
    draperyOrderSummaryComponent: defaultHeadRailSummaryComponent('HEADRAIL'),
  };
};

export const defaultHardware = () => {
  return {
    id: 0,
    draperyOrderId: 0,
    name: 'HARDWARE',
    isStaticHardware: true,
    draperyOrderSummaryComponent: defaultHardwareSummaryComponent('HARDWARE'),
  };
};
export const duplicateHeadRail = (fabric: any) => {
  return {
    ...fabric,
    id: 0,
    draperyOrderId: 0,
    draperyOrderSummaryComponent: defaultHeadRailSummaryComponent(
      fabric.draperyOrderSummaryComponent.item
    ),
  };
};
export const filterHeadRail = (
  headRail: DraperyModule.DraperyOrderFabric & { supplierName?: string } & {
    customSupplier?: string;
  },
  component: DraperyModule.DraperyOrderSummaryComponent
): any => ({
  id: headRail.id,
  draperyOrderId: headRail.draperyOrderId,
  name: 'HEADRAIL',
  draperyOrderSummaryComponent: component,
});

// validate
export const validateDraperyOrderSummary = (
  draperyOrderSummary: DraperyModule.DraperyOrderSummary
): ValidationErrorInfo[] => {
  // const prefixName = "draperyOrderSummary.";
  // const tabIndex = 2;
  const errors: ValidationErrorInfo[] = [];
  // if (draperyOrderSummary.invoiceJson.description === undefined) { errors.push({tabIndex, name: prefixName + "invoiceJson.description", message: "Please select invoice description"}); }
  return errors;
};

export const validateDraperyOrderSummaryComponent = (
  draperyOrderSummaryComponent: DraperyModule.DraperyOrderSummaryComponent,
  prefixName: string,
  isFabric?: boolean
): ValidationErrorInfo[] => {
  const tabIndex = 3;
  const errors: ValidationErrorInfo[] = [];
  // if (draperyOrderSummaryComponent.draperyOrderFabricId === 0 && isFabric) {
  //     errors.push({
  //         tabIndex: 2,
  //         name: "",
  //         message: "Please save fabric first",
  //     });
  // }
  if (!draperyOrderSummaryComponent.item) {
    errors.push({
      tabIndex,
      name: prefixName + 'item',
      message: 'Please input component item',
    });
  }
  return errors;
};

export const validateRomanShadeItemPricingTab = (
  draperyItemDetail: FormFields[],
  newRomanShade?: any,
  draperyOrderId?: any
): ValidationErrorInfo[] => {
  let errors: ValidationErrorInfo[] = [];
  const romanShadeItems = draperyItemDetail.filter((item) => item.name === 'Roman Shade');
  const pricingKeys = [
    'clientPricingValue',
    'pleatTypesWithPricing',
    'liningAndInterliningWithPricing',
    'valanceAndReturns',
    'embellishmentsWithPricing',
  ];
  const isCreateMode = draperyOrderId === 0 || draperyOrderId === null ? true : false;

  let errorAdded = false;

  if (romanShadeItems && romanShadeItems.length > 0) {
    for (const key of pricingKeys) {
      if (key === 'clientPricingValue' && !romanShadeItems[0]?.isClientPricingActionOn) {
        continue;
      }
      const value = romanShadeItems[0][key];

      if (!value || (typeof value === 'string' && value.trim() === '')) {
        if (!errorAdded && (newRomanShade || isCreateMode)) {
          errors.push({
            tabIndex: 3,
            name: ['romanShadeItemPricing'],
            message:
              'Pricing for Roman Shades must be set up before a Roman Shade Order can be completed.',
            itemId: romanShadeItems[0].itemId,
            itemClassId: romanShadeItems[0].itemClassId,
          });
          errorAdded = true;
        }
        break;
      }
      if (key === 'embellishmentsWithPricing') {
        if (Array.isArray(value)) {
          for (let i = 0; i < value.length; i++) {
            if (
              value[i] &&
              value[i].group &&
              value[i].group.name !== 'Trim from fabric' &&
              value[i].group.items &&
              value[i].group.items.length > 0
            ) {
              for (let j = 0; j < value[i].group.items.length; j++) {
                if (value[i].group.items[j] && value[i].group.items[j].price === '') {
                  if (!errorAdded && (newRomanShade || isCreateMode)) {
                    errors.push({
                      tabIndex: 3,
                      name: ['romanShadeItemPricing'],
                      message:
                        'Pricing for Roman Shades must be set up before a Roman Shade Order can be completed.',
                      itemId: romanShadeItems[0].itemId,
                      itemClassId: romanShadeItems[0].itemClassId,
                    });
                    errorAdded = true;
                  }
                }
              }
            }
          }
        }
      }
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          if (value[i].price === '') {
            if (!errorAdded && (newRomanShade || isCreateMode)) {
              errors.push({
                tabIndex: 3,
                name: ['romanShadeItemPricing'],
                message:
                  'Pricing for Roman Shades must be set up before a Roman Shade Order can be completed.',
                itemId: romanShadeItems[0].itemId,
                itemClassId: romanShadeItems[0].itemClassId,
              });
              errorAdded = true;
            }
            break;
          }
        }
      }

      if (errorAdded) {
        break;
      }
    }
  }
  return errors;
};

export const validateRipplefoldPricing = (
  draperyItemDetail: FormFields[]
): ValidationErrorInfo[] => {
  let errors: ValidationErrorInfo[] = [];
  const draperyItems = draperyItemDetail.filter((item) => item.name === 'Drapery');
  const draperyItemDetailsKeys = ['pleatTypesWithPricing'];

  if (draperyItems.length > 0) {
    for (const key of draperyItemDetailsKeys) {
      const value = draperyItems[0][key];

      if (Array.isArray(value)) {
        const ripplefoldItem = value?.find((item) => item.id === 'ripplefold' && item.price === '');
        if (ripplefoldItem) {
          errors.push({
            tabIndex: 3,
            name: ['draperyItemPricing'],
            message: 'Pricing for Ripplefold header required in My Shop > Drapery Item.',
            itemId: ripplefoldItem.id,
            itemClassId: ripplefoldItem.itemClassId || null,
          });
          break;
        }
      }
    }
  }

  return errors;
};

const getEmbellishmentComps = ({ list }: { list: DraperyOrderDesignEmbellishment[] }) => {
  const result: DraperyModule.DraperyOrderSummaryComponent[] = [];
  if (!list || !list.length) {
    return result;
  }
  list.forEach((item) => {
    const itemDOFabric = item.draperyOrderFabric;
    if (itemDOFabric) {
      result.push(itemDOFabric.draperyOrderSummaryComponent);
    }
  });
  return result;
};

type GetComponentListParams = {
  bandings: DraperyOrderDesignEmbellishment[];
  cordings: DraperyOrderDesignEmbellishment[];
  flanges: DraperyOrderDesignEmbellishment[];
  trims: DraperyOrderDesignEmbellishment[];
  othersEmbellishments: DraperyOrderDesignEmbellishment[];
  mainFabric: DraperyOrderFabric;
  embellishmentsList: EmbellishmentCheckInfo[];
  draperyOrderSummaryComponents: DraperyModule.DraperyOrderSummaryComponent[];
};

export const getComponentList = (compListParams: GetComponentListParams) => {
  const {
    bandings,
    cordings,
    flanges,
    trims,
    othersEmbellishments,
    mainFabric,
    embellishmentsList,
    draperyOrderSummaryComponents,
  } = compListParams;
  const componentList: DraperyModule.DraperyOrderSummaryComponent[] = [];
  componentList.push(mainFabric.draperyOrderSummaryComponent);

  const [embell0Checked, embell1Checked, embell2Checked, embell3Checked, embell4Checked] =
    embellishmentsList.map((item) => item.checked);

  if (embell0Checked) {
    componentList.push(...getEmbellishmentComps({ list: bandings }));
  }
  if (embell1Checked) {
    componentList.push(...getEmbellishmentComps({ list: cordings }));
  }
  if (embell2Checked) {
    componentList.push(...getEmbellishmentComps({ list: flanges }));
  }
  if (embell3Checked) {
    componentList.push(...getEmbellishmentComps({ list: trims }));
  }
  if (embell4Checked) {
    componentList.push(...getEmbellishmentComps({ list: othersEmbellishments }));
  }

  for (const component of draperyOrderSummaryComponents) {
    componentList.push(component);
  }
  return componentList;
};

// duplicate
export const duplicateDraperyOrderSummaryComponent = (
  component: DraperyModule.DraperyOrderSummaryComponent
): DraperyModule.DraperyOrderSummaryComponent => {
  return {
    ...component,
    id: 0,
    draperyOrderSummaryId: 0,
    draperyOrderFabricId: undefined,
  };
};

interface Props {
  draperyOrderId: number;
  draperyOrderSummary: DraperyModule.DraperyOrderSummary;
  draperyOrderHeadrail?: DraperyModule.DraperyOrderHeadrail;
  isLoadingCreateButton?: boolean;

  bandings: DraperyOrderDesignEmbellishment[];
  cordings: DraperyOrderDesignEmbellishment[];
  flanges: DraperyOrderDesignEmbellishment[];
  trims: DraperyOrderDesignEmbellishment[];
  othersEmbellishments: DraperyOrderDesignEmbellishment[];
  mainFabric: DraperyOrderFabric;
  embellishmentsList: EmbellishmentCheckInfo[];
  draperyOrderSummaryComponents: DraperyModule.DraperyOrderSummaryComponent[];
  draperyOrderFees: DraperyModule.DraperyOrderFee[];
  draperyOrder: DraperyModule.DraperyOrder;
  draperyOrderEditable: boolean;
  workOrder: WorkOrderModule.WorkOrder;
  draperyOrderErrors?: string[];
  draperyOrderSummaryErrors?: string[];
  workOrderStatus: 'none' | 'downloading' | 'error';
  highlightedSection: string | null | undefined;
  data?: any;
  draperyItemDetail?: any;

  handleDuplicate(): void;
  handleEditWorkOrder(): Promise<void>;
  handleDownloadWorkOrderPdf(
    open: boolean,
    options?: { refreshOrder?: boolean; saveBeforeLoad?: boolean; updatePricing?: boolean }
  ): Promise<void>;
  handleAddSummaryComponent(): void;
  handleDeleteSummaryComponent(id: number): void;
  // handleDownloadWorkOrderForSummery(): Promise<void>;
  handleInputChangeForNumber(e: ChangeEvent<HTMLInputElement>): void;
  handleInputChangeForString(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void;
  handleInputChangeForBoolean(e: ChangeEvent<HTMLInputElement>): void;
  handleSelectListChange(value: string | number, name?: string): void;
  dispatch(arg: any): any;
  accountId: number;
  workOrderPdfContentSummery?: WorkOrderPdfContent;
  updateStateByName(name: string, value: string): void;
  draperyOrderPriceId: number;
  draperyOrderPriceRefreshKey?: number;
  handleChangeDates(value: Date | null, field: string): void;
  returnDates(): any;
  editNavigate(tab: number): void;
  updateWorkOrder(val?: string): Promise<void>;
  workOrderEditMode: boolean;
  loadingUpdate: boolean;
  isLoading?: boolean;
  onLoadingChange?(loading: boolean): void;
  handleCreateOtherItemOrder(openPdf: boolean, yardage?: any): Promise<void>;
  headRail: any;
  setYardage(e: ChangeEvent<HTMLInputElement>): void;
  yardage: any;
  hardware: any;
  isConnected?: boolean;
  handleDraperyOrderFeesChange?(fees: DraperyModule.DraperyOrderFee[]): void;
  handleDraperyOrderFeesBundleChange?(fees: DraperyModule.DraperyOrderFee[]): void;
  accountUser?: any;
  canAccessTeamSettings?: boolean;
}

// interface LiningObject {
//     name: string;
//     draperyOrderLiningsFabric?: {
//         values: {
//             fabricWidth: number;
//         };
//     };
//     active: boolean;
// }

// tslint:disable-next-line:no-empty-interface

interface Price {
  basePrice: string;
  liningPrice: string;
  interliningPrice: string;
  bandingPrice: string;
  cordingPrePrice: string;
  cordingFabricPrice: string;
  flangePrePrice: string;
  flangeFabricPrice: string;
  trimPrePrice: string;
  trimFabricPrice: string;
  otherPrice: string;
  draperyPinningPrice: string;
  weightPrice: string;
  extraLongPrice: string;
  extraWidePrice: string;
  cafeCurtainPrice: string;
  calculatedSpecialityPrice: string;
  calculatedSpecialityLiningPrice: string;
  calculatedSpecialityInterliningPrice: string;
  calculatedSpecialityBandingPrice: string;
  calculatedSpecialityCordingPreMadePrice: string;
  calculatedSpecialityCordingFabricPrice: string;
  calculatedSpecialityFlangePreMadePrice: string;
  calculatedSpecialityFlangeFabricPrice: string;
  calculatedSpecialityTrimPreMadePrice: string;
  calculatedSpecialityTrimFabricPrice: string;
  calculatedSpecialityOtherPrice: string;
  totalFabricLiningPrice: string;
  totalFabricInterliningPrice: string;
  mainFabricUnitPrice: string;
  bandingUnitPrice: any;
  cordingUnitPrice: any;
  flangeUnitPrice: any;
  trimUnitPrice: any;
  liningsFabricUnitPrice: string;
  interliningsFabricUnitPrice: string;
  othersEmbellishmentsUnitPrice: any;
  mainFabricShippingPrice: string;
  bandingShippingPrice: any;
  cordingShippingPrice: any;
  trimShippingPrice: any;
  flangeShippingPrice: any;
  liningsFabricShippingPrice: string;
  interliningsFabricShippingPrice: string;
  othersEmbellishmentsShippingPrice: any;
  frontValance: any;
  backValance: any;
  sideFlaps: any;
  id?: any;
  additionalPriceAdjustment?: string;
}

interface State {
  pattern: number;
  isRecommendationsOverrides: boolean;
  calcPrice: number;
  hasValuesOnHardwareTab: boolean;
  workroomSettings: any[];
  prices: Price;
  textAreaHeight: string;
  isWarningModalOpen: boolean;
  isFirstBundleToolTipOpen: boolean;
  isSecondBundleToolTipOpen: boolean;
  additionalPriceAdjustmentType: string;
  bundledFeesTotal: number;
  accountDescriptionSettings: AccountDescriptionSettings | null;
  initialSummaryDataLoaded: boolean;
}
const defaultPrices = (): Price => ({
  basePrice: '0.00',
  liningPrice: '0.00',
  interliningPrice: '0.00',
  bandingPrice: '0.00',
  cordingPrePrice: '0.00',
  cordingFabricPrice: '0.00',
  flangePrePrice: '0.00',
  flangeFabricPrice: '0.00',
  trimPrePrice: '0.00',
  trimFabricPrice: '0.00',
  otherPrice: '0.00',
  draperyPinningPrice: '0.00',
  weightPrice: '0.00',
  extraLongPrice: '0.00',
  extraWidePrice: '0.00',
  cafeCurtainPrice: '0.00',
  calculatedSpecialityPrice: '0.00',
  calculatedSpecialityLiningPrice: '0.00',
  calculatedSpecialityInterliningPrice: '0.00',
  calculatedSpecialityBandingPrice: '0.00',
  calculatedSpecialityCordingPreMadePrice: '0.00',
  calculatedSpecialityCordingFabricPrice: '0.00',
  calculatedSpecialityFlangePreMadePrice: '0.00',
  calculatedSpecialityFlangeFabricPrice: '0.00',
  calculatedSpecialityTrimPreMadePrice: '0.00',
  calculatedSpecialityTrimFabricPrice: '0.00',
  calculatedSpecialityOtherPrice: '0.00',
  totalFabricLiningPrice: '0.00',
  totalFabricInterliningPrice: '0.00',
  mainFabricUnitPrice: '0.00',
  bandingUnitPrice: [],
  cordingUnitPrice: [],
  flangeUnitPrice: [],
  trimUnitPrice: [],
  liningsFabricUnitPrice: '0.00',
  interliningsFabricUnitPrice: '0.00',
  othersEmbellishmentsUnitPrice: [],
  mainFabricShippingPrice: '0.00',
  bandingShippingPrice: [],
  cordingShippingPrice: [],
  trimShippingPrice: [],
  flangeShippingPrice: [],
  liningsFabricShippingPrice: '0.00',
  interliningsFabricShippingPrice: '0.00',
  othersEmbellishmentsShippingPrice: [],
  frontValance: '0.00',
  backValance: '0.00',
  sideFlaps: '0.00',
  additionalPriceAdjustment: '0.00',
});

export const EstimateLink = styled.a`
  font-weight: 400;
  color: #2d778c;
  &:hover {
    color: #2d778c;
  }
`;

export const EstimateSettingsLink = styled(EstimateLink)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #2f8fb0;
  text-decoration: none;
  &:hover {
    color: #267990;
  }
`;

const ReadOnlyEstimateValue = styled.div`
  min-height: 31px;
  display: flex;
  align-items: center;
  color: #222222;
  font-size: 14px;
  line-height: 1.4;
  padding: 0 8px;
`;

class RomanShadeSummaryTab extends PureComponent<Props, State> {
  private tooltipTriggerRef = React.createRef<HTMLButtonElement>();
  private tooltipContentRef = React.createRef<HTMLDivElement>();
  private secondTooltipTriggerRef = React.createRef<HTMLButtonElement>();
  private secondTooltipContentRef = React.createRef<HTMLDivElement>();
  private lastRequestedDraperyOrderPriceKey?: string;

  public constructor(props: Props) {
    super(props);
    this.state = {
      isRecommendationsOverrides: false,
      isWarningModalOpen: false,
      pattern: 0,
      calcPrice: 0,
      hasValuesOnHardwareTab: false,
      workroomSettings: [],
      prices: defaultPrices(),
      additionalPriceAdjustmentType: 'none',
      textAreaHeight: '39.42px',
      isFirstBundleToolTipOpen: false,
      isSecondBundleToolTipOpen: false,
      bundledFeesTotal: 0,
      accountDescriptionSettings: null,
      initialSummaryDataLoaded: false,
    };
  }

  async componentDidMount(): Promise<void> {
    const { accountId } = this.props;
    this.props.onLoadingChange?.(true);

    try {
      try {
        const res = await searchWorkroomSetting(accountId);
        if (res && res.length > 0) {
          const workroomSettings = res;
          this.setState({ workroomSettings });
        } else {
          console.error('There is no information about the settings.');
        }
      } catch (error) {
        console.error('Error executing the dispatch function:', error);
      }

      try {
        const ownerAccountId = Number(localStorage.getItem('ownerAccountId') || '0');
        const descriptionSettingsAccountId = ownerAccountId > 0 ? ownerAccountId : accountId;
        const accountRes = await getAccount(descriptionSettingsAccountId);

        if (accountRes && !accountRes.error) {
          this.setState({
            accountDescriptionSettings: {
              orderingDescription: accountRes.orderingDescription || [],
              salesDescriptionCom: accountRes.salesDescriptionCom || [],
              salesDescriptionWorkroom: accountRes.salesDescriptionWorkroom || [],
            },
          });
        }
      } catch (error) {
        console.error('Error loading account description settings:', error);
      }

      await this.loadDraperyOrderPrice();

      if (
        this.props.draperyOrderId &&
        this.props.workOrderStatus === 'none' &&
        !this.props.data?.workOrderPdfContentSummery
      ) {
        await this.props.handleDownloadWorkOrderPdf(false, {
          refreshOrder: false,
          saveBeforeLoad: false,
          updatePricing: false,
        });
      }
    } finally {
      this.setState({ initialSummaryDataLoaded: true });
      this.props.onLoadingChange?.(false);
    }
  }

  private async loadDraperyOrderPrice(props: Readonly<Props> = this.props): Promise<void> {
    const { draperyOrderPriceId } = props;
    if (!draperyOrderPriceId) {
      return;
    }

    const priceKey = `${draperyOrderPriceId}:${props.draperyOrderPriceRefreshKey || 0}`;
    if (this.lastRequestedDraperyOrderPriceKey === priceKey) {
      return;
    }

    this.lastRequestedDraperyOrderPriceKey = priceKey;

    try {
      const response = await getDraperyOrderPrice(draperyOrderPriceId);
      if (
        this.props.draperyOrderPriceId !== draperyOrderPriceId ||
        (this.props.draperyOrderPriceRefreshKey || 0) !== (props.draperyOrderPriceRefreshKey || 0)
      ) {
        return;
      }

      let { additionalPriceAdjustmentType, ...rest } = response;
      this.setState({
        additionalPriceAdjustmentType: additionalPriceAdjustmentType || 'none',
        prices: {
          ...rest,
          bandingUnitPrice: rest.bandingUnitPrice || [],
          cordingUnitPrice: rest.cordingUnitPrice || [],
          flangeUnitPrice: rest.flangeUnitPrice || [],
          trimUnitPrice: rest.trimUnitPrice || [],
          othersEmbellishmentsUnitPrice: rest.othersEmbellishmentsUnitPrice || [],
          bandingShippingPrice: rest.bandingShippingPrice || [],
          cordingShippingPrice: rest.cordingShippingPrice || [],
          trimShippingPrice: rest.trimShippingPrice || [],
          flangeShippingPrice: rest.flangeShippingPrice || [],
          othersEmbellishmentsShippingPrice: rest.othersEmbellishmentsShippingPrice || [],
        },
      });
    } catch (error) {
      console.error('Error executing the dispatch function:', error);
    }
  }

  private async loadDraperyOrderPriceWithLoading(props: Readonly<Props> = this.props) {
    this.props.onLoadingChange?.(true);

    try {
      await this.loadDraperyOrderPrice(props);
    } finally {
      this.props.onLoadingChange?.(false);
    }
  }

  async componentDidUpdate(
    prevProps: Readonly<Props>,
    prevState: Readonly<State>,
    snapshot?: any
  ): Promise<void> {
    if (
      prevProps.draperyOrderPriceId !== this.props.draperyOrderPriceId ||
      prevProps.draperyOrderPriceRefreshKey !== this.props.draperyOrderPriceRefreshKey
    ) {
      void this.loadDraperyOrderPriceWithLoading();
    }

    const isAnyBundleTooltipOpen =
      this.state.isFirstBundleToolTipOpen || this.state.isSecondBundleToolTipOpen;
    const wasAnyBundleTooltipOpen =
      prevState.isFirstBundleToolTipOpen || prevState.isSecondBundleToolTipOpen;

    if (isAnyBundleTooltipOpen && !wasAnyBundleTooltipOpen) {
      document.addEventListener('mousedown', this.handleBundleTooltipPointerDown);
      document.addEventListener('touchstart', this.handleBundleTooltipPointerDown);
    } else if (!isAnyBundleTooltipOpen && wasAnyBundleTooltipOpen) {
      document.removeEventListener('mousedown', this.handleBundleTooltipPointerDown);
      document.removeEventListener('touchstart', this.handleBundleTooltipPointerDown);
    }

    if (!this.props.draperyOrder.newRomanShade) {
      function hasValues(obj: any) {
        const checkItems = (items: any) =>
          items?.some(
            (item: any) =>
              item.finish.trim() !== '' ||
              item.quantity.trim() !== '' ||
              item.description.trim() !== ''
          );

        let checkRods, checkOtherItems;
        if (obj && obj.rods) {
          checkRods = checkItems(obj.rods);
        }
        if (obj && obj.otherItems) {
          checkOtherItems = checkItems(obj.otherItems);
        }

        if (checkRods || checkOtherItems) {
          return true;
        } else {
          return false;
        }
      }

      const hasValuesOnHardwareTab = hasValues(this.props.draperyOrderHardware);

      this.setState((state) => ({
        ...state,
        hasValuesOnHardwareTab,
      }));
    }
  }

  componentWillUnmount(): void {
    document.removeEventListener('mousedown', this.handleBundleTooltipPointerDown);
    document.removeEventListener('touchstart', this.handleBundleTooltipPointerDown);
  }

  private handleBundleTooltipPointerDown = (event: MouseEvent | TouchEvent): void => {
    const target = event.target as Node | null;

    if (
      (this.tooltipTriggerRef.current && this.tooltipTriggerRef.current.contains(target)) ||
      (this.tooltipContentRef.current && this.tooltipContentRef.current.contains(target)) ||
      (this.secondTooltipTriggerRef.current &&
        this.secondTooltipTriggerRef.current.contains(target)) ||
      (this.secondTooltipContentRef.current &&
        this.secondTooltipContentRef.current.contains(target))
    ) {
      return;
    }

    this.handleBundleTooltipClose();
  };

  private handleBundleTooltipOpen = (tooltip: 'first' | 'second'): void => {
    if (tooltip === 'first') {
      this.setState({
        isFirstBundleToolTipOpen: true,
        isSecondBundleToolTipOpen: false,
      });
    } else {
      this.setState({
        isFirstBundleToolTipOpen: false,
        isSecondBundleToolTipOpen: true,
      });
    }
  };

  private handleBundleTooltipClose = (): void => {
    if (this.state.isFirstBundleToolTipOpen || this.state.isSecondBundleToolTipOpen) {
      this.setState({
        isFirstBundleToolTipOpen: false,
        isSecondBundleToolTipOpen: false,
      });
    }
  };

  private handleBundledFeesTotalChange = (bundledFeesTotal: number): void => {
    if (this.state.bundledFeesTotal !== bundledFeesTotal) {
      this.setState({ bundledFeesTotal });
    }
  };

  private handleDeleteHeadrailComponent = (): void => {
    this.props.updateStateByName('headRail.draperyOrderSummaryComponent.isDeleted', true);
  };

  private getPricingSectionPrice = (item: FabricPatternItem) => {
    const client = this.props.data.client;
    const headrailInfo = this.props.draperyOrderHeadrail;
    if (client) {
      const billingDetails = client.billToParent
        ? client.billingDetails
        : client.billingDetailsDirectly;

      // additional adjustment type
      const additionalPriceAdjustment_raw = client?.billToParent
        ? billingDetails?.additionalPriceAdjustment
        : billingDetails?.additionalPriceAdjustment;

      const additionalPriceAdjustment =
        headrailInfo?.headrailAdditionalPriceAdjustmentType ||
        additionalPriceAdjustment_raw ||
        'none';
      // additional adjustment value
      const additionalPriceAdjustmentValue_raw = client?.billToParent
        ? billingDetails?.additionalPriceAdjustmentValue
        : billingDetails?.additionalPriceAdjustmentValue;

      const additionalPriceAdjustmentValue =
        headrailInfo?.headrailAdditionalPriceAdjustment || additionalPriceAdjustmentValue_raw;

      const additionalPercentage = (Number(additionalPriceAdjustmentValue) || 0) / 100;
      const additionalPercentageWithSymbol =
        additionalPriceAdjustment === 'discount' ? -additionalPercentage : additionalPercentage;
      const pricingSection = billingDetails?.billingType;
      if (!pricingSection) {
        return 'TBD';
      }
      const pricingSectionLower = pricingSection.toLowerCase();

      const pricingMethodTextKey = `${pricingSectionLower}PricingMethod`;
      const pricingMethodValueKey = `${pricingSectionLower}PricingValue`;

      // Initialize empty or default values
      let pricingMethodText = null;
      let pricingMethodValue = null;
      let msrp = null;
      let cost = null;

      // Conditionally assign values if 'item' is defined
      if (item) {
        pricingMethodText = item[pricingMethodTextKey];
        pricingMethodValue = item[pricingMethodValueKey];
        msrp = item.msrp;
        cost = item.cost;
      }

      if (['discountMsrpRetail', 'discountMsrpTrade'].includes(pricingMethodText)) {
        if (msrp && pricingMethodValue) {
          msrp = +msrp;
          pricingMethodValue = +pricingMethodValue;
          const discountedVal = (pricingMethodValue / 100) * msrp;
          const total = msrp - discountedVal;
          const percentage = 1 + additionalPercentageWithSymbol;
          return formatSectionTotalPrice(total * percentage).replace('$', '');
        } else {
          return 'TBD';
        }
      }

      if (['markUpCostRetail', 'markUpCostTrade'].includes(pricingMethodText)) {
        if (cost && pricingMethodValue) {
          cost = +cost;
          pricingMethodValue = +pricingMethodValue;
          const markUpVal = (pricingMethodValue / 100) * cost;
          const total = markUpVal + cost;
          const percentage = 1 + additionalPercentageWithSymbol;
          return formatSectionTotalPrice(total * percentage).replace('$', '');
        } else {
          return 'TBD';
        }
      }

      if (['costPlusRetail', 'costPlusTrade'].includes(pricingMethodText)) {
        if (cost && pricingMethodValue) {
          cost = +cost;
          pricingMethodValue = +pricingMethodValue;
          const total = cost + pricingMethodValue;
          const percentage = 1 + additionalPercentageWithSymbol;
          return formatSectionTotalPrice(total * percentage).replace('$', '');
        } else {
          return 'TBD';
        }
      }

      pricingMethodValue *= 1 + additionalPercentageWithSymbol;

      return pricingMethodValue ? (Number(pricingMethodValue) || 0).toFixed(2) : '';
    }
  };

  public render() {
    const {
      draperyOrderSummary,
      workOrder,
      mainFabric,
      bandings,
      cordings,
      flanges,
      trims,
      othersEmbellishments,
      embellishmentsList,
      draperyOrderSummaryComponents,
      workOrderEditMode,
      loadingUpdate,
      headRail,
      handleBundleConfigSettings,
      draperyOrderHeadrail,
      // hardware,
    } = this.props;

    // Client billing details based on bill to parent
    const client = this.props.data.client;
    const clientBillingInfo = client?.billToParent
      ? client?.billingDetails
      : client?.billingDetailsDirectly;
    const feeClientPriceAdjustmentType = clientBillingInfo?.additionalPriceAdjustment || 'none';
    const feeClientPriceAdjustmentValue =
      Number(clientBillingInfo?.additionalPriceAdjustmentValue) || 0;
    // Client additional price adjustment (none, markup, discount)
    const additionalPriceAdjustment =
      draperyOrderHeadrail?.headrailAdditionalPriceAdjustmentType ||
      clientBillingInfo?.additionalPriceAdjustment;
    // Client additional price adjustment value (negative if "discount")
    const additionalPriceAdjustmentValue = draperyOrderHeadrail?.headrailAdditionalPriceAdjustment
      ? Number(draperyOrderHeadrail?.headrailAdditionalPriceAdjustment)
      : Number(clientBillingInfo?.additionalPriceAdjustmentValue) || 0;
    const additionalPriceAdjustmentCalculate =
      additionalPriceAdjustment === 'discount'
        ? -additionalPriceAdjustmentValue
        : additionalPriceAdjustmentValue;

    const romanShadeItemDetailsSource =
      (Array.isArray(this.props.data?.romanShadeItemDetails) &&
        this.props.data?.romanShadeItemDetails?.[0]) ||
      this.props.data?.romanShadeItemDetails;

    const bundleDefaults = this.props?.draperyOrder?.bundleConfigJson ??
      romanShadeItemDetailsSource?.bundleSelections ?? {
        mainFabric: false,
        embellishments: false,
        linings: false,
        headrail: false,
        hardware: false,
        fees: false,
        shippingAndHandling: false,
      };

    const mainFabricBundleSelected = Boolean(bundleDefaults?.mainFabric);
    const embellishmentBundleSelected = Boolean(bundleDefaults?.embellishments);
    const liningBundleSelected = Boolean(bundleDefaults?.linings);
    const headrailBundleSelected = Boolean(bundleDefaults?.headrail);
    const hardwareBundleSelected = Boolean(bundleDefaults?.hardware);
    const feesBundleDefaultSelected = Boolean(bundleDefaults?.fees);
    const shippingAndHandlingBundleSelected = Boolean(bundleDefaults?.shippingAndHandling);
    const showBundleColumn = Boolean(romanShadeItemDetailsSource?.isBundlingSelected);
    const showBundledFabricationQuantity =
      showBundleColumn &&
      this.props.draperyOrder.quantity !== undefined &&
      this.props.draperyOrder.quantity !== null &&
      `${this.props.draperyOrder.quantity}`.trim() !== '';
    const headrailSupplier = draperyOrderHeadrail?.supplier || '';
    const headrailEstimateDescription = (draperyOrderHeadrail?.estimateDescription || '').trim();
    const headrailQuantity = Number(draperyOrderHeadrail?.quantity || 0) || null;
    const headrailUnitCost = Number(draperyOrderHeadrail?.cost || 0) || 0;
    const headrailMarkup = Number(draperyOrderHeadrail?.markup || 0) || 0;
    const headrailCustomerRaw = draperyOrderHeadrail?.customerFacingPrice;
    const headrailCalculated =
      headrailQuantity && headrailUnitCost
        ? headrailQuantity *
          headrailUnitCost *
          (1 + (headrailMarkup + additionalPriceAdjustmentCalculate) / 100)
        : null;
    const headrailCustomerPrice =
      headrailCustomerRaw === undefined ||
      headrailCustomerRaw === null ||
      headrailCustomerRaw === ''
        ? null
        : Number(headrailCustomerRaw);
    const headrailEffectiveCustomerPrice =
      headrailCustomerPrice !== null && !Number.isNaN(headrailCustomerPrice)
        ? headrailCustomerPrice
        : headrailCalculated;
    const headrailUnitCustomer =
      headrailQuantity && headrailEffectiveCustomerPrice !== null
        ? headrailEffectiveCustomerPrice / headrailQuantity
        : null;
    const headrailPurchaserIsCom = draperyOrderHeadrail?.purchaser === 2;
    const headrailPurchaserIsWorkroom = draperyOrderHeadrail?.purchaser === 1;
    const headrailReceiverIsWorkroom = draperyOrderHeadrail?.receiver === 1;
    const headrailAllowedReceiver =
      !!draperyOrderHeadrail && (headrailPurchaserIsWorkroom || headrailReceiverIsWorkroom);
    const headrailSih = draperyOrderHeadrail?.headrailSih || {};
    const headrailShippingActive = !!headrailSih?.active;
    const headrailSihCost = Number(headrailSih.cost || 0) || 0;
    const headrailSihMarkup = Number(headrailSih.markup || 0) || 0;
    const headrailSihCustomer =
      headrailSih.customerFacingPrice !== undefined &&
      headrailSih.customerFacingPrice !== null &&
      headrailSih.customerFacingPrice !== ''
        ? Number(headrailSih.customerFacingPrice)
        : null;
    const headrailShippingCalculated = headrailSihCost
      ? headrailSihCost * (1 + headrailSihMarkup / 100)
      : null;
    const headrailShippingPrice = headrailShippingActive
      ? headrailSihCustomer !== null && !Number.isNaN(headrailSihCustomer)
        ? headrailSihCustomer
        : headrailShippingCalculated
      : null;
    const headrailHasPrice =
      headrailEffectiveCustomerPrice !== null &&
      !Number.isNaN(headrailEffectiveCustomerPrice) &&
      headrailEffectiveCustomerPrice > 0;
    const headrailHasDescription = headrailEstimateDescription.length > 0;
    const headrailComponentDeleted = !!headRail?.draperyOrderSummaryComponent?.isDeleted;
    const headrailShouldDisplay =
      (headrailHasPrice || headrailHasDescription) &&
      draperyOrderHeadrail.purchaser !== 0 &&
      draperyOrderHeadrail.purchaser !== 3 &&
      draperyOrderHeadrail.purchaser !== undefined &&
      draperyOrderHeadrail.purchaser !== null;
    const headrailComponentShouldDisplay = headrailAllowedReceiver && !headrailComponentDeleted;
    const headrailShippingShouldDisplay = headrailShouldDisplay && headrailShippingActive;
    const headrailTotal = (headrailEffectiveCustomerPrice || 0) + (headrailShippingPrice || 0);
    const headrailTotalShouldDisplay =
      headrailEffectiveCustomerPrice !== null || headrailShippingPrice !== null;
    const headrailUnitDisplay =
      headrailUnitCustomer !== null && !Number.isNaN(headrailUnitCustomer)
        ? Number(headrailUnitCustomer).toFixed(2)
        : '0.00';
    const headrailTotalDisplay = headrailTotalShouldDisplay
      ? headrailTotal.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : '0.00';

    const datesForPicker = this.props.returnDates();

    const componentList = getComponentList({
      bandings,
      cordings,
      flanges,
      trims,
      othersEmbellishments,
      mainFabric,
      embellishmentsList,
      draperyOrderSummaryComponents,
    });

    const readOnlyEstimateSummary = getReadOnlyEstimateSummary({
      draperyOrder: this.props.draperyOrder,
      draperyOrderSummary,
    });
    const legacyEstimateStatusSet = new Set(statusList);
    const rawEstimateNumber = draperyOrderSummary.estimateJson.num || '';
    const estimateStatusValue =
      draperyOrderSummary.estimateJson.num ||
      (legacyEstimateStatusSet.has(rawEstimateNumber) ? rawEstimateNumber : '');
    const estimateAssociations = this.props.draperyOrder?.estimateStatusSummary?.estimates || [];
    const hasQuipaEstimateConnection =
      !!(this.props.draperyOrder as any)?.estimateId ||
      !!(this.props.draperyOrder as any)?.quipaEstimateId ||
      estimateAssociations?.some((estimate: any) => estimate?.estimateId && !estimate?.legacy);
    const estimateNumberInputDisabled =
      this.props.draperyOrder.archived || hasQuipaEstimateConnection;
    // const estimateNumberDisplayValue = legacyEstimateStatusSet.has(rawEstimateNumber)
    //   ? ''
    //   : rawEstimateNumber;
    // const disableEstimateNumberField =
    //   this.props.draperyOrder.archived ||
    //   !!this.props.draperyOrder.qbEstimateId ||
    //   !!this.props.isConnected;

    let componentChecked = true;
    for (const component of componentList) {
      if (!component.receivedDate) {
        componentChecked = false;
        break;
      }
    }

    // let editCreate = 'Create';

    // if (workOrder.id) {
    //   editCreate = 'Edit';
    // }

    // const { yardage } = this.props;

    // const cancelBtn = (
    //   <CancelBtn
    //     uiColor="primary"
    //     type="button"
    //     onClick={() => this.props.handleCreateOtherItemOrder(false, yardage)}
    //     className="create-btn"
    //     disabled={this.props.isLoading || this.props.isLoadingCreateButton}
    //     uiDisabled={this.props.isLoading || this.props.isLoadingCreateButton}
    //   >
    //     {editCreate}
    //   </CancelBtn>
    // );

    let quantity: number =
      this.props.data &&
      this.props.data.workOrderPdfContent &&
      this.props.data.workOrderPdfContent.quantity;

    let shippingCostLining: number = 0;
    let costLining: number = 0;
    let shippingCostInterlining: number = 0;
    let costInterlining: number = 0;
    let liningYards: number = 0;
    let interliningYards: number = 0;
    let totalFabricLining: number = 0;
    let totalFabricInterlining: number = 0;
  
    if (this.props.data && this.props.data.liningsList) {
      this.props.data.liningsList?.forEach((item: any) => {
        if (item.active && item.name === 'Lining') {
          shippingCostLining =
            (item.draperyOrderLiningsFabric && item.draperyOrderLiningsFabric.amount) || 0;
          costLining =
            (item.draperyOrderLiningsFabric && item.draperyOrderLiningsFabric.calcPrice) || 0;
          if (this.props.data && this.props.data.workOrderPdfContentSummery) {
            liningYards = this.props.data.workOrderPdfContentSummery.liningYDS || 0;
          } else {
            liningYards = 0;
          }
          totalFabricLining = liningYards * costLining + shippingCostLining;
        } else if (item.active && item.name === 'Interlining') {
          shippingCostInterlining =
            (item.draperyOrderLiningsFabric && item.draperyOrderLiningsFabric.amount) || 0;
          costInterlining =
            (item.draperyOrderLiningsFabric && item.draperyOrderLiningsFabric.calcPrice) || 0;
          if (this.props.data && this.props.data.workOrderPdfContentSummery) {
            interliningYards = this.props.data.workOrderPdfContentSummery.interliningYDS || 0;
          } else {
            interliningYards = 0;
          }
          totalFabricInterlining =
            quantity * interliningYards * costInterlining + shippingCostInterlining;
        }
      });
    }

    const calculateTotal = () => {
      const {
        basePrice,
        liningPrice,
        interliningPrice,
        trimPrePrice,
        otherPrice,
        extraLongPrice,
        extraWidePrice,
        frontValance,
        backValance,
        sideFlaps,
        calculatedSpecialityPrice,
        calculatedSpecialityLiningPrice,
        calculatedSpecialityInterliningPrice,
        calculatedSpecialityTrimPreMadePrice,
        calculatedSpecialityOtherPrice,
        additionalPriceAdjustment,
      } = this.state.prices;

      let total = 0;

      total += parseFloat(basePrice);

      total += parseFloat(liningPrice);

      total += parseFloat(interliningPrice);

      total += parseFloat(trimPrePrice);

      total += parseFloat(calculatedSpecialityPrice);

      total += parseFloat(calculatedSpecialityLiningPrice);

      total += parseFloat(calculatedSpecialityInterliningPrice);

      total += parseFloat(calculatedSpecialityTrimPreMadePrice);

      total += parseFloat(calculatedSpecialityOtherPrice);

      // total += parseFloat(draperyPinningPrice);

      // const weightPriceParsed =
      //   weightPrice !== null ? weightPrice : "0.00";
      // total += parseFloat(weightPriceParsed);

      total += parseFloat(otherPrice);

      total += parseFloat(extraLongPrice);

      total += parseFloat(extraWidePrice);

      total += parseFloat(frontValance);

      total += parseFloat(backValance);

      total += parseFloat(sideFlaps);

      total += parseFloat(additionalPriceAdjustment || '0');

      const liningsList = this.props.data.liningsList;
      let liningYardageNeeded: number = 0;

      if (liningsList) {
        const liningsFabric = liningsList?.find((item: any) => item.name === 'Lining');
        if (
          liningsFabric &&
          liningsFabric.draperyOrderLiningsFabric &&
          liningsFabric.name === 'Lining'
        ) {
          liningYardageNeeded = liningsFabric.draperyOrderLiningsFabric.yardsNeeded || 0;
        }
      }

      const liningUnitPrice = parseFloat(this.state.prices.liningsFabricUnitPrice);
      const liningSHPrice = parseFloat(this.state.prices.liningsFabricShippingPrice);

      totalFabricLining =
        isNaN(liningYardageNeeded) || isNaN(liningUnitPrice) || isNaN(liningSHPrice) || !quantity
          ? 0
          : (liningYardageNeeded * liningUnitPrice + liningSHPrice) / quantity;

      let interliningYardageNeeded: number = 0;

      if (liningsList) {
        const interliningsFabric = liningsList?.find((item: any) => item.name === 'Interlining');
        if (
          interliningsFabric &&
          interliningsFabric.draperyOrderLiningsFabric &&
          interliningsFabric.name === 'Interlining'
        ) {
          interliningYardageNeeded = interliningsFabric.draperyOrderLiningsFabric.yardsNeeded || 0;
        }
      }
      const interliningUnitPrice = parseFloat(this.state.prices.interliningsFabricUnitPrice);
      const interliningSHPrice = parseFloat(this.state.prices.interliningsFabricShippingPrice);

      totalFabricInterlining =
        isNaN(interliningYardageNeeded) ||
        isNaN(interliningUnitPrice) ||
        isNaN(interliningSHPrice) ||
        !quantity
          ? 0
          : (interliningYardageNeeded * interliningUnitPrice + interliningSHPrice) / quantity;

      return total.toFixed(2);
    };

    let liningMaterialYardage: number | undefined;
    let interliningMaterialYardage: number | undefined;

    let totalPerUnit: number | undefined;
    const totalPriceQuantity = parseFloat(calculateTotal());
    totalPerUnit = totalPriceQuantity;

    //WORK ORDER DESCRIPTION

    const draperyItemDetail = this.props.data.romanShadeItemDetails;
    let salesDescriptionSettingsMapped: any[] = [];

    if (draperyItemDetail && draperyItemDetail.length > 0) {
      const firstDraperyItem = draperyItemDetail[0];

      if (firstDraperyItem.salesDescriptionSettings) {
        salesDescriptionSettingsMapped = firstDraperyItem.salesDescriptionSettings;
      }
    }

    const liningsList: any[] = Array.isArray(this.props.data && this.props.data.liningsList)
      ? this.props.data.liningsList
      : [];

    const isSettingEnabled = (id: string) =>
      salesDescriptionSettingsMapped?.some(
        (item: { id: string; isEnabled: boolean }) => item.id === id && item.isEnabled
      );
    const isAnySettingEnabled = (ids: string[]) => ids?.some((id) => isSettingEnabled(id));
    const isSquareFeetEnabled = isAnySettingEnabled(['salessquarefootage', 'salessqaurefeet']);

    const isLiningNoEnabled = isSettingEnabled('saleslining:no');
    const isLiningYesEnabled = isSettingEnabled('saleslining:yes');
    const isShowLiningNameEnabled = isSettingEnabled('salesshowliningname');
    const isLiningPurchaserIfComEnabled = isSettingEnabled('salesliningpurchaserifcom');
    const isLiningYardsIfComEnabled = isSettingEnabled('salesliningyardsifcom');
    const isLiningYardsIfWorkroomEnabled = isSettingEnabled('salesliningyardsifworkroompurchasing');
    const isInterliningNoEnabled = isSettingEnabled('salesinterlining:no');
    const isInterliningYesEnabled = isSettingEnabled('salesinterlining:yes');
    const isShowInterliningNameEnabled = isSettingEnabled('salesshowinterliningname');
    const isInterliningPurchaserIfComEnabled = isSettingEnabled('salesinterliningpurchaserifcom');
    const isInterliningYardsIfComEnabled = isSettingEnabled('salesinterliningyardsifcom');
    const isInterliningYardsIfWorkroomEnabled = isSettingEnabled(
      'salesinterliningyardsifworkroompurchasing'
    );

    const liningItem = liningsList?.find((l: any) => l.name === 'Lining' && l.active);
    const liningOrderOrigin =
      liningItem && liningItem.draperyOrderLiningsFabric
        ? liningItem.draperyOrderLiningsFabric.orderOrigin
        : undefined;
    const liningItemName =
      liningItem && liningItem.draperyOrderLiningsFabric
        ? liningItem.draperyOrderLiningsFabric.pattern
        : undefined;
    const liningYardsNeeded =
      liningItem && liningItem.draperyOrderLiningsFabric
        ? liningItem.draperyOrderLiningsFabric.yardsNeeded
        : undefined;

    const interliningItem = liningsList?.find((l: any) => l.name === 'Interlining' && l.active);
    const interliningOrderOrigin =
      interliningItem && interliningItem.draperyOrderLiningsFabric
        ? interliningItem.draperyOrderLiningsFabric.orderOrigin
        : undefined;
    const interliningItemName =
      interliningItem && interliningItem.draperyOrderLiningsFabric
        ? interliningItem.draperyOrderLiningsFabric.pattern
        : undefined;
    const interliningYardsNeeded =
      interliningItem && interliningItem.draperyOrderLiningsFabric
        ? interliningItem.draperyOrderLiningsFabric.yardsNeeded
        : undefined;

    const hasLiningItem = Boolean(liningItem);
    const hasInterliningItem = Boolean(interliningItem);

    const shouldShowLiningSection =
      isLiningNoEnabled ||
      isLiningYesEnabled ||
      isShowLiningNameEnabled ||
      isLiningPurchaserIfComEnabled ||
      isLiningYardsIfComEnabled ||
      isLiningYardsIfWorkroomEnabled;

    const shouldShowInterliningSection =
      isInterliningNoEnabled ||
      isInterliningYesEnabled ||
      isShowInterliningNameEnabled ||
      isInterliningPurchaserIfComEnabled ||
      isInterliningYardsIfComEnabled ||
      isInterliningYardsIfWorkroomEnabled;

    const shouldShowLiningYes = hasLiningItem && isLiningYesEnabled;
    const shouldShowLiningName =
      hasLiningItem && isShowLiningNameEnabled && Boolean(liningItemName);
    const shouldShowLiningCom =
      hasLiningItem && liningOrderOrigin === 2 && isLiningPurchaserIfComEnabled;
    const shouldShowLiningYardsFromCom =
      hasLiningItem &&
      liningOrderOrigin === 2 &&
      isLiningYardsIfComEnabled &&
      Boolean(liningYardsNeeded);
    const shouldShowLiningYardsFromWorkroom =
      hasLiningItem &&
      liningOrderOrigin === 1 &&
      isLiningYardsIfWorkroomEnabled &&
      Boolean(liningYardsNeeded);
    const shouldShowLiningYards = shouldShowLiningYardsFromCom || shouldShowLiningYardsFromWorkroom;

    const liningDetailParts: string[] = [];
    if (hasLiningItem) {
      if (shouldShowLiningYes) {
        liningDetailParts.push('Yes');
      }
      if (shouldShowLiningName && liningItemName) {
        liningDetailParts.push(liningItemName);
      }
      if (shouldShowLiningYards) {
        liningDetailParts.push(`${liningYardsNeeded} yards`);
      }
    } else if (isLiningNoEnabled) {
      liningDetailParts.push('No');
    }

    const shouldRenderLining =
      shouldShowLiningSection &&
      ((hasLiningItem && (liningDetailParts.length > 0 || shouldShowLiningCom)) ||
        (!hasLiningItem && liningDetailParts.length > 0));

    const shouldShowInterliningYes = hasInterliningItem && isInterliningYesEnabled;
    const shouldShowInterliningName =
      hasInterliningItem && isShowInterliningNameEnabled && Boolean(interliningItemName);
    const shouldShowInterliningCom =
      hasInterliningItem && interliningOrderOrigin === 2 && isInterliningPurchaserIfComEnabled;
    const shouldShowInterliningYardsFromCom =
      hasInterliningItem &&
      interliningOrderOrigin === 2 &&
      isInterliningYardsIfComEnabled &&
      Boolean(interliningYardsNeeded);
    const shouldShowInterliningYardsFromWorkroom =
      hasInterliningItem &&
      interliningOrderOrigin === 1 &&
      isInterliningYardsIfWorkroomEnabled &&
      Boolean(interliningYardsNeeded);
    const shouldShowInterliningYards =
      shouldShowInterliningYardsFromCom || shouldShowInterliningYardsFromWorkroom;

    const interliningDetailParts: string[] = [];
    if (hasInterliningItem) {
      if (shouldShowInterliningYes) {
        interliningDetailParts.push('Yes');
      }
      if (shouldShowInterliningName && interliningItemName) {
        interliningDetailParts.push(interliningItemName);
      }
      if (shouldShowInterliningYards) {
        interliningDetailParts.push(`${interliningYardsNeeded} yards`);
      }
    } else if (isInterliningNoEnabled) {
      interliningDetailParts.push('No');
    }

    const shouldRenderInterlining =
      shouldShowInterliningSection &&
      ((hasInterliningItem && (interliningDetailParts.length > 0 || shouldShowInterliningCom)) ||
        (!hasInterliningItem && interliningDetailParts.length > 0));

    // BASE PRICE TOTAL
    let calculatedBasePrice: string = this.state.prices.basePrice;

    const formattedPrice = calculatedBasePrice;

    const basePriceElement = document.querySelector('.basePrice');
    if (basePriceElement) {
      basePriceElement.textContent = `${formattedPrice} Base`;
    }
    // LINING AND INTERLINING PRICE
    const liningActive = this.props.data.liningsList;

    let calculatedLiningPrice: string = this.state.prices.liningPrice;
    let calculatedInterliningPrice: string = this.state.prices.interliningPrice;

    const formattedLiningPrice = calculatedLiningPrice;
    const formattedInterliningPrice = calculatedInterliningPrice;

    const liningPriceElement = document.querySelector('.liningPrice');
    const interliningPriceElement = document.querySelector('.interliningPrice');

    const liningMaterialPriceElement = document.querySelector('.liningMaterialPrice');
    const interliningMaterialPriceElement = document.querySelector('.interliningMaterialPrice');
    if (liningMaterialPriceElement) {
      liningMaterialPriceElement.textContent = '';
    }
    if (interliningMaterialPriceElement) {
      interliningMaterialPriceElement.textContent = '';
    }

    if (Array.isArray(liningActive)) {
      const lining = liningActive?.find((item) => item.name === 'Lining' && item.active === true);

      if (lining) {
        if (liningPriceElement) {
          liningPriceElement.textContent = `${formattedLiningPrice} Lining Fabrication`;
        }
      } else {
        if (liningPriceElement) {
          liningPriceElement.textContent = '';
        }
      }
    }

    if (Array.isArray(liningActive)) {
      const interlining = liningActive?.find(
        (item) => item.name === 'Interlining' && item.active === true
      );

      if (interlining) {
        if (interliningPriceElement) {
          interliningPriceElement.textContent = `${formattedInterliningPrice} Interlining Fabrication`;
        }
      } else {
        if (interliningPriceElement) {
          interliningPriceElement.textContent = '';
        }
      }
    }

    // EMBELLISHMENT PRICE
    const activeEmbellishmet = this.props.data.embellishmentsList;
    // BANDINGS PRICE
    let calculatedBandingPrice: string = this.state.prices.bandingPrice;
    const bandingPriceElement = document.querySelector('.bandingPrice');

    if (Array.isArray(activeEmbellishmet)) {
      const activeBanding = activeEmbellishmet?.find(
        (item) => item.title === 'Banding' && item.checked === true
      );

      if (activeBanding) {
        if (bandingPriceElement) {
          bandingPriceElement.textContent = calculatedBandingPrice + ' Banding';
        }
      }
    }

    // CORDING PRE MADE PRICE
    let calculatedCordingPrePrice: string = this.state.prices.cordingPrePrice;
    const cordingPriceElement = document.querySelector('.cordingPrice');

    if (Array.isArray(activeEmbellishmet)) {
      const activeCording = activeEmbellishmet?.find(
        (item) => item.title === 'Cording' && item.checked === true
      );
      if (activeCording) {
        const activeCordingPreMade = this.props.data.cordings?.find(
          (cording: { subType: number }) => cording.subType === 0
        );
        if (activeCordingPreMade) {
          if (cordingPriceElement) {
            cordingPriceElement.textContent = calculatedCordingPrePrice + ' Cording pre-made';
          }
        }
      }
    }

    // CORDING FROM FABRIC
    let calculatedCordingFabricPrice: string = this.state.prices.cordingFabricPrice;

    const cordingFabricPriceElement = document.querySelector('.cordingFabricPrice');
    if (Array.isArray(activeEmbellishmet)) {
      const activeCording = activeEmbellishmet?.find(
        (item) => item.title === 'Cording' && item.checked === true
      );
      if (activeCording) {
        const activeCordingFabric = this.props.data.cordings?.find(
          (cording: { subType: number }) => cording.subType === 1
        );
        if (activeCordingFabric) {
          if (cordingFabricPriceElement) {
            cordingFabricPriceElement.textContent =
              calculatedCordingFabricPrice + ' Cording from fabric';
          }
        }
      }
    }

    // FLANGE PRE MADE PRICE
    let calculatedFlangePrePrice: string = this.state.prices.flangePrePrice;

    const flangePriceElement = document.querySelector('.flangePrice');

    if (Array.isArray(activeEmbellishmet)) {
      const activeFlange = activeEmbellishmet?.find(
        (item) => item.title === 'Flange' && item.checked === true
      );
      if (activeFlange) {
        const activeFlangePreMade = this.props.data.flanges?.find(
          (flange: { subType: number }) => flange.subType === 0
        );
        if (activeFlangePreMade) {
          if (flangePriceElement) {
            flangePriceElement.textContent = calculatedFlangePrePrice + ' Flange pre-made';
          }
        }
      }
    }

    // FLANGE FABRIC PRICE
    let calculatedFlangeFabricPrice: string = this.state.prices.flangeFabricPrice;

    const flangeFabricPriceElement = document.querySelector('.flangeFabricPrice');

    if (Array.isArray(activeEmbellishmet)) {
      const activeFlange = activeEmbellishmet?.find(
        (item) => item.title === 'Flange' && item.checked === true
      );
      if (activeFlange) {
        const activeFlangeFabric = this.props.data.flanges?.find(
          (flange: { subType: number }) => flange.subType === 1
        );
        if (activeFlangeFabric) {
          if (flangeFabricPriceElement) {
            flangeFabricPriceElement.textContent =
              calculatedFlangeFabricPrice + ' Flange from fabric';
          }
        }
      }
    }

    // TRIMS PRE MADE PRICE
    let calculatedTrimPrePrice: string = this.state.prices.trimPrePrice;

    const trimPriceElement = document.querySelector('.trimPrice');

    if (Array.isArray(activeEmbellishmet)) {
      const activeTrim = activeEmbellishmet?.find(
        (item) => item.title === 'Trim' && item.checked === true
      );
      if (activeTrim) {
        const activeTrimPreMade = this.props.data.trims?.find(
          (trim: { subType: number }) => trim.subType === 0
        );
        if (activeTrimPreMade) {
          if (trimPriceElement) {
            trimPriceElement.textContent = calculatedTrimPrePrice + ' Trim pre-made';
          }
        }
      }
    }

    // TRIMS FABRIC PRICE
    let calculatedTrimFabricPrice: string = this.state.prices.trimFabricPrice;

    const trimFabricPriceElement = document.querySelector('.trimFabricPrice');

    if (Array.isArray(activeEmbellishmet)) {
      const activeTrim = activeEmbellishmet?.find(
        (item) => item.title === 'Trim' && item.checked === true
      );
      if (activeTrim) {
        const activeTrimFabric = this.props.data.trims?.find(
          (trim: { subType: number }) => trim.subType === 1
        );
        if (activeTrimFabric) {
          if (trimFabricPriceElement) {
            trimFabricPriceElement.textContent = calculatedTrimFabricPrice + ' Trim from fabric';
          }
        }
      }
    }

    //OTHER EMBELLISHMENTS
    let calculatedOtherPrice: string = this.state.prices.otherPrice;

    const formatedOtherPrice = calculatedOtherPrice;

    const othersEmbelishmentsPrice = document.querySelector('.othersEmbelishmentsPrice');

    if (Array.isArray(activeEmbellishmet)) {
      const activeOther = activeEmbellishmet?.find(
        (item) => item.stateName === 'othersEmbellishments' && item.checked === true
      );
      if (activeOther) {
        if (othersEmbelishmentsPrice) {
          othersEmbelishmentsPrice.textContent = `${formatedOtherPrice} Other embellishments`;
        }
      }
    }
    //DRAPERY PINING

    let draperyPininngTotal: string = this.state.prices.draperyPinningPrice;
    const draperyActive =
      this.props.data &&
      this.props.data.draperyOrderDesign &&
      this.props.data.draperyOrderDesign.isPinSet;

    const pinningPriceElement = document.querySelector('.pinningPrice');

    if (draperyActive) {
      if (pinningPriceElement) {
        pinningPriceElement.textContent = draperyPininngTotal + ' Drapery pinning';
      }
    }
    //WEIGHT

    let weightTotal: string = this.state.prices.weightPrice;
    const weightActive =
      this.props.data &&
      this.props.data.draperyOrderDesign &&
      this.props.data.draperyOrderDesign.isWeight;

    const weightPriceElement = document.querySelector('.weightPrice');

    if (weightActive) {
      let weightDescription = '';
      if (this.props.data.draperyOrderDesign.weightRadio === 'standard-corner') {
        weightDescription = 'Weight: Standard Corner';
      } else if (this.props.data.draperyOrderDesign.weightRadio === 'beaded-chain') {
        weightDescription = 'Weight: Beaded Chain';
      }

      if (weightPriceElement) {
        weightPriceElement.textContent = `${weightTotal} ${weightDescription}`;
      }
    }
    // EXTRA LONG PANELS
    let extraLongDeduction: string = this.state.prices.extraLongPrice;

    const extraLongElement = document.querySelector('.extraLongPrice');
    if (parseFloat(extraLongDeduction) > 0) {
      if (extraLongElement) {
        extraLongElement.textContent = extraLongDeduction + ' Extra Long Panels';
      }
    } else {
      if (extraLongElement) {
        extraLongElement.textContent = '';
      }
    }

    // EXTRA WIDE PANELS
    let extraWideTotal: string = this.state.prices.extraWidePrice;

    let extraWideElement = document.querySelector('.extraWidePrice');

    if (parseFloat(extraWideTotal) > 0) {
      if (extraWideElement) {
        extraWideElement.textContent = extraWideTotal + ' Extra Wide Panels';
      }
    } else {
      if (extraWideElement) {
        extraWideElement.textContent = '';
      }
    }

    // CAFE CURTAIN DISCOUNT
    let cafeCurtainDeduction: string = this.state.prices.cafeCurtainPrice;

    const cafePriceElement = document.querySelector('.cafePrice');
    if (parseFloat(cafeCurtainDeduction) < 0) {
      if (cafePriceElement) {
        cafePriceElement.textContent = cafeCurtainDeduction + ' Café Curtain Discount';
      }
    } else {
      if (cafePriceElement) {
        cafePriceElement.textContent = '';
      }
    }

    // SPECIALTY BASE PRICE

    let calculatedSpeciality: any = this.state.prices.calculatedSpecialityPrice;

    if (typeof calculatedSpeciality === 'number' && !isNaN(calculatedSpeciality)) {
      calculatedSpeciality = calculatedSpeciality.toFixed(2);
    }

    const specialityBasePriceElement = document.querySelector('.specialityPrice');

    if (specialityBasePriceElement) {
      specialityBasePriceElement.innerHTML =
        parseFloat(calculatedSpeciality) > 0
          ? calculatedSpeciality + ' Specialty Fabrics Surcharge'
          : '';
    }

    // SPECIALTY LINING PRICE
    let calculatedSpecialityLining: string = this.state.prices.calculatedSpecialityLiningPrice;

    const specialityLiningPriceElement = document.querySelector('.specialityPriceLining');

    if (specialityLiningPriceElement) {
      if (parseFloat(calculatedSpecialityLining) !== 0) {
        specialityLiningPriceElement.textContent = calculatedSpecialityLining + ' Specialty Lining';
      } else {
        specialityLiningPriceElement.textContent = '';
      }
    }

    // SPECIALTY INTERLINING PRICE
    let calculatedSpecialityInterlining: string =
      this.state.prices.calculatedSpecialityInterliningPrice;

    const specialityInterliningPriceElement = document.querySelector('.specialityPriceInterlining');

    if (specialityInterliningPriceElement) {
      if (parseFloat(calculatedSpecialityInterlining) !== 0) {
        specialityInterliningPriceElement.textContent =
          calculatedSpecialityInterlining + ' Specialty Interlining';
      } else {
        specialityInterliningPriceElement.textContent = '';
      }
    }

    // SPECIALTY BANDINGS PRICE
    let calculatedSpecialityBanding: string = this.state.prices.calculatedSpecialityBandingPrice;

    const specialityBandingPriceElement = document.querySelector('.specialityPriceBanding');

    if (specialityBandingPriceElement) {
      if (calculatedSpecialityBanding && parseFloat(calculatedSpecialityBanding) !== 0) {
        specialityBandingPriceElement.textContent =
          calculatedSpecialityBanding + ' Specialty Banding';
      } else {
        specialityBandingPriceElement.textContent = '';
      }
    }
    // SPECIALTY CORDING PRE MADE
    let calculatedSpecialityCordingPreMade: string =
      this.state.prices.calculatedSpecialityCordingPreMadePrice;

    const specialityCordingPriceElement = document.querySelector('.specialityPriceCordingPreMade');

    if (specialityCordingPriceElement) {
      if (
        calculatedSpecialityCordingPreMade &&
        parseFloat(calculatedSpecialityCordingPreMade) !== 0
      ) {
        specialityCordingPriceElement.textContent =
          calculatedSpecialityCordingPreMade + ' Specialty Cording pre-made';
      } else {
        specialityCordingPriceElement.textContent = '';
      }
    }
    // SPECIALTY CORDING FROM FABRIC
    let calculatedSpecialityCordingFabric: string =
      this.state.prices.calculatedSpecialityCordingFabricPrice;

    const specialityCordingFabricPriceElement = document.querySelector(
      '.specialityPriceCordingFabric'
    );

    if (specialityCordingFabricPriceElement) {
      if (
        calculatedSpecialityCordingFabric &&
        parseFloat(calculatedSpecialityCordingFabric) !== 0
      ) {
        specialityCordingFabricPriceElement.textContent =
          calculatedSpecialityCordingFabric + ' Specialty Cording from fabric';
      } else {
        specialityCordingFabricPriceElement.textContent = '';
      }
    }

    // SPECIALTY FLANGE PRE MADE
    let calculatedSpecialityFlangePreMade: string =
      this.state.prices.calculatedSpecialityFlangePreMadePrice;

    const specialityFlangePriceElement = document.querySelector('.specialityPriceFlangePreMade');

    if (specialityFlangePriceElement) {
      if (
        calculatedSpecialityFlangePreMade &&
        parseFloat(calculatedSpecialityFlangePreMade) !== 0
      ) {
        specialityFlangePriceElement.textContent =
          calculatedSpecialityFlangePreMade + ' Specialty Flange pre-made';
      } else {
        specialityFlangePriceElement.textContent = '';
      }
    }

    // SPECIALTY FLANGE FROM FABRIC
    let calculatedSpecialityFlangeFabric: string =
      this.state.prices.calculatedSpecialityFlangeFabricPrice;

    const specialityFlangeFabricPriceElement = document.querySelector(
      '.specialityPriceFlangeFabric'
    );

    if (specialityFlangeFabricPriceElement) {
      if (calculatedSpecialityFlangeFabric && parseFloat(calculatedSpecialityFlangeFabric) !== 0) {
        specialityFlangeFabricPriceElement.textContent =
          calculatedSpecialityFlangeFabric + ' Specialty Flange from fabric';
      } else {
        specialityFlangeFabricPriceElement.textContent = '';
      }
    }

    // SPECIALTY TRIM PRE MADE
    let calculatedSpecialityTrimPreMade: string =
      this.state.prices.calculatedSpecialityTrimPreMadePrice;

    const specialityTrimPriceElement = document.querySelector('.specialityPriceTrimPreMade');

    if (specialityTrimPriceElement) {
      if (calculatedSpecialityTrimPreMade && parseFloat(calculatedSpecialityTrimPreMade) !== 0) {
        specialityTrimPriceElement.textContent =
          calculatedSpecialityTrimPreMade + ' Specialty Trim pre-made';
      } else {
        specialityTrimPriceElement.textContent = '';
      }
    }

    // SPECIALTY TRIM FROM FABRIC
    let calculatedSpecialityTrimFabric: string =
      this.state.prices.calculatedSpecialityTrimFabricPrice;

    const specialityTrimFabricPriceElement = document.querySelector('.specialityPriceTrimFabric');

    if (specialityTrimFabricPriceElement) {
      if (calculatedSpecialityTrimFabric && parseFloat(calculatedSpecialityTrimFabric) !== 0) {
        specialityTrimFabricPriceElement.textContent =
          calculatedSpecialityTrimFabric + ' Specialty Trim from fabric';
      } else {
        specialityTrimFabricPriceElement.textContent = '';
      }
    }

    // SPECIALTY OTHER EMBELLISHMENTS
    let calculatedSpecialityOther: string = this.state.prices.calculatedSpecialityOtherPrice;

    const specialityOtherPriceElement = document.querySelector('.specialityPriceOther');
    if (specialityOtherPriceElement) {
      if (calculatedSpecialityOther && parseFloat(calculatedSpecialityOther) !== 0) {
        specialityOtherPriceElement.textContent =
          calculatedSpecialityOther + ' Specialty other embellishments';
      } else {
        specialityOtherPriceElement.textContent = '';
      }
    }

    const formatPleatType = (pleatType: any) => {
      let formattedPleatType = pleatType.replace(/\d{4}$/, '');

      formattedPleatType = formattedPleatType.replace(/_/g, ' ');

      formattedPleatType = formattedPleatType.replace(/\b\w/g, (char: string) =>
        char.toUpperCase()
      );
      return formattedPleatType;
    };

    const changeStatus = (e: ChangeEvent<HTMLSelectElement>): void => {
      this.props.updateStateByName('draperyOrder.status', e.currentTarget.value);
    };

    const handleEnterPressed = (e: React.KeyboardEvent<HTMLTextAreaElement>): void => {
      const key = e.key;
      if (key === 'Enter' || key === 'Return') {
        e.preventDefault();

        const textarea = e.currentTarget;
        const value = textarea.value;
        const selectionStart = textarea.selectionStart;
        const selectionEnd = textarea.selectionEnd;

        const part1 = value.slice(0, selectionStart);
        const part2 = value.slice(selectionEnd);

        const newValue = part1 + '\n' + part2;

        textarea.value = newValue;
        textarea.selectionStart = textarea.selectionEnd = selectionStart + 1;
      }
    };

    const isDraperyOrder: boolean = this.props.data.orderType !== 'roman-shade-order';
    const romanShadeEstimateSettingsHref = '/myshop?item=roman-shade-item&tab=estimate-settings';
    const isCreateMode: boolean = this.props.draperyOrder.id === 0;

    const otherItemTotal: string | number =
      this.props.draperyOrder.quantity != null &&
      draperyOrderSummary.totalPerUnit != null &&
      !isNaN(Number(this.props.draperyOrder.quantity)) &&
      !isNaN(Number(draperyOrderSummary.totalPerUnit)) &&
      Number(this.props.draperyOrder.quantity) >= 0 &&
      Number(draperyOrderSummary.totalPerUnit) >= 0 &&
      !isCreateMode &&
      !workOrderEditMode &&
      this.props.data.workOrder.id > 0
        ? (
            Number(this.props.draperyOrder.quantity) * Number(draperyOrderSummary.totalPerUnit)
          ).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        : 'TBD';

    const { romanShadeJson } = this.props.data.draperyOrderDesign;
    const draperyOrderDesignFunction = {
      0: 'Functional',
      1: 'Faux',
    };
    const draperyOrderDesignStyleWindowMount = {
      0: 'Inside',
      1: 'Outside',
    };
    const draperyOrderDesignStyleBoardMount = {
      0: 'Waterfall',
      1: 'Reverse',
    };
    const draperyOrderDesignValanceAndReturnsSides = {
      'side-flaps': 'Sides Flaps',
      returns: 'Wrapped Returns',
    };

    const mountBoardBackDescriptionParts: string[] = [];

    if (
      romanShadeJson &&
      romanShadeJson.style.windowMount !== -1 &&
      isSettingEnabled('saleswindowmountandboardmount')
    ) {
      mountBoardBackDescriptionParts.push(
        `${draperyOrderDesignStyleWindowMount[romanShadeJson.style.windowMount]} Mount`
      );
    }

    if (
      romanShadeJson &&
      romanShadeJson.style.boardMount !== -1 &&
      isSettingEnabled('saleswindowmountandboardmount')
    ) {
      const boardMountValue = draperyOrderDesignStyleBoardMount[romanShadeJson.style.boardMount];
      if (boardMountValue) {
        mountBoardBackDescriptionParts.push(boardMountValue);
      }
    }

    if (
      romanShadeJson &&
      romanShadeJson.valanceAndReturns &&
      romanShadeJson.valanceAndReturns.backValance === 1 &&
      isSettingEnabled('salesifbackvalanceselected')
    ) {
      mountBoardBackDescriptionParts.push('Back Valance');
    }

    const mountBoardBackDescription = mountBoardBackDescriptionParts.join(' / ');

    const valanceSidesBottomDescriptionParts: string[] = [];

    if (
      romanShadeJson &&
      romanShadeJson.valanceAndReturns &&
      romanShadeJson.valanceAndReturns.frontValance === 1 &&
      isSettingEnabled('salesiffrontvalanceandsidesselected')
    ) {
      valanceSidesBottomDescriptionParts.push('Front Valance');
    }

    const valanceSideKey =
      romanShadeJson && romanShadeJson.valanceAndReturns
        ? romanShadeJson.valanceAndReturns.sides
        : null;

    if (
      valanceSideKey &&
      valanceSideKey !== 'none' &&
      isSettingEnabled('salesiffrontvalanceandsidesselected')
    ) {
      const sideLabel = draperyOrderDesignValanceAndReturnsSides[valanceSideKey];
      if (sideLabel) {
        valanceSidesBottomDescriptionParts.push(sideLabel);
      }
    }

    if (
      romanShadeJson &&
      romanShadeJson.dimensions &&
      romanShadeJson.dimensions.bottomSkirit === 1 &&
      isSettingEnabled('salesifbottomskirtselected')
    ) {
      valanceSidesBottomDescriptionParts.push('Bottom Skirt');
    }

    const valanceSidesBottomDescription = valanceSidesBottomDescriptionParts.join(' / ');

    const forBackValance =
      romanShadeJson &&
      romanShadeJson.valanceAndReturns &&
      romanShadeJson.valanceAndReturns.backValance &&
      romanShadeJson.valanceAndReturns.backValance > 0 &&
      this.props.data.liningsList
        .filter((lin: any) => lin.name === 'Lining')
        .every((lin: any) => !lin.active)
        ? true
        : false;

    let shippingPriceMainFabric: string = '';
    let shippingPriceTrim: any[] = [];
    let shippingOthersEmbellishments: any[] = [];
    let shippingPriceLiningsFabric: string = '';
    let shippingPriceInterliningsFabric: string = '';

    if (this.props.data.fabricsPatternItems && this.props.data.mainFabric) {
      this.props.data.fabricsPatternItems
        .filter((item: any) => item.name === this.props.data.mainFabric.pattern)
        .map((item: any) => {
          shippingPriceMainFabric = getAdjustedSihAmount(
            item,
            this.props.yardage.mainFabricYardage,
            additionalPriceAdjustmentCalculate
          );
        });
    }

    this.props.data.trims &&
      this.props.data.trims
        .filter((item: any) => item.subType === 0)
        .map((item: any, num: number) => {
          const newItem = item.draperyOrderFabric;
          this.props.data &&
            this.props.data.fabricsPatternItems &&
            newItem &&
            newItem.pattern &&
            this.props.data.fabricsPatternItems
              .filter((item: any) => item.name === newItem.pattern)
              .map((item: any) => {
                shippingPriceTrim.push({
                  price: getAdjustedSihAmount(
                    item,
                    this.props.yardage.trimsPreMadeYardage[num],
                    additionalPriceAdjustmentCalculate
                  ),
                  subType: 0,
                });
              });
        });
    this.props.data.trims &&
      this.props.data.trims
        .filter((item: any) => item.subType === 1)
        .map((item: any, num: number) => {
          const newItem = item && item.draperyOrderFabric && item.draperyOrderFabric.pattern;
          this.props.data &&
            this.props.data.fabricsPatternItems &&
            this.props.data.fabricsPatternItems
              .filter((item: any) => item.name === newItem)
              .map((item: any) => {
                shippingPriceTrim.push({
                  price: getAdjustedSihAmount(
                    item,
                    this.props.yardage.trimsFabricYardage[num],
                    additionalPriceAdjustmentCalculate
                  ),
                  subType: 1,
                });
              });
        });
    this.props.data &&
      this.props.data.othersEmbellishments &&
      this.props.data.othersEmbellishments &&
      this.props.data.othersEmbellishments.map((item: any, num: number) => {
        const newItem = item && item.draperyOrderFabric && item.draperyOrderFabric.pattern;
        this.props.data &&
          this.props.data.fabricsPatternItems &&
          this.props.data.fabricsPatternItems
            .filter((item: any) => item.name === newItem)
            .map((item: any) => {
              const amount = getItemSihAmount(
                item,
                this.props.yardage.otherEmbellishmentsYardage[num]
              );
              const arrItem = this.props.data.othersEmbellishments;
              arrItem[num]['amount'] = +amount;

              shippingOthersEmbellishments.push({
                price: (amount * (1 + additionalPriceAdjustmentCalculate / 100)).toFixed(2),
              });
            });
      });

    this.props.data.liningsList.map((item: any, num: number) => {
      const newItem =
        item && item.draperyOrderLiningsFabric && item.draperyOrderLiningsFabric.pattern;
      const tempItem = item;

      if (newItem) {
        this.props.data &&
          this.props.data.liningsPatternItems &&
          this.props.data.liningsPatternItems
            .filter((item: any) => {
              return item.name === newItem;
            })
            .map((item: any) => {
              const shippingPrice = getAdjustedSihAmount(
                item,
                this.props.yardage.liningsYardage[num] || '0',
                additionalPriceAdjustmentCalculate
              );
              if (tempItem.name === 'Lining') {
                shippingPriceLiningsFabric = shippingPrice;
              } else {
                shippingPriceInterliningsFabric = shippingPrice;
              }
            });
      }
    });

    const parseNumber = (value: any) => {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const normalized = typeof value === 'string' ? value.replace(/[$,]/g, '') : value;
      const numericValue = Number(normalized);
      return Number.isFinite(numericValue) ? numericValue : null;
    };

    const resolveYardage = (yardage: any) => {
      if (yardage === null || yardage === undefined || yardage === '') {
        return null;
      }
      const yardageNumber = parseNumber(yardage);
      if (yardageNumber === null) {
        return null;
      }
      return yardage === '0' || yardage === 0 ? 1 : yardageNumber;
    };

    const calcBundledItemTotal = (
      orderOrigin: any,
      unitPrice: any,
      yardage: any,
      shippingPrice: any,
      respectEditMode = false
    ) => {
      if (respectEditMode && workOrderEditMode) {
        return null;
      }
      if (orderOrigin === 2) {
        return 0;
      }
      if (orderOrigin !== 1) {
        return null;
      }
      const yardageValue = resolveYardage(yardage);
      if (yardageValue === null) {
        return null;
      }
      const unitPriceValue = parseNumber(unitPrice);
      if (unitPriceValue === null) {
        return null;
      }
      const shippingValue = shippingAndHandlingBundleSelected
        ? (parseNumber(shippingPrice) ?? 0)
        : 0;
      return unitPriceValue * yardageValue + shippingValue;
    };

    const sumTotals = (values: Array<number | null>) => {
      let total = 0;
      let hasUnknown = false;
      values.forEach((value) => {
        if (value === null) {
          hasUnknown = true;
          return;
        }
        total += value;
      });
      return { total, hasUnknown };
    };

    const getPriceValue = (value: any) => {
      if (value && typeof value === 'object' && value.price !== undefined) {
        return parseNumber(value.price);
      }
      return parseNumber(value);
    };

    const alignPricingByOrderOrigin = (summaryItems: any[] | undefined, priceItems: any[]) => {
      const aligned = Array.isArray(priceItems) ? [...priceItems] : [];
      if (!Array.isArray(summaryItems)) {
        return aligned;
      }

      summaryItems.forEach((summaryItem: any, index: number) => {
        if (summaryItem?.orderOrigin === 2) {
          aligned.splice(index, 0, undefined);
        }
      });

      return aligned;
    };

    const summaryContent = this.props.data?.workOrderPdfContentSummery;
    const bandingUnitPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.bandingFabricContents,
      this.state.prices.bandingUnitPrice || []
    );
    const bandingShippingPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.bandingFabricContents,
      this.state.prices.bandingShippingPrice || []
    );
    const cordingPreUnitPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.premadeCordingFabricContents,
      (this.state.prices.cordingUnitPrice || []).filter((item: any) => item?.subType === 0)
    );
    const cordingPreShippingPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.premadeCordingFabricContents,
      (this.state.prices.cordingShippingPrice || []).filter((item: any) => item?.subType === 0)
    );
    const cordingFabricUnitPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.weltCordingFabricContents,
      (this.state.prices.cordingUnitPrice || []).filter((item: any) => item?.subType === 1)
    );
    const cordingFabricShippingPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.weltCordingFabricContents,
      (this.state.prices.cordingShippingPrice || []).filter((item: any) => item?.subType === 1)
    );
    const flangePreUnitPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.premadeFlangeFabricContents,
      (this.state.prices.flangeUnitPrice || []).filter((item: any) => item?.subType === 0)
    );
    const flangePreShippingPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.premadeFlangeFabricContents,
      (this.state.prices.flangeShippingPrice || []).filter((item: any) => item?.subType === 0)
    );
    const flangeFabricUnitPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.fabricFlangeFabricContents,
      (this.state.prices.flangeUnitPrice || []).filter((item: any) => item?.subType === 1)
    );
    const flangeFabricShippingPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.fabricFlangeFabricContents,
      (this.state.prices.flangeShippingPrice || []).filter((item: any) => item?.subType === 1)
    );
    const trimPreUnitPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.premadeTrimFabricContents,
      (this.state.prices.trimUnitPrice || []).filter((item: any) => item?.subType === 0)
    );
    const trimPreShippingPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.premadeTrimFabricContents,
      (this.state.prices.trimShippingPrice || []).filter((item: any) => item?.subType === 0)
    );
    const trimFabricUnitPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.fabricTrimFabricContents,
      (this.state.prices.trimUnitPrice || []).filter((item: any) => item?.subType === 1)
    );
    const trimFabricShippingPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.fabricTrimFabricContents,
      (this.state.prices.trimShippingPrice || []).filter((item: any) => item?.subType === 1)
    );
    const othersUnitPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.otherFabricContents,
      this.state.prices.othersEmbellishmentsUnitPrice || []
    );
    const othersShippingPriceForBundle = alignPricingByOrderOrigin(
      summaryContent?.otherFabricContents,
      this.state.prices.othersEmbellishmentsShippingPrice || []
    );

    let mainFabricBundleTotal: number | null = null;
    if (this.props.data?.mainFabric) {
      const unitPrice = this.state.prices.mainFabricUnitPrice;
      mainFabricBundleTotal = calcBundledItemTotal(
        this.props.data.mainFabric.orderOrigin,
        unitPrice,
        this.props.yardage.mainFabricYardage,
        this.state.prices.mainFabricShippingPrice,
        true
      );
    }

    const embellishmentTotals: Array<number | null> = [];

    if (this.props.data?.bandings) {
      this.props.data.bandings.forEach((item: any, index: number) => {
        if (!item.draperyOrderFabric) {
          return;
        }
        const unitPrice = getPriceValue(bandingUnitPriceForBundle[index]);
        const shippingPrice = getPriceValue(bandingShippingPriceForBundle[index]) ?? 0;
        embellishmentTotals.push(
          calcBundledItemTotal(
            item.draperyOrderFabric.orderOrigin,
            unitPrice,
            this.props.yardage.bandingsYardage[index],
            shippingPrice
          )
        );
      });
    }

    if (this.props.data?.cordings) {
      this.props.data.cordings
        .filter((item: any) => item.subType === 0)
        .forEach((item: any, index: number) => {
          if (!item.draperyOrderFabric) {
            return;
          }
          const unitPrice = getPriceValue(cordingPreUnitPriceForBundle[index]);
          const shippingPrice = getPriceValue(cordingPreShippingPriceForBundle[index]) ?? 0;
          embellishmentTotals.push(
            calcBundledItemTotal(
              item.draperyOrderFabric.orderOrigin,
              unitPrice,
              this.props.yardage.cordingsPreMadeYardage[index],
              shippingPrice
            )
          );
        });
    }

    if (this.props.data?.flanges) {
      this.props.data.flanges
        .filter((item: any) => item.subType === 0)
        .forEach((item: any, index: number) => {
          if (!item.draperyOrderFabric) {
            return;
          }
          const unitPrice = getPriceValue(flangePreUnitPriceForBundle[index]);
          const shippingPrice = getPriceValue(flangePreShippingPriceForBundle[index]) ?? 0;
          embellishmentTotals.push(
            calcBundledItemTotal(
              item.draperyOrderFabric.orderOrigin,
              unitPrice,
              this.props.yardage.flangesPreMadeYardage[index],
              shippingPrice
            )
          );
        });
    }

    if (this.props.data?.trims) {
      this.props.data.trims
        .filter((item: any) => item.subType === 0)
        .forEach((item: any, index: number) => {
          if (!item.draperyOrderFabric) {
            return;
          }
          const unitPrice = getPriceValue(trimPreUnitPriceForBundle[index]);
          const shippingPrice = getPriceValue(trimPreShippingPriceForBundle[index]) ?? 0;
          embellishmentTotals.push(
            calcBundledItemTotal(
              item.draperyOrderFabric.orderOrigin,
              unitPrice,
              this.props.yardage.trimsPreMadeYardage[index],
              shippingPrice,
              true
            )
          );
        });
    }

    if (this.props.data?.cordings) {
      this.props.data.cordings
        .filter((item: any) => item.subType === 1)
        .forEach((item: any, index: number) => {
          if (!item.draperyOrderFabric) {
            return;
          }
          const unitPrice = getPriceValue(cordingFabricUnitPriceForBundle[index]);
          const shippingPrice = getPriceValue(cordingFabricShippingPriceForBundle[index]) ?? 0;
          embellishmentTotals.push(
            calcBundledItemTotal(
              item.draperyOrderFabric.orderOrigin,
              unitPrice,
              this.props.yardage.cordingsFabricYardage[index],
              shippingPrice
            )
          );
        });
    }

    if (this.props.data?.flanges) {
      this.props.data.flanges
        .filter((item: any) => item.subType === 1)
        .forEach((item: any, index: number) => {
          if (!item.draperyOrderFabric) {
            return;
          }
          const unitPrice = getPriceValue(flangeFabricUnitPriceForBundle[index]);
          const shippingPrice = getPriceValue(flangeFabricShippingPriceForBundle[index]) ?? 0;
          embellishmentTotals.push(
            calcBundledItemTotal(
              item.draperyOrderFabric.orderOrigin,
              unitPrice,
              this.props.yardage.flangesFabricYardage[index],
              shippingPrice
            )
          );
        });
    }

    if (this.props.data?.trims) {
      this.props.data.trims
        .filter((item: any) => item.subType === 1)
        .forEach((item: any, index: number) => {
          if (!item.draperyOrderFabric) {
            return;
          }
          const unitPrice = getPriceValue(trimFabricUnitPriceForBundle[index]);
          const shippingPrice = getPriceValue(trimFabricShippingPriceForBundle[index]) ?? 0;
          embellishmentTotals.push(
            calcBundledItemTotal(
              item.draperyOrderFabric.orderOrigin,
              unitPrice,
              this.props.yardage.trimsFabricYardage[index],
              shippingPrice,
              true
            )
          );
        });
    }

    if (this.props.data?.othersEmbellishments) {
      this.props.data.othersEmbellishments.forEach((item: any, index: number) => {
        if (!item.draperyOrderFabric) {
          return;
        }
        const unitPrice = getPriceValue(othersUnitPriceForBundle[index]);
        const shippingPrice = getPriceValue(othersShippingPriceForBundle[index]) ?? 0;
        embellishmentTotals.push(
          calcBundledItemTotal(
            item.draperyOrderFabric.orderOrigin,
            unitPrice,
            this.props.yardage.otherEmbellishmentsYardage[index],
            shippingPrice
          )
        );
      });
    }

    const { total: embellishmentBundleTotal, hasUnknown: embellishmentHasUnknown } =
      sumTotals(embellishmentTotals);

    const liningTotals: Array<number | null> = [];
    if (this.props.data?.liningsList) {
      this.props.data.liningsList
        .filter((item: any, index: number) => {
          if (index === 0) {
            return item.active || forBackValance;
          }
          return item.active;
        })
        .forEach((item: any, index: number) => {
          if (!item.draperyOrderLiningsFabric) {
            return;
          }
          const unitPrice =
            item.name === 'Lining'
              ? this.state.prices.liningsFabricUnitPrice
              : this.state.prices.interliningsFabricUnitPrice;
          const yardageValue =
            item.name === 'Lining'
              ? this.props.yardage.liningsYardage[0] !== '0'
                ? this.props.yardage.liningsYardage[index]
                : '0'
              : this.props.yardage.liningsYardage[index];
          const shippingPrice =
            item.name === 'Lining'
              ? this.state.prices.liningsFabricShippingPrice
              : this.state.prices.interliningsFabricShippingPrice;
          liningTotals.push(
            calcBundledItemTotal(
              item.draperyOrderLiningsFabric.orderOrigin,
              unitPrice,
              yardageValue,
              shippingPrice,
              true
            )
          );
        });
    }

    const { total: liningBundleTotal, hasUnknown: liningHasUnknown } = sumTotals(liningTotals);

    const headrailBundleTotal = headrailPurchaserIsCom
      ? 0
      : parseNumber(headrailEffectiveCustomerPrice || 0) +
        (shippingAndHandlingBundleSelected ? parseNumber(headrailShippingPrice) || 0 : 0);

    const isAnyBundleSelection =
      mainFabricBundleSelected ||
      embellishmentBundleSelected ||
      liningBundleSelected ||
      headrailBundleSelected ||
      hardwareBundleSelected;

    const fabricationQuantity =
      parseNumber(this.props.draperyOrder?.quantity) ??
      (quantity ? parseNumber(quantity) : null) ??
      1;
    const fabricationPerUnitForBundle = parseNumber(
      isDraperyOrder ? (draperyOrderSummary.totalPerUnit ?? totalPerUnit) : totalPerUnit
    );
    const fabricationTotalForBundle =
      workOrderEditMode && isDraperyOrder
        ? null
        : fabricationPerUnitForBundle === null
          ? null
          : fabricationPerUnitForBundle * fabricationQuantity;

    const normalizeBundleValue = (value: number | null) =>
      typeof value === 'number' && !Number.isNaN(value) ? value : 0;

    const bundleTotalValue = showBundleColumn
      ? normalizeBundleValue(fabricationTotalForBundle) +
        (mainFabricBundleSelected ? normalizeBundleValue(mainFabricBundleTotal) : 0) +
        (embellishmentBundleSelected ? normalizeBundleValue(embellishmentBundleTotal) : 0) +
        (liningBundleSelected ? normalizeBundleValue(liningBundleTotal) : 0) +
        (headrailBundleSelected ? normalizeBundleValue(headrailBundleTotal) : 0) +
        normalizeBundleValue(this.state.bundledFeesTotal)
      : 0;

    const bundleTotalDisplay = showBundleColumn
      ? bundleTotalValue.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : null;

    const bundleTotalLabel = bundleTotalDisplay === null ? null : `$ ${bundleTotalDisplay} TOTAL`;

    const surcharge_total =
      +this.state.prices.calculatedSpecialityPrice +
      +this.state.prices.calculatedSpecialityLiningPrice +
      +this.state.prices.calculatedSpecialityInterliningPrice +
      +this.state.prices.calculatedSpecialityTrimPreMadePrice +
      +this.state.prices.calculatedSpecialityOtherPrice;

    const shade_linings =
      this.props.data && this.props.data.liningsList ? this.props.data.liningsList : [];
    const trims_for_case = this.props.trims ? this.props.trims : [];
    const other_embellishments_for_case = this.props.othersEmbellishments
      ? this.props.othersEmbellishments
      : [];

    const payload_for_helper_fabrication_prices = [
      {
        value: null,
        label: 'Base',
        checkCaseName: 'case_for_base',
        romanShadeJson: romanShadeJson || {},
        arrayValue: [],
      },
      {
        value: null,
        label: 'Lining Fabrication',
        checkCaseName: 'case_for_lining_fabrication',
        romanShadeJson: romanShadeJson || {},
        arrayValue: shade_linings,
      },
      {
        value: null,
        label: 'Interlining Fabrication',
        checkCaseName: 'case_for_interlining_fabrication_and_material',
        romanShadeJson: romanShadeJson || {},
        arrayValue: shade_linings,
      },
      {
        value: this.state.prices.extraLongPrice || 0,
        label: 'Extra Long Shades',
        checkCaseName: 'case_for_extra_long_shades',
        romanShadeJson: romanShadeJson || {},
        arrayValue: [],
      },
      {
        value: this.state.prices.extraWidePrice || 0,
        label: 'Extra Wide Shades',
        checkCaseName: 'case_for_extra_wide_shades',
        romanShadeJson: romanShadeJson || {},
        arrayValue: [],
      },
      {
        value: null,
        label: 'Trim (Pre-made)',
        checkCaseName: 'case_for_trim_pre_made',
        romanShadeJson: romanShadeJson || {},
        arrayValue: trims_for_case,
      },
      {
        value: null,
        label: 'Trim (From Fabric)',
        checkCaseName: 'case_for_trim_from_fabric',
        romanShadeJson: romanShadeJson || {},
        arrayValue: trims_for_case,
      },
      {
        value: null,
        label: 'Other Embellishment',
        checkCaseName: 'case_for_other_embellishments',
        romanShadeJson: romanShadeJson || {},
        arrayValue: other_embellishments_for_case,
      },
      {
        value: null,
        label: 'Front Valance',
        checkCaseName: 'case_for_front_valance',
        romanShadeJson: romanShadeJson || {},
        arrayValue: [],
      },
      {
        value: null,
        label: 'Back Valance',
        checkCaseName: 'case_for_back_valance',
        romanShadeJson: romanShadeJson || {},
        arrayValue: [],
      },
      {
        value: null,
        label: 'Side Flaps',
        checkCaseName: 'case_for_side_flaps',
        romanShadeJson: romanShadeJson || {},
        arrayValue: [],
      },
      {
        value: surcharge_total || 0,
        label: 'Specialty Fabrics Surcharge',
        checkCaseName: 'case_for_specialty_fabrics_surcharge',
        romanShadeJson: romanShadeJson || {},
        arrayValue: [],
      },
    ];

    const {
      case_for_base,
      case_for_lining_fabrication,
      case_for_interlining_fabrication_and_material,
      case_for_extra_long_shades,
      case_for_extra_wide_shades,
      case_for_trim_pre_made,
      case_for_trim_from_fabric,
      case_for_other_embellishments,
      case_for_front_valance,
      case_for_back_valance,
      case_for_side_flaps,
      case_for_specialty_fabrics_surcharge,
    } = fabrication_type_prices_show(payload_for_helper_fabrication_prices);

    const fabrication_prices_per_unit: any = [
      { value: +this.state.prices.basePrice || 0, showCase: case_for_base, label: 'Base' },
      {
        value: +this.state.prices.liningPrice || 0,
        showCase: case_for_lining_fabrication,
        label: 'Lining Fabrication',
      },
      {
        value: +this.state.prices.interliningPrice || 0,
        showCase: case_for_interlining_fabrication_and_material,
        label: 'Interlining Fabrication',
      },
      {
        value: +this.state.prices.extraLongPrice || 0,
        showCase: case_for_extra_long_shades,
        label: 'Extra Long Shades',
      },
      {
        value: +this.state.prices.extraWidePrice || 0,
        showCase: case_for_extra_wide_shades,
        label: 'Extra Wide Shades',
      },
      {
        value: +this.state.prices.trimPrePrice || 0,
        showCase: case_for_trim_pre_made,
        label: 'Trim (Pre-made)',
      },
      { value: 0, showCase: case_for_trim_from_fabric, label: 'Trim (From Fabric)' },
      {
        value: +this.state.prices.otherPrice || 0,
        showCase: case_for_other_embellishments,
        label: 'Other Embellishment',
      },
      {
        value: +this.state.prices.frontValance || 0,
        showCase: case_for_front_valance,
        label: 'Front Valance',
      },
      {
        value: +this.state.prices.backValance || 0,
        showCase: case_for_back_valance,
        label: 'Back Valance',
      },
      {
        value: +this.state.prices.sideFlaps || 0,
        showCase: case_for_side_flaps,
        label: 'Side Flaps',
      },
      {
        value: surcharge_total || 0,
        showCase: case_for_specialty_fabrics_surcharge,
        label: 'Specialty Fabrics Surcharge',
      },
    ];

    const order_quantity =
      this.props.draperyOrder && this.props.draperyOrder.quantity
        ? +this.props.draperyOrder.quantity
        : 1;
    const romanShadeTotal =
      !this.props.draperyOrderPriceId ||
      (this.props.workOrder && !this.props.workOrder.id) ||
      workOrderEditMode
        ? 'TBD'
        : order_quantity * +totalPerUnit;
    return (
      <>
        <DisableAutocompleteInput name="firstName" />
        <SummaryContainer>
          <SummaryTimeline />
          <SummaryContent>
            <SummaryInfoBlock>
              <DraperyHeader noMarginTop uiTimeStatus></DraperyHeader>

              <HContainer uiBaseLine uiGap>
                <CalculatorFormField uiInline uiNoMargin>
                  <TitleNotes>Status</TitleNotes>
                  <Select
                    name="draperyOrder.status"
                    value={this.props.draperyOrder.status}
                    onChange={changeStatus}
                    uiDisabled={this.props.draperyOrder.archived}
                    style={{ width: '200px' }}
                  >
                    {this.props.data.accountStatuses &&
                      this.props.data.accountStatuses.length > 0 &&
                      this.props.data.accountStatuses.map((item: any, index: number) => (
                        <option key={index} value={item.value}>
                          {item.name}
                        </option>
                      ))}
                    <option value={'New'}>New</option>
                    <option value={'Planning'}>Planning</option>
                    <option value={'Measured'}>Measured</option>
                    <option value={'Need Measure'}>Need Measure</option>
                    <option value={'Pending'}>Pending</option>
                    <option value={'Approved'}>Approved</option>
                    <option value={'Production'}>Production</option>
                    <option value={'Ready'}>Ready</option>
                    <option value={'Closed'}>Closed</option>
                    <option value={'Rejected'}>Rejected</option>
                  </Select>
                </CalculatorFormField>

                <CalculatorFormField uiInline uiNoMargin style={{ width: '50%' }}>
                  <TitleNotes>Project Overview Notes</TitleNotes>
                  <TextArea
                    style={{
                      border: '1px solid #B3B3B3',
                      height: '131px',
                    }}
                    name="draperyOrderSummary.notes"
                    onChange={this.props.handleInputChangeForString}
                    onKeyDown={handleEnterPressed}
                    placeholder="Click to enter notes"
                    value={draperyOrderSummary.notes || ''}
                    uiDisabled={this.props.draperyOrder.archived}
                  />
                </CalculatorFormField>
              </HContainer>
            </SummaryInfoBlock>
            <SummaryInfoBlock>
              <DraperyHeader
                noMarginTop
                uiTimeStatus
                uiTimeStatusChecked={!!workOrder.id}
                className="firstCheck"
              >
                ITEM SUMMARY
                <div style={{ gap: '20px' }} className="flex items-center">
                  <div>
                    {!this.props.draperyOrder.archived && this.props.data.workOrder.id > 0 && (
                      <DraftCheckBox>
                        <input
                          type="checkbox"
                          id="isDraft"
                          name="draperyOrder.isDraft"
                          checked={this.props.data.draperyOrder.isDraft}
                          onChange={this.props.handleInputChangeForBoolean}
                          value={this.props.data.draperyOrder.isDraft}
                          disabled={this.props.draperyOrder.archived}
                          style={
                            this.props.draperyOrder.archived
                              ? {
                                  border: '2px solid #EEEEEE',
                                }
                              : {}
                          }
                        />
                        <span>Mark as Draft</span>
                      </DraftCheckBox>
                    )}
                  </div>

                  <div className="flex items-center">
                    {/* <div
                      onClick={
                        this.props.workOrderEditMode ||
                        (((this.props.trims &&
                          this.props.trims.length > 0 &&
                          this.props.trims[0].draperyOrderFabric &&
                          this.props.trims[0].draperyOrderFabric.name &&
                          this.props.trims[0].draperyOrderFabric.name.includes('TRIM FABRIC')) ||
                          this.state.hasValuesOnHardwareTab) &&
                          !this.props.draperyOrder.newRomanShade)
                          ? this.openWarningModal
                          : !this.props.draperyOrder.archived
                          ? this.props.handleDuplicate
                          : undefined
                      }
                    >
                      <DuplicateBtn
                        uiDisabled={
                          this.props.draperyOrder.archived ||
                          this.props.workOrderEditMode ||
                          (((this.props.trims &&
                            this.props.trims.length > 0 &&
                            this.props.trims[0].draperyOrderFabric &&
                            this.props.trims[0].draperyOrderFabric.name &&
                            this.props.trims[0].draperyOrderFabric.name.includes('TRIM FABRIC')) ||
                            this.state.hasValuesOnHardwareTab) &&
                            !this.props.draperyOrder.newRomanShade)
                            ? true
                            : this.props.draperyOrder.archived
                        }
                        uiColor="primary"
                        type="button"
                      >
                        Duplicate
                      </DuplicateBtn>
                    </div>

                    {!this.props.draperyOrder.archived &&
                      !!this.props.draperyOrderEditable &&
                      cancelBtn}
                    {!this.props.draperyOrder.archived && this.props.data.workOrder.id > 0 && (
                      <EditButton
                        uiDisabled={loadingUpdate}
                        uiColor="primary"
                        type="button"
                        onClick={() =>
                          this.props.workOrderEditMode &&
                          this.props.data.orderType !== 'roman-shade-order'
                            ? this.props.updateWorkOrder('delete_messag')
                            : this.props.workOrderEditMode &&
                              this.props.data.orderType === 'roman-shade-order'
                            ? this.props.handleCreateOtherItemOrder(false, yardage)
                            : this.props.editNavigate(0)
                        }
                      >
                        {!this.props.workOrderEditMode && <EditIcon className="inline-flex mr-2" />}
                        <span>{this.props.workOrderEditMode ? 'Update' : 'Edit'}</span>
                      </EditButton>
                    )} */}
                  </div>
                </div>
              </DraperyHeader>

              {(this.props.data &&
                this.props.data.workOrderPdfContentSummery &&
                this.props.data.workOrder.id > 0) ||
              !isDraperyOrder ? (
                <HContainer text="fabrics" style={{ marginBottom: '30px' }} uiColumnDirection>
                  <div className={`rs_item_summary_table ${showBundleColumn ? 'has-bundle' : ''}`}>
                    <div className="rs_item_summary_table_header">
                      <div className="th">
                        <span>Work Order</span>
                      </div>
                      <div
                        className="th"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          gap: '4px',
                        }}
                      >
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                          <span>Estimate Description</span>
                          <span>&nbsp;</span>
                          <span>(per unit)</span>
                        </div>
                        {!isDraperyOrder && (
                          <EstimateSettingsLink
                            href={romanShadeEstimateSettingsHref}
                            style={{ fontSize: '12px', fontWeight: '500' }}
                            data-qa="roman-shade-estimate-description-settings-link"
                          >
                            <span>Edit Description Settings</span>
                            <ExternalLink className="h-[14px] w-[14px]" />
                          </EstimateSettingsLink>
                        )}
                      </div>
                      <div className="th">
                        <span>Quantity</span>
                      </div>
                      <div className="th">
                        <span>Fabrication price (per unit)</span>
                      </div>
                      <div className="th">
                        <span>Fabrication Price</span>
                      </div>
                      {showBundleColumn && (
                        <div className="th">
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span>Bundle</span>
                            <Tooltip open={this.state.isFirstBundleToolTipOpen}>
                              <TooltipTrigger asChild ref={this.tooltipTriggerRef}>
                                <button
                                  type="button"
                                  className="flex h-5 w-5 items-center justify-center transition-colors"
                                  aria-label="Bundling details"
                                  aria-expanded={this.state.isFirstBundleToolTipOpen}
                                  onClick={() => this.handleBundleTooltipOpen('first')}
                                >
                                  <HelpIcon className="h-4 w-4" />
                                </button>
                              </TooltipTrigger>
                              <TooltipContent
                                className="relative max-w-[320px] whitespace-pre-wrap rounded-[10px] border border-[#E5E7EB] bg-white px-4 py-4 pr-9 text-[14px] leading-[1.6] text-[#111827] shadow-[0_8px_24px_rgba(0,0,0,0.12)]"
                                arrowClassName="fill-white"
                                sideOffset={8}
                                ref={this.tooltipContentRef}
                              >
                                <button
                                  type="button"
                                  className="absolute right-3 top-3 text-[#6B7280] hover:text-[#111827]"
                                  onClick={this.handleBundleTooltipClose}
                                  aria-label="Close bundling details"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  >
                                    <path d="M18 6 6 18"></path>
                                    <path d="m6 6 12 12"></path>
                                  </svg>
                                </button>
                                The estimate description and price for selected components are
                                combined into one line item with fabrication for customer-facing
                                estimates. Each bundled component appears as an itemized part of the
                                bundle internally for QuickBooks accounting and reporting.
                                Components not selected appear as separate line items on the
                                customer-facing estimate.
                              </TooltipContent>
                            </Tooltip>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="rs_item_summary_table_body">
                      <div className="rs_item_summary_table_body_row">
                        <div className="td">
                          <div>
                            {workOrderEditMode && isDraperyOrder
                              ? null
                              : !this.props.workOrderEditMode && (
                                  <SummaryTableCell
                                    style={{
                                      textAlign: 'left',
                                    }}
                                    onClick={() => this.props.handleDownloadWorkOrderPdf(true)}
                                  >
                                    <WorkOrderLink
                                      style={{
                                        flexWrap: 'wrap',
                                      }}
                                    >
                                      {this.props.data.workOrderPdfContentSummery &&
                                      workOrder.id ? (
                                        <WorkOrderNumber
                                          className="woNumber"
                                          style={{
                                            textAlign: 'left',
                                            fontWeight: '600',
                                            minHeight: '40px',
                                          }}
                                        >
                                          {'WO - ' + workOrder.num}
                                        </WorkOrderNumber>
                                      ) : null}
                                      {this.props.data.draperyOrder.isDraft && <Draft>DRAFT</Draft>}
                                    </WorkOrderLink>
                                  </SummaryTableCell>
                                )}
                          </div>
                        </div>

                        <div className="td">
                          <div>
                            {workOrderEditMode && isDraperyOrder ? null : (
                              <>
                                {
                                  <SummaryTableCell
                                    text="content"
                                    style={{
                                      textAlign: 'left',
                                      textTransform: 'uppercase',
                                      border: 'none',
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontWeight: '600',
                                        paddingBottom: '20px',
                                      }}
                                    >
                                      {isDraperyOrder ? (
                                        <>
                                          {this.props.data.workOrderPdfContent.room} /{' '}
                                          {this.props.data.draperyOrder.window}
                                        </>
                                      ) : (
                                        <>
                                          {this.props.data.draperyOrder.roomName}{' '}
                                          {this.props.data.draperyOrder.window ||
                                          (!this.props.data.draperyOrder.window &&
                                            !this.props.data.draperyOrder.roomName)
                                            ? '/'
                                            : ''}{' '}
                                          {this.props.data.draperyOrder.window}
                                        </>
                                      )}
                                    </span>
                                  </SummaryTableCell>
                                }

                                <SummaryTableCell
                                  style={{
                                    flex: 1,
                                    border: 'none',
                                  }}
                                >
                                  {showBundledFabricationQuantity && (
                                    <>
                                      <span>{`Quantity: ${this.props.draperyOrder.quantity}`}</span>
                                      <br />
                                    </>
                                  )}
                                  {isDraperyOrder ? (
                                    <>
                                      {salesDescriptionSettingsMapped?.some(
                                        (item) =>
                                          item.id === 'salesfunctionalityandstyle' && item.isEnabled
                                      ) && (
                                        <>
                                          {this.props.data.draperyOrderDesign.category === 0 && (
                                            <span className="boldText">Functional</span>
                                          )}
                                          {this.props.data.draperyOrderDesign.category === 1 && (
                                            <span className="boldText">Stationary</span>
                                          )}

                                          {(this.props.data.draperyOrderDesign.draperyType ===
                                            'full-length' ||
                                            this.props.data.draperyOrderDesign.draperyType ===
                                              'cafe-curtain') && (
                                            <>
                                              <span className="boldText">
                                                {this.props.data.draperyOrderDesign.headingType !==
                                                  'ripplefold' &&
                                                  (this.props.data.draperyOrderDesign
                                                    .draperyType === 'full-length'
                                                    ? '/ Full Length'
                                                    : '/ Cafe Curtain')}
                                              </span>
                                            </>
                                          )}
                                        </>
                                      )}
                                      {salesDescriptionSettingsMapped?.some(
                                        (item) =>
                                          item.id === 'salesfinishedlength' && item.isEnabled
                                      ) && (
                                        <>
                                          {salesDescriptionSettingsMapped?.some(
                                            (item) =>
                                              item.id === 'salesfunctionalityandstyle' &&
                                              item.isEnabled
                                          ) && <span className="boldText"> / </span>}
                                          <span className="nowrap">
                                            <span className="boldText">Finished Length: </span>
                                            <span className="nonBold">
                                              {
                                                this.props.data.draperyOrderDesign
                                                  .finishedLengthOfPanels
                                              }
                                              {''}
                                              ''
                                            </span>
                                          </span>
                                        </>
                                      )}
                                      <br></br>
                                      {salesDescriptionSettingsMapped?.some(
                                        (item) =>
                                          item.id === 'salesheadingandpleattype' && item.isEnabled
                                      ) ? (
                                        <>
                                          <span className="boldText">
                                            {this.props.data.draperyOrderDesign.headingType ===
                                            'rodandrings'
                                              ? 'Pleated / '
                                              : this.props.data.draperyOrderDesign.headingType ===
                                                  'ripplefold'
                                                ? 'Ripplefold / '
                                                : ''}
                                          </span>
                                          <span
                                            className="boldText"
                                            style={{
                                              textTransform: 'capitalize',
                                            }}
                                          >
                                            {(() => {
                                              if (
                                                this.props.data.draperyOrderDesign.headingType ===
                                                'ripplefold'
                                              ) {
                                                const { masterCarrier } =
                                                  (this.props.data &&
                                                    this.props.data.draperyOrderDesign &&
                                                    this.props.data.draperyOrderDesign
                                                      .ripplefoldOptions) ||
                                                  '';
                                                if (masterCarrier === 'butt') {
                                                  return 'Butt';
                                                } else if (masterCarrier === 'overlap') {
                                                  return 'Overlap';
                                                }
                                                return '';
                                              }

                                              if (
                                                this.props.draperyItemDetail &&
                                                this.props.draperyItemDetail[0]
                                                  .pleatTypesWithPricing
                                              ) {
                                                const pleat =
                                                  this.props.draperyItemDetail[0].pleatTypesWithPricing?.find(
                                                    (pleat: any) =>
                                                      pleat.id ===
                                                      this.props.data.workOrderPdfContentSummery
                                                        .pleatType
                                                  );
                                                if (pleat) {
                                                  return pleat.name.toLowerCase();
                                                }
                                                return formatPleatType(
                                                  this.props.data.draperyOrderDesign.pleatType.toLowerCase()
                                                );
                                              }
                                              return '';
                                            })()}
                                          </span>
                                        </>
                                      ) : (
                                        <span></span>
                                      )}
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        {salesDescriptionSettingsMapped?.some(
                                          (item) =>
                                            item.id === 'salespanelandwidthdetails' &&
                                            item.isEnabled
                                        ) ? (
                                          <>
                                            <span className="boldText">Panels:</span>
                                            <span
                                              style={{
                                                paddingLeft: '8px',
                                                fontWeight: '400',
                                              }}
                                            >
                                              {Object.keys(
                                                this.props.data.draperyOrderDesign.panelJson
                                              )
                                                .map(
                                                  (key) =>
                                                    this.props.data.draperyOrderDesign.panelJson[
                                                      key
                                                    ]
                                                )
                                                .filter((value) => value !== undefined)
                                                .map((value) => value + 'w')
                                                .join(' - ')}
                                            </span>
                                          </>
                                        ) : (
                                          <span></span>
                                        )}
                                      </div>
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        {salesDescriptionSettingsMapped?.some(
                                          (item) =>
                                            item.id === 'salestotalnumberofpanelsandwidths' &&
                                            item.isEnabled
                                        ) ? (
                                          <>
                                            <span className="boldText">Total Panels:</span>
                                            <span
                                              style={{
                                                paddingLeft: '8px',
                                                fontWeight: '400',
                                              }}
                                            >
                                              {
                                                Object.keys(
                                                  this.props.data.draperyOrderDesign.panelJson
                                                ).filter(
                                                  (key) =>
                                                    typeof this.props.data.draperyOrderDesign
                                                      .panelJson[key] !== 'undefined'
                                                ).length
                                              }{' '}
                                              /
                                            </span>
                                            <span
                                              className="boldText"
                                              style={{
                                                paddingLeft: '2px',
                                              }}
                                            >
                                              Total Widths:
                                            </span>
                                            <span
                                              style={{
                                                paddingLeft: '8px',
                                                fontWeight: '400',
                                              }}
                                            >
                                              {Object.values(
                                                this.props.data.draperyOrderDesign.panelJson
                                              )
                                                .map((value) => {
                                                  const numericValue = parseFloat(value as string);
                                                  return isNaN(numericValue) ? 0 : numericValue;
                                                })
                                                .reduce(
                                                  (acc, currentValue) => acc + currentValue,
                                                  0
                                                )
                                                .toLocaleString(undefined, {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 2,
                                                })}
                                            </span>
                                          </>
                                        ) : (
                                          <span></span>
                                        )}
                                      </div>
                                      {/* {salesDescriptionSettingsMapped?.some(
                                        (item) =>
                                          item.id === 'salesifliningandinterliningselected' &&
                                          item.isEnabled
                                      ) ? (
                                        <>
                                          <span className="boldText">Lining:</span>
                                          <span
                                            style={{
                                              paddingLeft: '8px',
                                              fontWeight: '400',
                                            }}
                                          >
                                            {this.props.data.liningsList?.some(
                                              (lining: any) =>
                                                lining.name === 'Lining' &&
                                                (lining.active ||
                                                  (romanShadeJson.valanceAndReturns &&
                                                    romanShadeJson.valanceAndReturns.backValance &&
                                                    romanShadeJson.valanceAndReturns.backValance >
                                                      0))
                                            )
                                              ? 'Yes'
                                              : 'No'}
                                          </span>
                                          <br></br>
                                          <span className="boldText">Interlining:</span>
                                          <span
                                            style={{
                                              paddingLeft: '8px',
                                              fontWeight: '400',
                                            }}
                                          >
                                            {this.props.data.liningsList?.some(
                                              (lining: any) =>
                                                lining.name === 'Interlining' && lining.active
                                            )
                                              ? 'Yes'
                                              : 'No'}
                                          </span>
                                          <br></br>
                                          {this.props.data.liningsList?.some(
                                            (lining: any) =>
                                              lining.name === 'Other interlining' && lining.active
                                          ) && (
                                            <div>
                                              <span
                                                className="boldText"
                                                style={{
                                                  paddingLeft: '2px',
                                                }}
                                              >
                                                Additional Interlining:
                                              </span>
                                              <span
                                                style={{
                                                  paddingLeft: '8px',
                                                  fontWeight: '400',
                                                }}
                                              >
                                                Yes
                                              </span>
                                            </div>
                                          )}
                                        </>
                                      ) : (
                                        <span></span>
                                      )} */}
                                    </>
                                  ) : (
                                    <div>
                                      {salesDescriptionSettingsMapped?.some(
                                        (item) =>
                                          item.id === 'salesfunctionalityandstyle' && item.isEnabled
                                      ) ? (
                                        <div>
                                          <span className="nonBold">
                                            {romanShadeJson && romanShadeJson.style.function !== -1
                                              ? draperyOrderDesignFunction[
                                                  romanShadeJson.style.function
                                                ]
                                              : ''}
                                            {romanShadeJson && romanShadeJson.style.type !== ''
                                              ? (romanShadeJson.style.function !== -1
                                                  ? ' / '
                                                  : '') +
                                                romanShadeJson.style.type.charAt(0).toUpperCase() +
                                                romanShadeJson.style.type.substring(1)
                                              : ''}
                                            {isSquareFeetEnabled &&
                                            romanShadeJson &&
                                            romanShadeJson.dimensions
                                              ? !romanShadeJson.dimensions.finishedWidth &&
                                                !romanShadeJson.dimensions.finishedLength &&
                                                !romanShadeJson.dimensions.foldSize &&
                                                !romanShadeJson.dimensions.numOfPermanentFolds
                                                ? ''
                                                : (romanShadeJson.style.function !== -1 ||
                                                  romanShadeJson.style.type !== ''
                                                    ? ' / '
                                                    : '') +
                                                  `${Math.ceil(
                                                    ((+romanShadeJson.dimensions.finishedWidth &&
                                                    +romanShadeJson.dimensions.finishedLength
                                                      ? +romanShadeJson.dimensions.finishedWidth +
                                                        (+romanShadeJson.headrail.boardDepth &&
                                                        romanShadeJson.valanceAndReturns.sides ===
                                                          'returns' &&
                                                        romanShadeJson.valanceAndReturns
                                                          .frontValance === 0
                                                          ? 2 * +romanShadeJson.headrail.boardDepth
                                                          : 0)
                                                      : 1) *
                                                      ((+romanShadeJson.dimensions.finishedWidth &&
                                                      +romanShadeJson.dimensions.finishedLength
                                                        ? +romanShadeJson.dimensions.finishedLength
                                                        : 0) +
                                                        (romanShadeJson.dimensions.foldSize !==
                                                          null &&
                                                        romanShadeJson.dimensions.foldSize !==
                                                          undefined &&
                                                        +romanShadeJson.dimensions
                                                          .numOfPermanentFolds !== null
                                                          ? +romanShadeJson.dimensions.foldSize *
                                                            2 *
                                                            +romanShadeJson.dimensions
                                                              .numOfPermanentFolds
                                                          : 0))) /
                                                      144
                                                  )} Sq. Ft.`
                                              : ''}
                                          </span>

                                          <span className="nonBold">
                                            {this.props.data.draperyOrderDesign.description || ''}
                                          </span>
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                      {salesDescriptionSettingsMapped?.some(
                                        (item) =>
                                          item.id === 'saleswidthandlength' && item.isEnabled
                                      ) ? (
                                        <div>
                                          <span className="nonBold">
                                            {romanShadeJson &&
                                            romanShadeJson.dimensions.finishedWidth !== null &&
                                            romanShadeJson.dimensions.finishedLength !== null
                                              ? romanShadeJson.dimensions.finishedWidth +
                                                `''W x ${
                                                  romanShadeJson &&
                                                  romanShadeJson.dimensions.numOfPermanentFolds !==
                                                    null &&
                                                  +romanShadeJson.dimensions.numOfPermanentFolds !==
                                                    0 &&
                                                  romanShadeJson.dimensions.foldSize !== null &&
                                                  +romanShadeJson.dimensions.foldSize !== 0
                                                    ? '('
                                                    : ''
                                                }` +
                                                romanShadeJson.dimensions.finishedLength +
                                                "''L"
                                              : ''}
                                            {romanShadeJson &&
                                            romanShadeJson.dimensions.numOfPermanentFolds !==
                                              null &&
                                            +romanShadeJson.dimensions.numOfPermanentFolds !== 0 &&
                                            romanShadeJson.dimensions.foldSize !== null &&
                                            +romanShadeJson.dimensions.foldSize !== 0 &&
                                            romanShadeJson.dimensions.foldSize !== undefined
                                              ? ' + ' +
                                                +romanShadeJson.dimensions.numOfPermanentFolds *
                                                  +romanShadeJson.dimensions.foldSize *
                                                  2 +
                                                "''L for Permanent Folds)"
                                              : ''}
                                          </span>
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                      <div>
                                        <span className="nonBold">{mountBoardBackDescription}</span>
                                      </div>
                                      <div>
                                        <span className="nonBold">
                                          {valanceSidesBottomDescription}
                                        </span>
                                      </div>
                                      {shouldRenderLining || shouldRenderInterlining ? (
                                        <>
                                          {shouldRenderLining && (
                                            <>
                                              {shouldShowLiningCom && <span>{`COM `}</span>}
                                              <span className="nonBold">Lining:</span>
                                              {liningDetailParts.length > 0 && (
                                                <span
                                                  style={{
                                                    paddingLeft: '8px',
                                                    fontWeight: '400',
                                                  }}
                                                >
                                                  {liningDetailParts.join(', ')}
                                                </span>
                                              )}
                                              <br></br>
                                            </>
                                          )}
                                          {shouldRenderInterlining && (
                                            <>
                                              {shouldShowInterliningCom && <span>{`COM `}</span>}
                                              <span className="nonBold">Interlining:</span>
                                              {interliningDetailParts.length > 0 && (
                                                <span
                                                  style={{
                                                    paddingLeft: '8px',
                                                    fontWeight: '400',
                                                  }}
                                                >
                                                  {interliningDetailParts.join(', ')}
                                                </span>
                                              )}
                                              <br></br>
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                  )}
                                  {salesDescriptionSettingsMapped?.some(
                                    (item) =>
                                      item.id === 'salesembellishmentsselected' && item.isEnabled
                                  ) ? (
                                    <div>
                                      <span className="nonBold">Embellishments:</span>
                                      <span>
                                        {this.props.data.embellishmentsList?.some(
                                          (embellishment: any) =>
                                            embellishment.checked &&
                                            embellishment.title === 'Banding'
                                        ) && (
                                          <span>
                                            {this.props.data.bandings.map(
                                              (banding: any, index: number) => (
                                                <span key={index} className="nonBold">
                                                  {' '}
                                                  Banding
                                                  {banding.topEdge.active
                                                    ? ' on Top Edge' +
                                                      (banding.bottomEdge.active > 0 ? ',' : '')
                                                    : ''}
                                                  {banding.bottomEdge.active
                                                    ? banding.topEdge.active
                                                      ? ' Bottom Edge'
                                                      : ' on Bottom Edge'
                                                    : ''}
                                                  {banding.leadReturnEdge.active &&
                                                  banding.totalStrips > 0 &&
                                                  banding.topEdge.active &&
                                                  banding.bottomEdge.active
                                                    ? ','
                                                    : ''}
                                                  {banding.leadReturnEdge.active &&
                                                  banding.totalStrips > 0 &&
                                                  !banding.topEdge.active &&
                                                  !banding.bottomEdge.active
                                                    ? ' on'
                                                    : banding.leadReturnEdge.active &&
                                                        banding.totalStrips > 0 &&
                                                        (banding.topEdge.active ||
                                                          banding.bottomEdge.active)
                                                      ? ' and'
                                                      : ''}
                                                  {banding.leadReturnEdge.active &&
                                                  (banding.totalStrips > 0 ||
                                                    this.props.data.orderType ===
                                                      'roman-shade-order')
                                                    ? ` ${
                                                        banding.totalStrips
                                                          ? banding.totalStrips
                                                          : ' and '
                                                      } Vertical Edge${
                                                        banding.totalStrips > 1 ? 's' : ''
                                                      }`
                                                    : ''}
                                                  {/*.*/}
                                                </span>
                                              )
                                            )}
                                          </span>
                                        )}
                                        {this.props.data.embellishmentsList?.some(
                                          (embellishment: any) =>
                                            embellishment.checked &&
                                            embellishment.title === 'Cording'
                                        ) && (
                                          <span>
                                            {this.props.data.cordings.map(
                                              (cording: any, index: number) => (
                                                <span key={index} className="nonBold">
                                                  {cording &&
                                                    cording.draperyOrderFabric &&
                                                    (cording.draperyOrderFabric.name.includes(
                                                      'WELT CORDING FABRIC'
                                                    )
                                                      ? ' Welt Cording'
                                                      : cording.draperyOrderFabric.name.includes(
                                                            'CORDING (PRE-MADE)'
                                                          )
                                                        ? ' Cording (Pre-Made)'
                                                        : ' Cording')}
                                                  {cording.topEdge.active
                                                    ? ' on Top Edge' +
                                                      (cording.bottomEdge.active > 0 ? ',' : '')
                                                    : ''}
                                                  {cording.bottomEdge.active
                                                    ? cording.topEdge.active
                                                      ? ' Bottom Edge'
                                                      : ' on Bottom Edge'
                                                    : ''}
                                                  {cording.leadReturnEdge.active &&
                                                  cording.totalStrips > 0 &&
                                                  cording.topEdge.active &&
                                                  cording.bottomEdge.active
                                                    ? ','
                                                    : ''}
                                                  {cording.leadReturnEdge.active &&
                                                  cording.totalStrips > 0 &&
                                                  !cording.topEdge.active &&
                                                  !cording.bottomEdge.active
                                                    ? ' on'
                                                    : cording.leadReturnEdge.active &&
                                                        cording.totalStrips > 0 &&
                                                        (cording.topEdge.active ||
                                                          cording.bottomEdge.active)
                                                      ? ' and'
                                                      : ''}
                                                  {cording.leadReturnEdge.active &&
                                                  (cording.totalStrips > 0 ||
                                                    this.props.data.orderType ===
                                                      'roman-shade-order')
                                                    ? ` ${
                                                        cording.totalStrips
                                                          ? cording.totalStrips
                                                          : ' and '
                                                      } Vertical Edge${
                                                        cording.totalStrips > 1 ? 's' : ''
                                                      }`
                                                    : ''}

                                                  {/*.*/}
                                                </span>
                                              )
                                            )}
                                          </span>
                                        )}
                                        {this.props.data.embellishmentsList?.some(
                                          (embellishment: any) =>
                                            embellishment.checked &&
                                            embellishment.title === 'Flange'
                                        ) && (
                                          <span>
                                            {this.props.data.flanges.map(
                                              (flange: any, index: number) => (
                                                <span key={index} className="nonBold">
                                                  {flange &&
                                                    flange.draperyOrderFabric &&
                                                    (flange.draperyOrderFabric.name.includes(
                                                      'FLANGE FABRIC'
                                                    )
                                                      ? ' Flange from Fabric'
                                                      : flange.draperyOrderFabric.name.includes(
                                                            'FLANGE (PRE-MADE)'
                                                          )
                                                        ? ' Flange (Pre-Made)'
                                                        : ' Flange')}
                                                  {flange.topEdge.active
                                                    ? ' on Top Edge' +
                                                      (flange.bottomEdge.active > 0 ? ',' : '')
                                                    : ''}
                                                  {flange.bottomEdge.active
                                                    ? flange.topEdge.active
                                                      ? ' Bottom Edge'
                                                      : ' on Bottom Edge'
                                                    : ''}
                                                  {flange.leadReturnEdge.active &&
                                                  flange.totalStrips > 0 &&
                                                  flange.topEdge.active &&
                                                  flange.bottomEdge.active
                                                    ? ','
                                                    : ''}
                                                  {flange.leadReturnEdge.active &&
                                                  flange.totalStrips > 0 &&
                                                  !flange.topEdge.active &&
                                                  !flange.bottomEdge.active
                                                    ? ' on'
                                                    : flange.leadReturnEdge.active &&
                                                        flange.totalStrips > 0 &&
                                                        (flange.topEdge.active ||
                                                          flange.bottomEdge.active)
                                                      ? ' and'
                                                      : ''}
                                                  {flange.leadReturnEdge.active &&
                                                  (flange.totalStrips > 0 ||
                                                    this.props.data.orderType ===
                                                      'roman-shade-order')
                                                    ? ` ${
                                                        flange.totalStrips
                                                          ? flange.totalStrips
                                                          : ' and '
                                                      } Vertical Edge${
                                                        flange.totalStrips > 1 ? 's' : ''
                                                      }`
                                                    : ''}

                                                  {/*.*/}
                                                </span>
                                              )
                                            )}
                                          </span>
                                        )}
                                        {this.props.data.embellishmentsList?.some(
                                          (embellishment: any) =>
                                            embellishment.checked && embellishment.title === 'Trim'
                                        ) && (
                                          <span>
                                            {this.props.data.trims.map(
                                              (trim: any, index: number) => (
                                                <span key={index}>
                                                  {trim &&
                                                    trim.draperyOrderFabric &&
                                                    (trim.draperyOrderFabric.name.includes(
                                                      'TRIM FABRIC'
                                                    )
                                                      ? ' Trim from Fabric' +
                                                        (!trim.topEdge.shade &&
                                                        !trim.bottomEdge.shade &&
                                                        !trim.leadReturnEdge.shade
                                                          ? '. '
                                                          : ' ')
                                                      : trim.draperyOrderFabric.name.includes(
                                                            'TRIM (PRE-MADE)'
                                                          )
                                                        ? ' Trim (Pre-Made)' +
                                                          (!trim.topEdge.shade &&
                                                          !trim.bottomEdge.shade &&
                                                          !trim.leadReturnEdge.shade
                                                            ? '. '
                                                            : ' ')
                                                        : ' Trim' +
                                                          (!trim.topEdge.shade &&
                                                          !trim.bottomEdge.shade &&
                                                          !trim.leadReturnEdge.shade
                                                            ? '. '
                                                            : ' '))}
                                                  {trim.topEdge.active
                                                    ? ' on Top Edge' +
                                                      (trim.bottomEdge.active > 0 ? ',' : '')
                                                    : ''}
                                                  {trim.bottomEdge.active
                                                    ? trim.topEdge.active
                                                      ? ' Bottom Edge'
                                                      : ' on Bottom Edge'
                                                    : ''}
                                                  {trim.leadReturnEdge.active &&
                                                  trim.totalStrips > 0 &&
                                                  trim.topEdge.active &&
                                                  trim.bottomEdge.active
                                                    ? ','
                                                    : ''}
                                                  {trim.leadReturnEdge.active &&
                                                  trim.totalStrips > 0 &&
                                                  !trim.topEdge.active &&
                                                  !trim.bottomEdge.active
                                                    ? ' on'
                                                    : trim.leadReturnEdge.active &&
                                                        trim.totalStrips > 0 &&
                                                        (trim.topEdge.active ||
                                                          trim.bottomEdge.active)
                                                      ? ' and'
                                                      : ''}
                                                  {trim.leadReturnEdge.active &&
                                                  (trim.totalStrips > 0 ||
                                                    this.props.data.orderType ===
                                                      'roman-shade-order')
                                                    ? ` ${
                                                        trim.totalStrips
                                                          ? trim.totalStrips
                                                          : ' and '
                                                      } Vertical Edge${
                                                        trim.totalStrips > 1 ? 's' : ''
                                                      }`
                                                    : ''}
                                                  {trim.topEdge.shade &&
                                                  trim.bottomEdge.shade &&
                                                  trim.leadReturnEdge.shade
                                                    ? `on top edge, sides, and bottom edge of Shade${
                                                        trim.topEdge.valance ||
                                                        trim.bottomEdge.valance ||
                                                        trim.leadReturnEdge.valance
                                                          ? ' and'
                                                          : '.'
                                                      } `
                                                    : trim.topEdge.shade &&
                                                        trim.bottomEdge.shade &&
                                                        !trim.leadReturnEdge.shade
                                                      ? `on top edge and bottom edge of Shade${
                                                          trim.topEdge.valance ||
                                                          trim.bottomEdge.valance ||
                                                          trim.leadReturnEdge.valance
                                                            ? ' and'
                                                            : '.'
                                                        } `
                                                      : !trim.topEdge.shade &&
                                                          trim.bottomEdge.shade &&
                                                          trim.leadReturnEdge.shade
                                                        ? `on sides and bottom edge of Shade${
                                                            trim.topEdge.valance ||
                                                            trim.bottomEdge.valance ||
                                                            trim.leadReturnEdge.valance
                                                              ? ' and'
                                                              : '.'
                                                          } `
                                                        : trim.topEdge.shade &&
                                                            !trim.bottomEdge.shade &&
                                                            trim.leadReturnEdge.shade
                                                          ? `on top edge and sides of Shade${
                                                              trim.topEdge.valance ||
                                                              trim.bottomEdge.valance ||
                                                              trim.leadReturnEdge.valance
                                                                ? ' and'
                                                                : '.'
                                                            } `
                                                          : trim.topEdge.shade &&
                                                              !trim.bottomEdge.shade &&
                                                              !trim.leadReturnEdge.shade
                                                            ? `on top edge of Shade${
                                                                trim.topEdge.valance ||
                                                                trim.bottomEdge.valance ||
                                                                trim.leadReturnEdge.valance
                                                                  ? ' and'
                                                                  : '.'
                                                              } `
                                                            : !trim.topEdge.shade &&
                                                                trim.bottomEdge.shade &&
                                                                !trim.leadReturnEdge.shade
                                                              ? `on bottom edge of Shade${
                                                                  trim.topEdge.valance ||
                                                                  trim.bottomEdge.valance ||
                                                                  trim.leadReturnEdge.valance
                                                                    ? ' and'
                                                                    : '.'
                                                                } `
                                                              : !trim.topEdge.shade &&
                                                                  !trim.bottomEdge.shade &&
                                                                  trim.leadReturnEdge.shade
                                                                ? `on sides of Shade${
                                                                    trim.topEdge.valance ||
                                                                    trim.bottomEdge.valance ||
                                                                    trim.leadReturnEdge.valance
                                                                      ? ' and'
                                                                      : '.'
                                                                  } `
                                                                : ''}

                                                  {trim.topEdge.valance &&
                                                  trim.bottomEdge.valance &&
                                                  trim.leadReturnEdge.valance
                                                    ? 'on top edge, sides, and bottom edge of Valance.'
                                                    : trim.topEdge.valance &&
                                                        trim.bottomEdge.valance &&
                                                        !trim.leadReturnEdge.valance
                                                      ? 'on top edge and bottom edge of Valance.'
                                                      : !trim.topEdge.valance &&
                                                          trim.bottomEdge.valance &&
                                                          trim.leadReturnEdge.valance
                                                        ? 'on sides and bottom edge of Valance.'
                                                        : trim.topEdge.valance &&
                                                            !trim.bottomEdge.valance &&
                                                            trim.leadReturnEdge.valance
                                                          ? 'on top edge and sides of Valance.'
                                                          : trim.topEdge.valance &&
                                                              !trim.bottomEdge.valance &&
                                                              !trim.leadReturnEdge.valance
                                                            ? 'on top edge of Valance.'
                                                            : !trim.topEdge.valance &&
                                                                trim.bottomEdge.valance &&
                                                                !trim.leadReturnEdge.valance
                                                              ? 'on bottom edge of Valance.'
                                                              : !trim.topEdge.valance &&
                                                                  !trim.bottomEdge.valance &&
                                                                  trim.leadReturnEdge.valance
                                                                ? 'on sides of Valance.'
                                                                : ''}
                                                </span>
                                              )
                                            )}
                                          </span>
                                        )}
                                        {this.props.data.embellishmentsList?.some(
                                          (embellishment: any) =>
                                            embellishment.checked &&
                                            embellishment.stateName === 'othersEmbellishments'
                                        ) && (
                                          <span>
                                            {' '}
                                            {this.props.data.othersEmbellishments
                                              .filter((other: any) => other.name)
                                              .map((other: any) => other.name + '')
                                              .join(', ') +
                                              (this.props.data.othersEmbellishments.filter(
                                                (other: any) => other.name
                                              ).length > 0
                                                ? '.'
                                                : '')}
                                            {/*{"."}*/}
                                          </span>
                                        )}
                                        {!this.props.data.embellishmentsList?.some(
                                          (embellishment: any) => embellishment.checked
                                        ) && <span> None</span>}
                                      </span>
                                    </div>
                                  ) : (
                                    <span></span>
                                  )}
                                </SummaryTableCell>
                              </>
                            )}
                          </div>
                        </div>

                        <div className="td">
                          <div>
                            {workOrderEditMode && isDraperyOrder ? null : (
                              <SummaryTableCell
                                style={{
                                  textAlign: 'left',
                                  textTransform: 'uppercase',
                                  whiteSpace: 'pre-wrap',
                                  border: 'none',
                                }}
                              >
                                <span className="boldText">{this.props.draperyOrder.quantity}</span>
                              </SummaryTableCell>
                            )}
                          </div>
                        </div>

                        <div className="td">
                          <div>
                            {workOrderEditMode || !isDraperyOrder ? null : (
                              <SummaryTableCell style={{ border: 'none' }} text="total-per-unit">
                                <span
                                  style={{
                                    fontWeight: '600',
                                    paddingBottom: '20px',
                                    border: 'none',
                                  }}
                                >
                                  $ {totalPerUnit} TOTAL PER UNIT
                                </span>
                                <br></br>
                                <br></br>
                                <div className="nonBold">
                                  <span className="basePrice"></span>
                                </div>
                                <div
                                  className="price-item nonBold"
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <span
                                    className="liningPrice"
                                    style={{
                                      marginLeft: '5px',
                                    }}
                                  ></span>
                                  <span
                                    className="liningMaterialPrice"
                                    style={{
                                      marginLeft: '5px',
                                    }}
                                  ></span>
                                </div>
                                <div
                                  className="price-item nonBold"
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <span
                                    className="interliningPrice"
                                    style={{
                                      marginLeft: '5px',
                                    }}
                                  ></span>
                                  <span
                                    className="interliningMaterialPrice"
                                    style={{
                                      marginLeft: '5px',
                                    }}
                                  ></span>
                                </div>
                                <div
                                  className="price-item nonBold"
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <span className="bandingPrice"></span>
                                  <span className="cordingPrice"></span>
                                  <span className="cordingFabricPrice"></span>
                                  <span className="flangePrice"></span>
                                  <span className="flangeFabricPrice"></span>
                                  <span className="trimPrice"></span>
                                  <span className="trimFabricPrice"></span>
                                  <span className="othersEmbelishmentsPrice"></span>
                                </div>
                                <div
                                  className="price-item"
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <span className="pinningPrice"></span>
                                  <span className="weightPrice"></span>
                                  <span className="cafePrice"></span>
                                  <span className="extraLongPrice"></span>
                                  <span className="extraWidePrice"></span>
                                </div>
                                <div
                                  className="price-item"
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <span className="specialityPrice"></span>
                                  <span className="specialityPriceLining"></span>
                                  <span className="specialityPriceInterlining"></span>
                                  <span className="specialityPriceBanding"></span>
                                  <span className="specialityPriceCordingPreMade"></span>
                                  <span className="specialityPriceCordingFabric"></span>
                                  <span className="specialityPriceFlangePreMade"></span>
                                  <span className="specialityPriceFlangeFabric"></span>
                                  <span className="specialityPriceTrimPreMade"></span>
                                  <span className="specialityPriceTrimFabric"></span>
                                  <span className="specialityPriceOther"></span>
                                </div>
                                <br></br>
                                <br></br>
                              </SummaryTableCell>
                            )}

                            {!isDraperyOrder && (
                              <SummaryTableCell
                                style={{ gap: '7px', maxHeight: '100%', border: 'none' }}
                                text="total-per-unit"
                              >
                                <div>
                                  {this.props.draperyOrder.newRomanShade ||
                                  !this.props.draperyOrder.id ? (
                                    <>
                                      <table>
                                        <thead>
                                          <tr>
                                            <th>
                                              <span style={{ fontWeight: '600', marginRight: 10 }}>
                                                $
                                              </span>
                                            </th>
                                            <th>
                                              <span className="font-semibold">
                                                {workOrderEditMode ||
                                                !this.props.draperyOrderPriceId ||
                                                !(this.props.workOrder && this.props.workOrder.id)
                                                  ? 'TBD'
                                                  : totalPerUnit
                                                    ? totalPerUnit.toFixed(2)
                                                    : totalPerUnit}
                                              </span>
                                            </th>
                                            <th
                                              className="text-left"
                                              style={{ paddingLeft: '7px' }}
                                            >
                                              <span>
                                                {this.props.workOrder &&
                                                this.props.workOrder.id &&
                                                !workOrderEditMode ? (
                                                  <span style={{ fontWeight: '600' }}>
                                                    TOTAL PER UNIT
                                                  </span>
                                                ) : (
                                                  ''
                                                )}
                                              </span>
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {!workOrderEditMode &&
                                          this.props.workOrder &&
                                          this.props.workOrder.id &&
                                          fabrication_prices_per_unit &&
                                          fabrication_prices_per_unit.length > 0
                                            ? fabrication_prices_per_unit.map((i: any) => {
                                                if (!i.showCase) return;
                                                return (
                                                  <tr key={i.label} style={{ textAlign: 'right' }}>
                                                    <td></td>

                                                    <td className="text-right align-top font-medium">
                                                      {i.value.toFixed(2)}
                                                    </td>

                                                    <td
                                                      className="text-left align-top font-medium"
                                                      style={{ paddingLeft: '7px' }}
                                                    >
                                                      {i.label}
                                                    </td>
                                                  </tr>
                                                );
                                              })
                                            : ''}

                                          {(!workOrderEditMode || isCreateMode) &&
                                          this.state.additionalPriceAdjustmentType &&
                                          this.state.additionalPriceAdjustmentType !== 'none' &&
                                          Number(this.state.prices.additionalPriceAdjustment) ? (
                                            <tr>
                                              <td></td>

                                              <td className="text-right align-top font-medium">
                                                {this.state.prices.additionalPriceAdjustment}
                                              </td>

                                              <td className="text-left align-top font-medium pl-[7px]">
                                                Client{' '}
                                                {this.state.additionalPriceAdjustmentType ===
                                                'discount'
                                                  ? 'Discount'
                                                  : 'Markup'}
                                              </td>
                                            </tr>
                                          ) : null}
                                        </tbody>
                                      </table>
                                    </>
                                  ) : (
                                    ''
                                  )}
                                </div>

                                {this.props.draperyOrder.newRomanShade ||
                                !this.props.draperyOrder.id ? (
                                  ''
                                ) : (
                                  <>
                                    <span style={{ fontWeight: '600', marginRight: 10 }}>$</span>
                                    <CalculatorFieldInput
                                      uiWidth={250}
                                      style={{
                                        border: '1px solid #b3b3b3',
                                        borderRadius: '0.5rem',
                                        height: '33px',
                                        marginTop: '-6px',
                                      }}
                                    >
                                      <CalculatorYardageInput
                                        id="draperyOrderSummary.totalPerUnit"
                                        name="draperyOrderSummary.totalPerUnit"
                                        type="text"
                                        min={0}
                                        disabled={
                                          !(workOrderEditMode || isCreateMode) &&
                                          this.props.workOrder.id !== 0
                                        }
                                        uiDisabled={
                                          !(workOrderEditMode || isCreateMode) &&
                                          this.props.workOrder.id !== 0
                                        }
                                        value={
                                          draperyOrderSummary.totalPerUnit != null
                                            ? !(workOrderEditMode || isCreateMode) &&
                                              this.props.workOrder.id !== 0
                                              ? Number(
                                                  draperyOrderSummary.totalPerUnit
                                                ).toLocaleString(undefined, {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 2,
                                                })
                                              : draperyOrderSummary.totalPerUnit.toString()
                                            : ''
                                        }
                                        onChange={this.props.handleInputChangeForNumber}
                                      />
                                    </CalculatorFieldInput>
                                    <div style={{ marginBottom: '5px' }}>
                                      <span style={{ fontWeight: '600' }}>TOTAL PER UNIT</span>
                                    </div>
                                  </>
                                )}
                              </SummaryTableCell>
                            )}
                          </div>
                        </div>

                        <div className="td">
                          <div>
                            {workOrderEditMode && isDraperyOrder ? null : (
                              <SummaryTableCell>
                                <span
                                  style={{
                                    fontWeight: '600',
                                    paddingBottom: '20px',
                                    border: 'none',
                                  }}
                                >
                                  ${' '}
                                  {this.props.draperyOrder.newRomanShade
                                    ? typeof romanShadeTotal === 'number'
                                      ? romanShadeTotal.toLocaleString('en-US', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                      : romanShadeTotal
                                    : otherItemTotal}{' '}
                                  TOTAL
                                </span>
                              </SummaryTableCell>
                            )}
                          </div>
                        </div>

                        {showBundleColumn && (
                          <div className="td">
                            <div>
                              {bundleTotalLabel && (
                                <SummaryTableCell
                                  style={{
                                    textAlign: 'center',
                                    border: 'none',
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: '600',
                                      paddingBottom: '20px',
                                      display: 'block',
                                    }}
                                  >
                                    {bundleTotalLabel}
                                  </span>
                                </SummaryTableCell>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {workOrderEditMode &&
                    isDraperyOrder &&
                    this.props.data.orderType !== 'roman-shade-order' &&
                    (loadingUpdate ? (
                      <div className="work_order_edit_mode_alert_container"></div>
                    ) : (
                      <div className="work_order_edit_mode_alert_container">
                        <RedWarning />
                        <p className="work_order_edit_mode_alert_message">
                          This field will be re-calculated after update
                        </p>
                      </div>
                    ))}
                </HContainer>
              ) : (
                <HContainer text="fabrics">
                  <SummaryTable>
                    <SummaryTableCol>
                      <SummaryTableCell style={{ width: '50%' }} text="title">
                        Work Order
                      </SummaryTableCell>
                      <SummaryTableCell></SummaryTableCell>
                      <SummaryTableCell></SummaryTableCell>
                      <SummaryTableCell></SummaryTableCell>
                    </SummaryTableCol>
                    <SummaryTableCol>
                      <SummaryTableCell
                        text="title"
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          gap: '4px',
                        }}
                      >
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                          <span>Estimate Description</span>
                          <span>&nbsp;</span>
                          <span
                            style={{
                              fontStyle: 'italic',
                            }}
                          >
                            (per unit)
                          </span>
                        </div>
                        {!isDraperyOrder && (
                          <EstimateSettingsLink
                            href={romanShadeEstimateSettingsHref}
                            style={{ fontSize: '12px', fontWeight: '500' }}
                            data-qa="roman-shade-estimate-description-settings-link"
                          >
                            <span>Edit Description Settings</span>
                            <ExternalLink className="h-[14px] w-[14px]" />
                          </EstimateSettingsLink>
                        )}
                      </SummaryTableCell>
                    </SummaryTableCol>
                    <SummaryTableCol>
                      <SummaryTableCell text="title">Quantity</SummaryTableCell>
                    </SummaryTableCol>

                    <SummaryTableCol>
                      <SummaryTableCell text="title" style={{ whiteSpace: 'nowrap' }}>
                        Fabrication price <span>&nbsp;</span>
                        <span
                          style={{
                            fontStyle: 'italic',
                          }}
                        >
                          (per unit)
                        </span>
                      </SummaryTableCell>
                    </SummaryTableCol>
                    <SummaryTableCol>
                      <SummaryTableCell text="title">Fabrication price</SummaryTableCell>
                    </SummaryTableCol>
                  </SummaryTable>
                </HContainer>
              )}
              <DraperyHeader
                noMarginTop
                noMarginBottom
                uiTimeStatus
                uiTimeStatusChecked={!!this.props.workOrder.id}
              >
                FEES
              </DraperyHeader>
              <HContainer style={{ marginBottom: '30px' }} uiColumnDirection uiStretch>
                <OrderFeesSection
                  accountId={this.props.accountId}
                  clientId={this.props.draperyOrder.clientId}
                  clientBillingType={clientBillingInfo?.billingType}
                  fees={this.props.draperyOrderFees}
                  orderId={this.props.draperyOrder.id}
                  showBundleColumn={showBundleColumn}
                  defaultBundleChecked={feesBundleDefaultSelected}
                  clientAdjustmentType={feeClientPriceAdjustmentType}
                  clientAdjustmentValue={feeClientPriceAdjustmentValue}
                  disabled={!(workOrderEditMode || isCreateMode) && this.props.workOrder.id !== 0}
                  onChange={this.props.handleDraperyOrderFeesChange}
                  onBundleChange={this.props.handleDraperyOrderFeesBundleChange}
                  onBundledTotalChange={this.handleBundledFeesTotalChange}
                />
              </HContainer>
              {this.props.data &&
              this.props.data.workOrderPdfContentSummery &&
              this.props.data.workOrder.id > 0 &&
              this.props.data.orderType !== 'roman-shade-order' ? (
                <HContainer text="fabrics" uiColumnDirection>
                  <SummaryTable>
                    <SummaryTableCol text="fabrics" color="header">
                      <SummaryTableCell
                        className="fabricHeader"
                        text="title"
                        style={{
                          fontSize: window.innerWidth < 992 ? '10px' : 'inherit',
                        }}
                      >
                        Components
                      </SummaryTableCell>

                      {workOrderEditMode ? null : (
                        <SummaryTableCell text="fabrics">
                          <WorkOrderNumber className="left">
                            <div>
                              <p>{this.props.data.mainFabric && this.props.data.mainFabric.name}</p>
                              {this.renderEstimateDescriptionParagraphs(
                                this.props.data.mainFabric,
                                this.props.data?.fabricsPatternItems
                              )}
                              {this.shouldRenderLegacyComponentMeasurements(
                                this.props.data.mainFabric
                              ) && (
                                <WorkorderMeasureWrapper>
                                  {this.props.data &&
                                    this.props.data.fabricsPatternItems &&
                                    Object.values(this.props.data.mainFabric.values).map(
                                      (value, index) => {
                                        return (
                                          <WorkorderMeasure
                                            className="last-separator"
                                            style={{
                                              color: '#545454',
                                            }}
                                          >
                                            <span> {property[index]}</span>
                                            <p>
                                              {value}"<span>/</span>
                                            </p>
                                          </WorkorderMeasure>
                                        );
                                      }
                                    )}
                                </WorkorderMeasureWrapper>
                              )}
                            </div>
                          </WorkOrderNumber>

                          {this.props.data.workOrderPdfContentSummery.bandingFabricContents.map(
                            (item: any, index: number) => {
                              const newItem = item && item.pattern;
                              return (
                                <WorkOrderNumber className="left">
                                  <div>
                                    <p>{item.fabric}</p>
                                    {this.renderEstimateDescriptionParagraphs(
                                      item,
                                      this.props.data?.fabricsPatternItems
                                    )}
                                    {this.shouldRenderLegacyComponentMeasurements(item) && (
                                      <WorkorderMeasureWrapper>
                                        {this.props.data &&
                                          this.props.data.fabricsPatternItems &&
                                          Object.entries(
                                            this.props.data.workOrderPdfContentSummery
                                              .bandingFabricContents[index].trimWidth
                                          )
                                            .filter(([key, value]) => key !== 'trimWidth')
                                            .map(([key, value], index) => {
                                              return (
                                                <WorkorderMeasure
                                                  className="last-separator"
                                                  style={{
                                                    color: '#545454',
                                                  }}
                                                >
                                                  <span> {property[index]}</span>
                                                  <p>
                                                    {value}"<span>/</span>
                                                  </p>
                                                </WorkorderMeasure>
                                              );
                                            })}
                                      </WorkorderMeasureWrapper>
                                    )}
                                  </div>
                                </WorkOrderNumber>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.premadeCordingFabricContents.map(
                            (item: any) => {
                              const newItem = item && item.pattern;
                              return (
                                <WorkOrderNumber className="left">
                                  <div>
                                    <p>{item.fabric}</p>
                                    {this.renderEstimateDescriptionParagraphs(
                                      item,
                                      this.props.data?.fabricsPatternItems
                                    )}
                                  </div>
                                </WorkOrderNumber>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.premadeFlangeFabricContents.map(
                            (item: any) => {
                              const newItem = item && item.pattern;
                              return (
                                <WorkOrderNumber className="left">
                                  <div>
                                    <p>{item.fabric}</p>
                                    {this.renderEstimateDescriptionParagraphs(
                                      item,
                                      this.props.data?.fabricsPatternItems
                                    )}
                                  </div>
                                </WorkOrderNumber>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents.map(
                            (item: any) => {
                              const newItem = item && item.pattern;
                              return (
                                <WorkOrderNumber className="left">
                                  <div>
                                    <p>{item.fabric}</p>
                                    {this.renderEstimateDescriptionParagraphs(
                                      item,
                                      this.props.data?.fabricsPatternItems
                                    )}
                                    {this.shouldRenderLegacyComponentMeasurements(item) &&
                                      item.trimWidth && (
                                        <div>
                                          <span>W:</span>
                                          {item.trimWidth}"
                                        </div>
                                      )}
                                  </div>
                                </WorkOrderNumber>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.weltCordingFabricContents.map(
                            (item: any) => {
                              const newItem = item && item.pattern;
                              return (
                                <WorkOrderNumber className="left">
                                  <div>
                                    <p>{item.fabric}</p>
                                    {this.renderEstimateDescriptionParagraphs(
                                      item,
                                      this.props.data?.fabricsPatternItems
                                    )}
                                    {this.shouldRenderLegacyComponentMeasurements(item) && (
                                      <div>
                                        <span>W:</span>
                                        {item.trimWidth}"
                                      </div>
                                    )}
                                  </div>
                                </WorkOrderNumber>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.fabricFlangeFabricContents.map(
                            (item: any) => {
                              const newItem = item && item.pattern;

                              return (
                                <WorkOrderNumber className="left">
                                  <div>
                                    <p>{item.fabric}</p>
                                    {this.renderEstimateDescriptionParagraphs(
                                      item,
                                      this.props.data?.fabricsPatternItems
                                    )}
                                    {this.shouldRenderLegacyComponentMeasurements(item) && (
                                      <div>
                                        <span>W:</span>
                                        {item.trimWidth}"
                                      </div>
                                    )}
                                  </div>
                                </WorkOrderNumber>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.fabricTrimFabricContents.map(
                            (item: any, index: number) => {
                              const newItem = item && item.pattern;
                              return (
                                <WorkOrderNumber className="left">
                                  <div>
                                    <p>{item.fabric}</p>
                                    {this.renderEstimateDescriptionParagraphs(
                                      item,
                                      this.props.data?.fabricsPatternItems
                                    )}
                                    {this.shouldRenderLegacyComponentMeasurements(item) && (
                                      <WorkorderMeasureWrapper>
                                        {this.props.data &&
                                          this.props.data.fabricsPatternItems &&
                                          Object.entries(
                                            this.props.data.workOrderPdfContentSummery
                                              .fabricTrimFabricContents[index].trimWidth
                                          )
                                            .filter(([key, value]) => key !== 'trimWidth')
                                            .map(([key, value], index) => {
                                              return (
                                                <WorkorderMeasure
                                                  className="last-separator"
                                                  style={{
                                                    color: '#545454',
                                                  }}
                                                >
                                                  <span> {property[index]}</span>
                                                  <p>
                                                    {value}"<span>/</span>
                                                  </p>
                                                </WorkorderMeasure>
                                              );
                                            })}
                                      </WorkorderMeasureWrapper>
                                    )}
                                  </div>
                                </WorkOrderNumber>
                              );
                            }
                          )}
                          {this.props.data &&
                            this.props.data.liningsList &&
                            this.props.data.liningsList.map((item: any) => {
                              const newItem =
                                item &&
                                item.draperyOrderLiningsFabric &&
                                item.draperyOrderLiningsFabric.pattern &&
                                item.draperyOrderLiningsFabric.orderOrigin === 1
                                  ? item.draperyOrderLiningsFabric.pattern
                                  : item.draperyOrderLiningsFabric;
                              if (newItem) {
                                return (
                                  <WorkOrderNumber className="left">
                                    <div>
                                      <p>{item.draperyOrderLiningsFabric.name}</p>
                                      {this.renderEstimateDescriptionParagraphs(
                                        item.draperyOrderLiningsFabric,
                                        this.props.data?.liningsPatternItems
                                      )}
                                      {this.shouldRenderLegacyComponentMeasurements(
                                        item.draperyOrderLiningsFabric
                                      ) && (
                                        <div>
                                          <span className="mr-2">W:</span>
                                          {item &&
                                            item.draperyOrderLiningsFabric &&
                                            item.draperyOrderLiningsFabric.values &&
                                            item.draperyOrderLiningsFabric.values.fabricWidth}
                                          "
                                        </div>
                                      )}
                                    </div>
                                  </WorkOrderNumber>
                                );
                              }
                            })}
                          {this.props.data.othersEmbellishments[0].name &&
                            this.props.data.othersEmbellishments.map((item: any) => {
                              return (
                                <WorkOrderNumber className="left">
                                  <div>
                                    <p>
                                      {item && item.name && `${item.name.toUpperCase()} FABRIC`}
                                    </p>
                                    {this.renderEstimateDescriptionParagraphs(
                                      item?.draperyOrderFabric,
                                      this.props.data?.fabricsPatternItems
                                    )}
                                  </div>
                                </WorkOrderNumber>
                              );
                            })}
                        </SummaryTableCell>
                      )}
                    </SummaryTableCol>
                    <SummaryTableCol text="not-fabrics">
                      <SummaryTableCell
                        className="fabricHeader"
                        position="center"
                        style={{
                          fontSize: window.innerWidth < 992 ? '10px' : 'inherit',
                        }}
                      >
                        Quantity
                      </SummaryTableCell>

                      {workOrderEditMode ? null : (
                        <SummaryTableCell text="fabrics">
                          <WorkOrderNumber>
                            {
                              this.props.data.workOrderPdfContentSummery.mainFabricContent
                                .yardsNeeded
                            }
                          </WorkOrderNumber>
                          {this.props.data.workOrderPdfContentSummery.bandingFabricContents.map(
                            (content: any) => {
                              return <WorkOrderNumber>{content.yardsNeeded}</WorkOrderNumber>;
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.premadeCordingFabricContents.map(
                            (content: any) => {
                              return <WorkOrderNumber>{content.yardsNeeded}</WorkOrderNumber>;
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.premadeFlangeFabricContents.map(
                            (content: any) => {
                              return <WorkOrderNumber>{content.yardsNeeded}</WorkOrderNumber>;
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents.map(
                            (content: any) => {
                              return <WorkOrderNumber>{content.yardsNeeded}</WorkOrderNumber>;
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.weltCordingFabricContents.map(
                            (content: any) => {
                              return <WorkOrderNumber>{content.yardsNeeded}</WorkOrderNumber>;
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.fabricFlangeFabricContents.map(
                            (content: any) => {
                              return <WorkOrderNumber>{content.yardsNeeded}</WorkOrderNumber>;
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.fabricTrimFabricContents.map(
                            (content: any) => {
                              return <WorkOrderNumber>{content.yardsNeeded}</WorkOrderNumber>;
                            }
                          )}
                          {this.props.data &&
                          this.props.data.liningsList &&
                          this.props.data.liningsList.length > 0 &&
                          this.props.data.liningsList[0] &&
                          (this.props.data.liningsList[0].active || forBackValance) ? (
                            <WorkOrderNumber>
                              {this.props.data && this.props.data.liningsList && (
                                <>
                                  {this.props.data.liningsList.map((item: any) => {
                                    if (
                                      item.draperyOrderLiningsFabric &&
                                      item.draperyOrderLiningsFabric.name === 'LINING FABRIC'
                                    ) {
                                      liningMaterialYardage =
                                        item.draperyOrderLiningsFabric.yardsNeeded;
                                      return liningMaterialYardage;
                                    }
                                  })}
                                </>
                              )}
                            </WorkOrderNumber>
                          ) : null}
                          {this.props.data &&
                            this.props.data.liningsList &&
                            this.props.data.liningsList.length > 0 &&
                            this.props.data.liningsList[1] &&
                            this.props.data.liningsList[1].active && (
                              <WorkOrderNumber>
                                <>
                                  {this.props.data.liningsList.map((item: any) => {
                                    if (
                                      item.draperyOrderLiningsFabric &&
                                      item.draperyOrderLiningsFabric.name === 'INTERLINING FABRIC'
                                    ) {
                                      interliningMaterialYardage =
                                        item.draperyOrderLiningsFabric.yardsNeeded;
                                      return interliningMaterialYardage;
                                    }
                                  })}
                                </>
                              </WorkOrderNumber>
                            )}
                          {this.props.data.othersEmbellishments[0].name &&
                            this.props.data.othersEmbellishments.map((content: any) => {
                              return (
                                <WorkOrderNumber>
                                  {content &&
                                    content.draperyOrderFabric &&
                                    content.draperyOrderFabric.yardsNeeded}
                                </WorkOrderNumber>
                              );
                            })}
                        </SummaryTableCell>
                      )}
                    </SummaryTableCol>
                    <SummaryTableCol text="not-fabrics">
                      <SummaryTableCell
                        className="fabricHeader"
                        position="center"
                        style={{
                          whiteSpace: 'nowrap',
                          fontSize: window.innerWidth < 992 ? '10px' : 'inherit',
                        }}
                      >
                        Unit Price ($)
                      </SummaryTableCell>

                      {workOrderEditMode ? null : (
                        <SummaryTableCell text="fabrics">
                          <WorkOrderNumber>
                            {this.props.data && this.props.data.mainFabric.orderOrigin === 2 ? (
                              <WorkOrderNumber>COM</WorkOrderNumber>
                            ) : (
                              <WorkOrderNumber>
                                {this.state.prices.mainFabricUnitPrice}
                              </WorkOrderNumber>
                            )}
                          </WorkOrderNumber>
                          {this.props.data.workOrderPdfContentSummery.bandingFabricContents.map(
                            (item: any, index: any) => {
                              const bandingUnitPrice = [...this.state.prices.bandingUnitPrice];
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery.bandingFabricContents
                                  .length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery.bandingFabricContents[
                                    i
                                  ].orderOrigin === 2
                                ) {
                                  bandingUnitPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <>
                                  {bandingUnitPrice[index] ? (
                                    <WorkOrderNumber>
                                      {bandingUnitPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.premadeCordingFabricContents.map(
                            (item: any, index: number) => {
                              const cordingUnitPrice = [
                                ...this.state.prices.cordingUnitPrice,
                              ].filter((item) => item.subType === 0);
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery
                                  .premadeCordingFabricContents.length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery
                                    .premadeCordingFabricContents[i].orderOrigin === 2
                                ) {
                                  cordingUnitPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <>
                                  {cordingUnitPrice[index] ? (
                                    <WorkOrderNumber>
                                      {cordingUnitPrice[index].price}{' '}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.premadeFlangeFabricContents.map(
                            (item: any, index: number) => {
                              const flangeUnitPrice = [...this.state.prices.flangeUnitPrice].filter(
                                (item) => item.subType === 0
                              );
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery
                                  .premadeFlangeFabricContents.length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery
                                    .premadeFlangeFabricContents[i].orderOrigin === 2
                                ) {
                                  flangeUnitPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <>
                                  {flangeUnitPrice[index] ? (
                                    <WorkOrderNumber>
                                      {flangeUnitPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents.map(
                            (item: any, index: number) => {
                              const trimUnitPrice = [...this.state.prices.trimUnitPrice].filter(
                                (item) => item.subType === 0
                              );
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents
                                  .length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery
                                    .premadeTrimFabricContents[i].orderOrigin === 2
                                ) {
                                  trimUnitPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <>
                                  {trimUnitPrice[index] ? (
                                    <WorkOrderNumber>{trimUnitPrice[index].price}</WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.weltCordingFabricContents.map(
                            (item: any, index: number) => {
                              const cordingUnitPrice = [
                                ...this.state.prices.cordingUnitPrice,
                              ].filter((item) => item.subType === 1);
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery.weltCordingFabricContents
                                  .length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery
                                    .weltCordingFabricContents[i].orderOrigin === 2
                                ) {
                                  cordingUnitPrice.splice(i, 0, undefined);
                                }
                              }

                              return (
                                <>
                                  {cordingUnitPrice[index] ? (
                                    <WorkOrderNumber>
                                      {cordingUnitPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.fabricFlangeFabricContents.map(
                            (item: any, index: number) => {
                              const flangeUnitPrice = [...this.state.prices.flangeUnitPrice].filter(
                                (item) => item.subType === 1
                              );
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery
                                  .fabricFlangeFabricContents.length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery
                                    .fabricFlangeFabricContents[i].orderOrigin === 2
                                ) {
                                  flangeUnitPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <>
                                  {flangeUnitPrice[index] ? (
                                    <WorkOrderNumber>
                                      {flangeUnitPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.fabricTrimFabricContents.map(
                            (item: any, index: number) => {
                              const trimUnitPrice = [...this.state.prices.trimUnitPrice].filter(
                                (item) => item.subType === 1
                              );
                              // for (
                              //   let i = 0;
                              //   i <
                              //   this.props.data
                              //     .workOrderPdfContentSummery
                              //     .fabricTrimFabricContents
                              //     .length;
                              //   i++
                              // ) {
                              //   if (
                              //     this.props
                              //       .data
                              //       .workOrderPdfContentSummery
                              //       .fabricTrimFabricContents[
                              //       i
                              //     ]
                              //       .orderOrigin ===
                              //     2
                              //   ) {
                              //     trimUnitPrice.splice(
                              //       i,
                              //       0,
                              //       undefined
                              //     );
                              //   }
                              // }
                              return (
                                <>
                                  {trimUnitPrice[index] ? (
                                    <WorkOrderNumber>{trimUnitPrice[index].price}</WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </>
                              );
                            }
                          )}
                          {this.props.data &&
                            this.props.data.liningsList &&
                            this.props.data.liningsList.map((item: any) => {
                              const newItem =
                                item &&
                                item.draperyOrderLiningsFabric &&
                                item.draperyOrderLiningsFabric;

                              if (newItem) {
                                return (
                                  <>
                                    {this.props.data &&
                                    this.props.data.liningsPatternItems &&
                                    item.draperyOrderLiningsFabric.orderOrigin === 2 ? (
                                      <WorkOrderNumber>COM</WorkOrderNumber>
                                    ) : (
                                      <WorkOrderNumber>
                                        {item.name.toLowerCase() === 'lining'
                                          ? this.state.prices.liningsFabricUnitPrice
                                          : this.state.prices.interliningsFabricUnitPrice}
                                      </WorkOrderNumber>
                                    )}
                                  </>
                                );
                              }
                            })}
                          {this.props.data.othersEmbellishments[0].name &&
                            this.props.data.othersEmbellishments.map((item: any, index: number) => {
                              const othersEmbellishmentsUnitPrice = [
                                ...this.state.prices.othersEmbellishmentsUnitPrice,
                              ];
                              // for (
                              //   let i = 0;
                              //   i <
                              //   this.props
                              //     .data
                              //     .othersEmbellishments
                              //     .length;
                              //   i++
                              // ) {
                              //   if (
                              //     this
                              //       .props
                              //       .data
                              //       .othersEmbellishments[
                              //       i
                              //     ]
                              //       .orderOrigin ===
                              //     2
                              //   ) {
                              //     othersEmbellishmentsUnitPrice.splice(
                              //       i,
                              //       0,
                              //       undefined
                              //     );
                              //   }
                              // }
                              return (
                                <>
                                  {othersEmbellishmentsUnitPrice[index] &&
                                  item.draperyOrderFabric.orderOrigin &&
                                  item.draperyOrderFabric.orderOrigin === 1 ? (
                                    <WorkOrderNumber>
                                      {othersEmbellishmentsUnitPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </>
                              );
                            })}
                        </SummaryTableCell>
                      )}
                    </SummaryTableCol>{' '}
                    <SummaryTableCol text="not-fabrics">
                      <SummaryTableCell
                        className="fabricHeader"
                        position="center"
                        style={{
                          whiteSpace: 'nowrap',
                          fontSize: window.innerWidth < 992 ? '10px' : 'inherit',
                        }}
                      >
                        S+H ($)
                      </SummaryTableCell>

                      {workOrderEditMode ? null : (
                        <SummaryTableCell text="fabrics">
                          {this.props.data &&
                          this.props.data.fabricsPatternItems &&
                          this.props.data.mainFabric.orderOrigin === 2 ? (
                            <WorkOrderNumber>COM</WorkOrderNumber>
                          ) : (
                            <WorkOrderNumber>
                              {this.state.prices.mainFabricShippingPrice}
                            </WorkOrderNumber>
                          )}
                          {this.props.data.workOrderPdfContentSummery.bandingFabricContents.map(
                            (item: any, index: number) => {
                              const bandingShippingPrice = [
                                ...this.state.prices.bandingShippingPrice,
                              ];
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery.bandingFabricContents
                                  .length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery.bandingFabricContents[
                                    i
                                  ].orderOrigin === 2
                                ) {
                                  bandingShippingPrice.splice(i, 0, undefined);
                                }
                              }

                              return (
                                <div>
                                  {bandingShippingPrice[index] ? (
                                    <WorkOrderNumber>
                                      {bandingShippingPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </div>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.premadeCordingFabricContents.map(
                            (item: any, index: number) => {
                              const cordingShippingPrice = [
                                ...this.state.prices.cordingShippingPrice,
                              ].filter((item) => item.subType === 0);
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery
                                  .premadeCordingFabricContents.length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery
                                    .premadeCordingFabricContents[i].orderOrigin === 2
                                ) {
                                  cordingShippingPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <div>
                                  {cordingShippingPrice[index] ? (
                                    <WorkOrderNumber>
                                      {cordingShippingPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </div>
                              );
                            }
                          )}

                          {this.props.data.workOrderPdfContentSummery.premadeFlangeFabricContents.map(
                            (item: any, index: number) => {
                              const flangeShippingPrice = [
                                ...this.state.prices.flangeShippingPrice,
                              ].filter((item) => item.subType === 0);
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery
                                  .premadeFlangeFabricContents.length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery
                                    .premadeFlangeFabricContents[i].orderOrigin === 2
                                ) {
                                  flangeShippingPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <div>
                                  {flangeShippingPrice[index] ? (
                                    <WorkOrderNumber>
                                      {flangeShippingPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </div>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents.map(
                            (item: any, index: number) => {
                              const trimShippingPrice = [
                                ...this.state.prices.trimShippingPrice,
                              ].filter((item) => item.subType === 0);
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents
                                  .length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery
                                    .premadeTrimFabricContents[i].orderOrigin === 2
                                ) {
                                  trimShippingPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <div>
                                  {trimShippingPrice[index] ? (
                                    <WorkOrderNumber>
                                      {trimShippingPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </div>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.weltCordingFabricContents.map(
                            (item: any, index: number) => {
                              const cordingShippingPrice = [
                                ...this.state.prices.cordingShippingPrice,
                              ].filter((item) => item.subType === 1);
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery.weltCordingFabricContents
                                  .length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery
                                    .weltCordingFabricContents[i].orderOrigin === 2
                                ) {
                                  cordingShippingPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <div>
                                  {cordingShippingPrice[index] ? (
                                    <WorkOrderNumber>
                                      {cordingShippingPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </div>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.fabricFlangeFabricContents.map(
                            (item: any, index: number) => {
                              const flangeShippingPrice = [
                                ...this.state.prices.flangeShippingPrice,
                              ].filter((item) => item.subType === 1);
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery
                                  .fabricFlangeFabricContents.length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery
                                    .fabricFlangeFabricContents[i].orderOrigin === 2
                                ) {
                                  flangeShippingPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <div>
                                  {flangeShippingPrice[index] ? (
                                    <WorkOrderNumber>
                                      {flangeShippingPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </div>
                              );
                            }
                          )}
                          {this.props.data.workOrderPdfContentSummery.fabricTrimFabricContents.map(
                            (item: any, index: number) => {
                              const trimShippingPrice = [
                                ...this.state.prices.trimShippingPrice,
                              ].filter((item) => item.subType === 1);
                              for (
                                let i = 0;
                                i <
                                this.props.data.workOrderPdfContentSummery.fabricTrimFabricContents
                                  .length;
                                i++
                              ) {
                                if (
                                  this.props.data.workOrderPdfContentSummery
                                    .fabricTrimFabricContents[i].orderOrigin === 2
                                ) {
                                  trimShippingPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <div>
                                  {trimShippingPrice[index] ? (
                                    <WorkOrderNumber>
                                      {trimShippingPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </div>
                              );
                            }
                          )}
                          {this.props.data.liningsList.map((item: any) => {
                            const newItem =
                              item &&
                              item.draperyOrderLiningsFabric &&
                              item.draperyOrderLiningsFabric;
                            if (newItem) {
                              return (
                                <div>
                                  {this.props.data &&
                                  this.props.data.liningsPatternItems &&
                                  item.draperyOrderLiningsFabric.orderOrigin === 2 ? (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>
                                      {item.name.toLowerCase().startsWith('lining')
                                        ? this.state.prices.liningsFabricShippingPrice
                                        : this.state.prices.interliningsFabricShippingPrice}
                                    </WorkOrderNumber>
                                  )}
                                </div>
                              );
                            }
                          })}
                          {this.props.data.othersEmbellishments[0].name &&
                            this.props.data.othersEmbellishments.map((item: any, index: number) => {
                              const othersEmbellishmentsShippingPrice = [
                                ...this.state.prices.othersEmbellishmentsShippingPrice,
                              ];
                              for (
                                let i = 0;
                                i < this.props.data.othersEmbellishments.length;
                                i++
                              ) {
                                if (this.props.data.othersEmbellishments[i].orderOrigin === 2) {
                                  othersEmbellishmentsShippingPrice.splice(i, 0, undefined);
                                }
                              }
                              return (
                                <div>
                                  {othersEmbellishmentsShippingPrice[index] ? (
                                    <WorkOrderNumber>
                                      {othersEmbellishmentsShippingPrice[index].price}
                                    </WorkOrderNumber>
                                  ) : (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  )}
                                </div>
                              );
                            })}
                        </SummaryTableCell>
                      )}
                    </SummaryTableCol>{' '}
                    <SummaryTableCol text="not-fabrics">
                      <SummaryTableCell
                        position="center"
                        style={{
                          whiteSpace: 'nowrap',
                          fontSize: window.innerWidth < 992 ? '10px' : 'inherit',
                        }}
                      >
                        Total Price ($)
                      </SummaryTableCell>

                      {workOrderEditMode ? null : (
                        <SummaryTableCell text="fabrics" last="last">
                          <WorkOrderNumber>
                            {this.props.data &&
                            this.props.data.fabricsPatternItems &&
                            this.props.data.mainFabric.orderOrigin === 1 ? (
                              (
                                parseFloat(this.state.prices.mainFabricUnitPrice) *
                                  (this.props.data.workOrderPdfContentSummery.mainFabricContent
                                    .yardsNeeded || 1) +
                                parseFloat(this.state.prices.mainFabricShippingPrice)
                              ).toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            ) : (
                              <WorkOrderNumber>COM</WorkOrderNumber>
                            )}
                          </WorkOrderNumber>
                          {this.props.data &&
                            this.props.data.workOrderPdfContent &&
                            this.props.data.workOrderPdfContent.bandingFabricContents &&
                            this.props.data.workOrderPdfContent.bandingFabricContents.map(
                              (item: any, index: number) => {
                                const bandingShippingPrice = [
                                  ...this.state.prices.bandingShippingPrice,
                                ];
                                const bandingUnitPrice = [...this.state.prices.bandingUnitPrice];
                                for (
                                  let i = 0;
                                  i <
                                  this.props.data.workOrderPdfContentSummery.bandingFabricContents
                                    .length;
                                  i++
                                ) {
                                  if (
                                    this.props.data.workOrderPdfContentSummery
                                      .bandingFabricContents[i].orderOrigin === 2
                                  ) {
                                    bandingShippingPrice.splice(i, 0, undefined);
                                    bandingUnitPrice.splice(i, 0, undefined);
                                  }
                                }

                                return (
                                  <div>
                                    <WorkOrderNumber>
                                      {this.props.data && this.props.data.fabricsPatternItems ? (
                                        bandingUnitPrice[index] && bandingShippingPrice[index] ? (
                                          (
                                            parseFloat(bandingUnitPrice[index].price) *
                                              (item.yardsNeeded || 1) +
                                            parseFloat(bandingShippingPrice[index].price)
                                          ).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                        ) : (
                                          'COM'
                                        )
                                      ) : (
                                        <WorkOrderNumber>0.00</WorkOrderNumber>
                                      )}
                                    </WorkOrderNumber>
                                  </div>
                                );
                              }
                            )}
                          {this.props.data &&
                            this.props.data.workOrderPdfContent &&
                            this.props.data.workOrderPdfContent.premadeCordingFabricContents &&
                            this.props.data.workOrderPdfContent.premadeCordingFabricContents.map(
                              (item: any, index: number) => {
                                const cordingUnitPrice = [
                                  ...this.state.prices.cordingUnitPrice,
                                ].filter((item) => item.subType === 0);
                                const cordingShippingPrice = [
                                  ...this.state.prices.cordingShippingPrice,
                                ].filter((item) => item.subType === 0);
                                for (
                                  let i = 0;
                                  i <
                                  this.props.data.workOrderPdfContentSummery
                                    .premadeCordingFabricContents.length;
                                  i++
                                ) {
                                  if (
                                    this.props.data.workOrderPdfContentSummery
                                      .premadeCordingFabricContents[i].orderOrigin === 2
                                  ) {
                                    cordingUnitPrice.splice(i, 0, undefined);
                                    cordingShippingPrice.splice(i, 0, undefined);
                                  }
                                }
                                return (
                                  <div>
                                    <WorkOrderNumber>
                                      {this.props.data && this.props.data.fabricsPatternItems ? (
                                        cordingUnitPrice[index] && cordingShippingPrice[index] ? (
                                          (
                                            parseFloat(cordingUnitPrice[index].price) *
                                              (item.yardsNeeded || 1) +
                                            parseFloat(cordingShippingPrice[index].price)
                                          ).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                        ) : (
                                          'COM'
                                        )
                                      ) : (
                                        <WorkOrderNumber>0.00</WorkOrderNumber>
                                      )}
                                    </WorkOrderNumber>
                                  </div>
                                );
                              }
                            )}
                          {this.props.data &&
                            this.props.data.workOrderPdfContent &&
                            this.props.data.workOrderPdfContent.premadeFlangeFabricContents &&
                            this.props.data.workOrderPdfContent.premadeFlangeFabricContents.map(
                              (item: any, index: number) => {
                                const flangeUnitPrice = [
                                  ...this.state.prices.flangeUnitPrice,
                                ].filter((item) => item.subType === 0);
                                const flangeShippingPrice = [
                                  ...this.state.prices.flangeShippingPrice,
                                ].filter((item) => item.subType === 0);
                                for (
                                  let i = 0;
                                  i <
                                  this.props.data.workOrderPdfContentSummery
                                    .premadeFlangeFabricContents.length;
                                  i++
                                ) {
                                  if (
                                    this.props.data.workOrderPdfContentSummery
                                      .premadeFlangeFabricContents[i].orderOrigin === 2
                                  ) {
                                    flangeUnitPrice.splice(i, 0, undefined);
                                    flangeShippingPrice.splice(i, 0, undefined);
                                  }
                                }

                                return (
                                  <div>
                                    <WorkOrderNumber>
                                      {this.props.data && this.props.data.fabricsPatternItems ? (
                                        flangeUnitPrice[index] && flangeShippingPrice[index] ? (
                                          (
                                            (item.yardsNeeded || 1) *
                                              parseFloat(flangeUnitPrice[index].price) +
                                            parseFloat(flangeShippingPrice[index].price)
                                          ).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                        ) : (
                                          'COM'
                                        )
                                      ) : (
                                        <WorkOrderNumber>0.00</WorkOrderNumber>
                                      )}
                                    </WorkOrderNumber>
                                  </div>
                                );
                              }
                            )}
                          {this.props.data &&
                            this.props.data.workOrderPdfContent &&
                            this.props.data.workOrderPdfContent.premadeTrimFabricContents &&
                            this.props.data.workOrderPdfContent.premadeTrimFabricContents.map(
                              (item: any, index: number) => {
                                const trimUnitPrice = [...this.state.prices.trimUnitPrice].filter(
                                  (item) => item.subType === 0
                                );
                                const trimShippingPrice = [
                                  ...this.state.prices.trimShippingPrice,
                                ].filter((item) => item.subType === 0);
                                // for (
                                //   let i = 0;
                                //   i <
                                //   this.props
                                //     .data
                                //     .workOrderPdfContentSummery
                                //     .premadeTrimFabricContents
                                //     .length;
                                //   i++
                                // ) {
                                //   if (
                                //     this
                                //       .props
                                //       .data
                                //       .workOrderPdfContentSummery
                                //       .premadeTrimFabricContents[
                                //       i
                                //     ]
                                //       .orderOrigin ===
                                //     2
                                //   ) {
                                //     trimUnitPrice.splice(
                                //       i,
                                //       0,
                                //       undefined
                                //     );
                                //     trimShippingPrice.splice(
                                //       i,
                                //       0,
                                //       undefined
                                //     );
                                //   }
                                // }
                                return (
                                  <div>
                                    <WorkOrderNumber>
                                      {this.props.data && this.props.data.fabricsPatternItems ? (
                                        trimUnitPrice[index] && trimShippingPrice[index] ? (
                                          (
                                            (item.yardsNeeded || 1) *
                                              parseFloat(trimUnitPrice[index].price) +
                                            parseFloat(trimShippingPrice[index].price)
                                          ).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                        ) : (
                                          'COM'
                                        )
                                      ) : (
                                        <WorkOrderNumber>0.00</WorkOrderNumber>
                                      )}
                                    </WorkOrderNumber>
                                  </div>
                                );
                              }
                            )}
                          {this.props.data &&
                            this.props.data.workOrderPdfContent &&
                            this.props.data.workOrderPdfContent.weltCordingFabricContents &&
                            this.props.data.workOrderPdfContent.weltCordingFabricContents.map(
                              (item: any, index: number) => {
                                const cordingUnitPrice = [
                                  ...this.state.prices.cordingUnitPrice,
                                ].filter((item) => item.subType === 1);
                                const cordingShippingPrice = [
                                  ...this.state.prices.cordingShippingPrice,
                                ].filter((item) => item.subType === 1);
                                for (
                                  let i = 0;
                                  i <
                                  this.props.data.workOrderPdfContentSummery
                                    .weltCordingFabricContents.length;
                                  i++
                                ) {
                                  if (
                                    this.props.data.workOrderPdfContentSummery
                                      .weltCordingFabricContents[i].orderOrigin === 2
                                  ) {
                                    cordingUnitPrice.splice(i, 0, undefined);
                                    cordingShippingPrice.splice(i, 0, undefined);
                                  }
                                }
                                return (
                                  <div>
                                    <WorkOrderNumber>
                                      {this.props.data && this.props.data.fabricsPatternItems ? (
                                        cordingUnitPrice[index] && cordingShippingPrice[index] ? (
                                          (
                                            (item.yardsNeeded || 1) *
                                              parseFloat(cordingUnitPrice[index].price) +
                                            parseFloat(cordingShippingPrice[index].price)
                                          ).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                        ) : (
                                          'COM'
                                        )
                                      ) : (
                                        <WorkOrderNumber>0.00</WorkOrderNumber>
                                      )}
                                    </WorkOrderNumber>
                                  </div>
                                );
                              }
                            )}
                          {this.props.data &&
                            this.props.data.workOrderPdfContent &&
                            this.props.data.workOrderPdfContent.fabricFlangeFabricContents &&
                            this.props.data.workOrderPdfContent.fabricFlangeFabricContents.map(
                              (item: any, index: number) => {
                                const flangeUnitPrice = [
                                  ...this.state.prices.flangeUnitPrice,
                                ].filter((item) => item.subType === 1);
                                const flangeShippingPrice = [
                                  ...this.state.prices.flangeShippingPrice,
                                ].filter((item) => item.subType === 1);
                                for (
                                  let i = 0;
                                  i <
                                  this.props.data.workOrderPdfContentSummery
                                    .fabricFlangeFabricContents.length;
                                  i++
                                ) {
                                  if (
                                    this.props.data.workOrderPdfContentSummery
                                      .fabricFlangeFabricContents[i].orderOrigin === 2
                                  ) {
                                    flangeUnitPrice.splice(i, 0, undefined);
                                    flangeShippingPrice.splice(i, 0, undefined);
                                  }
                                }
                                return (
                                  <div>
                                    <WorkOrderNumber>
                                      {this.props.data && this.props.data.fabricsPatternItems ? (
                                        flangeUnitPrice[index] && flangeShippingPrice[index] ? (
                                          (
                                            (item.yardsNeeded || 1) *
                                              parseFloat(flangeUnitPrice[index].price) +
                                            parseFloat(flangeShippingPrice[index].price)
                                          ).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                        ) : (
                                          'COM'
                                        )
                                      ) : (
                                        <WorkOrderNumber>0.00</WorkOrderNumber>
                                      )}
                                    </WorkOrderNumber>
                                  </div>
                                );
                              }
                            )}
                          {this.props.data &&
                            this.props.data.workOrderPdfContent &&
                            this.props.data.workOrderPdfContent.fabricTrimFabricContents &&
                            this.props.data.workOrderPdfContent.fabricTrimFabricContents.map(
                              (item: any, index: number) => {
                                const trimUnitPrice = [...this.state.prices.trimUnitPrice].filter(
                                  (item) => item.subType === 1
                                );
                                const trimShippingPrice = [
                                  ...this.state.prices.trimShippingPrice,
                                ].filter((item) => item.subType === 1);
                                // for (
                                //   let i = 0;
                                //   i <
                                //   this.props
                                //     .data
                                //     .workOrderPdfContentSummery
                                //     .fabricTrimFabricContents
                                //     .length;
                                //   i++
                                // ) {
                                //   if (
                                //     this
                                //       .props
                                //       .data
                                //       .workOrderPdfContentSummery
                                //       .fabricTrimFabricContents[
                                //       i
                                //     ]
                                //       .orderOrigin ===
                                //     2
                                //   ) {
                                //     trimUnitPrice.splice(
                                //       i,
                                //       0,
                                //       undefined
                                //     );
                                //     trimShippingPrice.splice(
                                //       i,
                                //       0,
                                //       undefined
                                //     );
                                //   }
                                // }
                                return (
                                  <div>
                                    <WorkOrderNumber>
                                      {this.props.data && this.props.data.fabricsPatternItems ? (
                                        trimUnitPrice[index] && trimShippingPrice[index] ? (
                                          (
                                            (item.yardsNeeded || 1) *
                                              parseFloat(trimUnitPrice[index].price) +
                                            parseFloat(trimShippingPrice[index].price)
                                          ).toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          })
                                        ) : (
                                          'COM'
                                        )
                                      ) : (
                                        <WorkOrderNumber>0.00</WorkOrderNumber>
                                      )}
                                    </WorkOrderNumber>
                                  </div>
                                );
                              }
                            )}
                          {this.props.data &&
                            this.props.data.liningsList.map((item: any) => {
                              const liningTotal =
                                (liningMaterialYardage || 1) *
                                  parseFloat(this.state.prices.liningsFabricUnitPrice) +
                                parseFloat(this.state.prices.liningsFabricShippingPrice);
                              const interliningTotal =
                                (interliningMaterialYardage || 1) *
                                  parseFloat(this.state.prices.interliningsFabricUnitPrice) +
                                parseFloat(this.state.prices.interliningsFabricShippingPrice);
                              const liningIncludedText =
                                showBundleColumn &&
                                liningBundleSelected &&
                                Number.isFinite(liningTotal)
                                  ? 'included in bundle price'
                                  : '';
                              const interliningIncludedText =
                                showBundleColumn &&
                                liningBundleSelected &&
                                Number.isFinite(interliningTotal)
                                  ? 'included in bundle price'
                                  : '';

                              return (
                                <div>
                                  {this.props.data &&
                                  this.props.data.fabricsPatternItems &&
                                  item.draperyOrderLiningsFabric &&
                                  item.draperyOrderLiningsFabric.orderOrigin === 1 ? (
                                    item.name === 'Lining' ? (
                                      <WorkOrderNumber>
                                        {liningTotal.toLocaleString('en-US', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                        <p className="text-sm text-slate-400">
                                          {liningIncludedText}
                                        </p>
                                      </WorkOrderNumber>
                                    ) : (
                                      <WorkOrderNumber>
                                        {interliningTotal.toLocaleString('en-US', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}
                                        <p className="text-sm text-slate-400">
                                          {interliningIncludedText}
                                        </p>
                                      </WorkOrderNumber>
                                    )
                                  ) : this.props.data &&
                                    this.props.data.fabricsPatternItems &&
                                    item.draperyOrderLiningsFabric &&
                                    item.draperyOrderLiningsFabric.orderOrigin === 2 ? (
                                    <WorkOrderNumber>COM</WorkOrderNumber>
                                  ) : null}
                                </div>
                              );
                            })}
                          {this.props.data &&
                            this.props.data.othersEmbellishments &&
                            this.props.data.othersEmbellishments[0].name &&
                            this.props.data.othersEmbellishments.map((item: any, index: number) => {
                              const othersEmbellishmentsUnitPrice = [
                                ...this.state.prices.othersEmbellishmentsUnitPrice,
                              ];
                              const othersEmbellishmentsShippingPrice = [
                                ...this.state.prices.othersEmbellishmentsShippingPrice,
                              ];
                              // for (
                              //   let i = 0;
                              //   i <
                              //   this.props
                              //     .data
                              //     .othersEmbellishments
                              //     .length;
                              //   i++
                              // ) {
                              //   if (
                              //     this
                              //       .props
                              //       .data
                              //       .othersEmbellishments[
                              //       i
                              //     ]
                              //       .orderOrigin ===
                              //     2
                              //   ) {
                              //     othersEmbellishmentsUnitPrice.splice(
                              //       i,
                              //       0,
                              //       undefined
                              //     );
                              //     othersEmbellishmentsShippingPrice.splice(
                              //       i,
                              //       0,
                              //       undefined
                              //     );
                              //   }
                              // }
                              return (
                                <div>
                                  <WorkOrderNumber>
                                    {this.props.data && this.props.data.fabricsPatternItems ? (
                                      othersEmbellishmentsUnitPrice[index] &&
                                      othersEmbellishmentsShippingPrice[index] ? (
                                        (
                                          (item &&
                                          item.draperyOrderFabric &&
                                          item.draperyOrderFabric.yardsNeeded === 0
                                            ? 0
                                            : (item &&
                                                item.draperyOrderFabric &&
                                                item.draperyOrderFabric.yardsNeeded) ||
                                              1) *
                                            parseFloat(othersEmbellishmentsUnitPrice[index].price) +
                                          parseFloat(othersEmbellishmentsShippingPrice[index].price)
                                        ).toLocaleString('en-US', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                      ) : (
                                        'COM'
                                      )
                                    ) : (
                                      <WorkOrderNumber>0.00</WorkOrderNumber>
                                    )}
                                  </WorkOrderNumber>
                                </div>
                              );
                            })}
                        </SummaryTableCell>
                      )}
                    </SummaryTableCol>
                  </SummaryTable>

                  {workOrderEditMode &&
                    (loadingUpdate ? (
                      <div className="work_order_edit_mode_alert_container"></div>
                    ) : (
                      <div className="work_order_edit_mode_alert_container">
                        <RedWarning />
                        <p className="work_order_edit_mode_alert_message">
                          This field will be re-calculated after update
                        </p>
                      </div>
                    ))}
                </HContainer>
              ) : this.props.data.orderType === 'roman-shade-order' ? (
                <HContainer text="fabrics" uiColumnDirection>
                  <div className="w-full">
                    <table className="w-full [&_td]:p-0 [&_td]:m-0 [&_td]:border-r [&_td]:border-input">
                      <thead className="bg-[#ecf6f9] text-[#3b97b1]">
                        <tr>
                          <th className="font-medium p-[24px] text-left">
                            <div>Components</div>
                          </th>
                          <th className="font-medium p-[24px]">
                            <div>Quantity</div>
                          </th>
                          <th className="font-medium p-[24px]">
                            <div>Unit Price ($)</div>
                          </th>
                          <th className="font-medium p-[24px]">
                            <div>S+H ($)</div>
                          </th>
                          <th className="font-medium p-[24px]">
                            <div>Total Price ($)</div>
                          </th>
                          {showBundleColumn && (
                            <th className="font-medium p-[12px]">
                              <div className="flex items-center justify-center gap-[6px]">
                                Bundle
                                <Tooltip open={this.state.isSecondBundleToolTipOpen}>
                                  <TooltipTrigger asChild ref={this.secondTooltipTriggerRef}>
                                    <button
                                      type="button"
                                      className="flex w-5 items-center justify-center transition-colors"
                                      aria-label="Bundling details"
                                      aria-expanded={this.state.isSecondBundleToolTipOpen}
                                      onClick={() => this.handleBundleTooltipOpen('second')}
                                    >
                                      <HelpIcon className="h-4 w-4" />
                                    </button>
                                  </TooltipTrigger>
                                  <TooltipContent
                                    className="relative max-w-[320px] whitespace-pre-wrap rounded-[10px] border border-[#E5E7EB] bg-white px-4 py-4 pr-9 text-[14px] leading-[1.6] text-[#111827] shadow-[0_8px_24px_rgba(0,0,0,0.12)]"
                                    arrowClassName="fill-white"
                                    sideOffset={8}
                                    ref={this.secondTooltipContentRef}
                                  >
                                    <button
                                      type="button"
                                      className="absolute right-3 top-3 text-[#6B7280] hover:text-[#111827]"
                                      onClick={this.handleBundleTooltipClose}
                                      aria-label="Close bundling details"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      >
                                        <path d="M18 6 6 18"></path>
                                        <path d="m6 6 12 12"></path>
                                      </svg>
                                    </button>
                                    The estimate description and price for selected components are
                                    combined into one line item with fabrication for customer-facing
                                    estimates. Each bundled component appears as an itemized part of
                                    the bundle internally for QuickBooks accounting and reporting.
                                    Components not selected appear as separate line items on the
                                    customer-facing estimate.
                                  </TooltipContent>
                                </Tooltip>
                              </div>
                            </th>
                          )}
                        </tr>
                        {draperyOrderHeadrail?.headrailAdditionalPriceAdjustmentType &&
                          draperyOrderHeadrail?.headrailAdditionalPriceAdjustmentType !==
                            'none' && (
                            <tr>
                              <th></th>
                              <th></th>
                              <th
                                colSpan={2}
                                className="text-center py-0.5 text-xs text-muted-foreground italic"
                              >
                                <div className="flex items-center justify-center gap-1">
                                  <CheckmarkIcon className="h-4 w-4" />
                                  <span className="font-normal">
                                    {draperyOrderHeadrail?.headrailAdditionalPriceAdjustment}%
                                    Client{' '}
                                    {draperyOrderHeadrail?.headrailAdditionalPriceAdjustmentType ===
                                      'discount' || additionalPriceAdjustment === 'discount'
                                      ? 'Discount'
                                      : 'Markup'}{' '}
                                    Included{' '}
                                  </span>
                                </div>
                              </th>
                              <th></th>
                              <th></th>
                            </tr>
                          )}
                      </thead>

                      <tbody>
                        <tr>
                          <td>
                            <div>
                              <div className="p-[13px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-left">
                                <div>
                                  <p className="font-bold">
                                    {this.props.data.mainFabric && this.props.data.mainFabric.name}
                                  </p>
                                  {this.renderEstimateDescriptionParagraphs(
                                    this.props.data.mainFabric,
                                    this.props.data?.fabricsPatternItems
                                  )}
                                </div>
                                {this.shouldRenderLegacyComponentMeasurements(
                                  this.props.data.mainFabric
                                ) && (
                                  <WorkorderMeasureWrapper>
                                    {this.props.data &&
                                      this.props.data.fabricsPatternItems &&
                                      Object.entries(this.props.data.mainFabric.values)
                                        .sort((a, b): any => {
                                          const [keyA] = a;
                                          const [keyB] = b;

                                          if (keyA === 'horizontalRepeat') return 1;
                                          if (keyB === 'horizontalRepeat') return -1;
                                          if (keyA === 'fabricWidth') return -1;
                                          if (keyB === 'fabricWidth') return 1;
                                          return 0;
                                        })
                                        .map(([key, value]) => {
                                          if (
                                            value === null ||
                                            value === '' ||
                                            value === undefined
                                          ) {
                                            return;
                                          }
                                          const unit =
                                            key === 'horizontalRepeat'
                                              ? 2
                                              : key === 'fabricWidth'
                                                ? 0
                                                : 1;
                                          return (
                                            <WorkorderMeasure
                                              className="last-separator"
                                              style={{
                                                color: '#545454',
                                              }}
                                            >
                                              <span> {property[unit]}</span>
                                              <p>
                                                {value}"<span>/</span>
                                              </p>
                                            </WorkorderMeasure>
                                          );
                                        })}
                                  </WorkorderMeasureWrapper>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div>
                              <div className="p-[13px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                {this.props.draperyOrder.newRomanShade ||
                                !this.props.draperyOrder.id ? (
                                  this.props.workOrderEditMode || !this.props.data.workOrder.id ? (
                                    <span>TBD</span>
                                  ) : (
                                    <span>{this.props.yardage.mainFabricYardage || 'TBD'}</span>
                                  )
                                ) : (
                                  <CalculatorFieldInput
                                    uiWidth={180}
                                    style={{
                                      margin: '0 auto',
                                      border: '1px solid #b3b3b3',
                                      borderRadius: '0.5rem',
                                    }}
                                  >
                                    <CalculatorYardageInput
                                      id="mainFabricYardage"
                                      name="mainFabricYardage"
                                      type="text"
                                      value={this.props.yardage.mainFabricYardage || ''}
                                      onChange={this.props.setYardage}
                                      disabled={
                                        !(workOrderEditMode || isCreateMode) &&
                                        this.props.workOrder.id !== 0
                                      }
                                      uiDisabled={
                                        !(workOrderEditMode || isCreateMode) &&
                                        this.props.workOrder.id !== 0
                                      }
                                    />
                                  </CalculatorFieldInput>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data && this.props.data.mainFabric.orderOrigin === 2 ? (
                                <div className="p-[13px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                  COM
                                </div>
                              ) : (
                                <div className="p-[13px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                  {this.props.data.fabricsPatternItems &&
                                  this.props.data.mainFabric.pattern
                                    ? this.getPricingSectionPrice(
                                        this.props.data.fabricsPatternItems?.find(
                                          (fabricPattern: any) =>
                                            fabricPattern.name ===
                                            this.props.data.mainFabric.pattern
                                        ) || {}
                                      )
                                    : ''}
                                </div>
                              )}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data && this.props.data.mainFabric.orderOrigin === 2 ? (
                                <div className="p-[13px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                  COM
                                </div>
                              ) : (
                                <div className="p-[13px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                  {shippingPriceMainFabric}
                                </div>
                              )}
                            </div>
                          </td>
                          <td>
                            <div>
                              <div className="p-[13px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                {this.props.workOrderEditMode
                                  ? this.props.data.mainFabric.orderOrigin !== 2
                                    ? 'TBD'
                                    : 'COM'
                                  : this.props.data &&
                                      this.props.data.fabricsPatternItems &&
                                      !['', null, undefined].includes(
                                        this.props.yardage.mainFabricYardage
                                      )
                                    ? this.props.data.mainFabric.orderOrigin === 1 &&
                                      this.props.data.mainFabric.pattern &&
                                      (this.props.data.mainFabric.patternId ||
                                        this.props.data.fabricsPatternItems?.find(
                                          (fabricPattern: any) =>
                                            fabricPattern.name ===
                                            this.props.data.mainFabric.pattern
                                        ))
                                      ? (
                                          parseFloat(
                                            this.props.data.fabricsPatternItems &&
                                              this.props.data.mainFabric.pattern
                                              ? this.getPricingSectionPrice(
                                                  this.props.data.fabricsPatternItems?.find(
                                                    (fabricPattern: any) =>
                                                      fabricPattern.name ===
                                                      this.props.data.mainFabric.pattern
                                                  ) || {}
                                                ) || '0.00'
                                              : '0.00'
                                          ) *
                                            (this.props.yardage.mainFabricYardage !== '0' &&
                                            this.props.yardage.mainFabricYardage !== null
                                              ? +this.props.yardage.mainFabricYardage
                                              : 1) +
                                          +shippingPriceMainFabric
                                        ).toLocaleString('en-US', {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                      : this.props.data.mainFabric.orderOrigin !== 2
                                        ? ''
                                        : 'COM'
                                    : this.props.data.mainFabric.orderOrigin !== 2
                                      ? 'TBD'
                                      : 'COM'}
                              </div>
                            </div>
                          </td>
                          {showBundleColumn && (
                            <td>
                              <div>
                                <div className="p-[13px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                  <Checkbox
                                    checked={mainFabricBundleSelected}
                                    onCheckedChange={() => {
                                      handleBundleConfigSettings('mainFabric');
                                    }}
                                  />
                                </div>
                              </div>
                            </td>
                          )}
                        </tr>

                        <tr>
                          <td>
                            <div>
                              {this.props.data.trims
                                .filter((item: any) => item.subType === 0)
                                .map((item: any) => {
                                  const newItem =
                                    item &&
                                    item.draperyOrderFabric &&
                                    item.draperyOrderFabric.pattern;
                                  return item.draperyOrderFabric ? (
                                    <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-left">
                                      <div>
                                        <p className="font-bold">{item.draperyOrderFabric.name}</p>
                                        {this.renderEstimateDescriptionParagraphs(
                                          item.draperyOrderFabric,
                                          this.props.data?.fabricsPatternItems
                                        )}
                                        {this.shouldRenderLegacyComponentMeasurements(
                                          item.draperyOrderFabric
                                        ) &&
                                          item.draperyOrderFabric.values.trimWidth && (
                                            <div>
                                              <span>W:</span>
                                              {item.draperyOrderFabric.values.trimWidth}"
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  ) : null;
                                })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data.trims
                                .filter((item: any) => item.subType === 0)
                                .map((content: any, index: any) => {
                                  return content.draperyOrderFabric ? (
                                    <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                      {this.props.draperyOrder.newRomanShade ||
                                      !this.props.draperyOrder.id ? (
                                        this.props.workOrderEditMode ? (
                                          <span>TBD</span>
                                        ) : (
                                          <span>
                                            {this.props.yardage.trimsPreMadeYardage[index] || 'TBD'}
                                          </span>
                                        )
                                      ) : (
                                        <CalculatorFieldInput
                                          uiWidth={180}
                                          style={{
                                            margin: '-24px auto 0px auto',
                                            border: '1px solid #b3b3b3',
                                            borderRadius: '0.5rem',
                                          }}
                                        >
                                          <CalculatorYardageInput
                                            id={`trimsPreMadeYardage.${index}`}
                                            name={`trimsPreMadeYardage.${index}`}
                                            type="number"
                                            value={
                                              this.props.yardage.trimsPreMadeYardage[index] || ''
                                            }
                                            onChange={this.props.setYardage}
                                            disabled={
                                              !(workOrderEditMode || isCreateMode) &&
                                              this.props.workOrder.id !== 0
                                            }
                                            uiDisabled={
                                              !(workOrderEditMode || isCreateMode) &&
                                              this.props.workOrder.id !== 0
                                            }
                                          />
                                        </CalculatorFieldInput>
                                      )}
                                    </div>
                                  ) : null;
                                })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data.trims
                                .filter((item: any) => item.subType === 0)
                                .map((item: any, index: number) => {
                                  let trimUnitPrice: any = [];
                                  if (item.draperyOrderFabric && item.draperyOrderFabric.pattern) {
                                    const trimItem =
                                      this.props.data.fabricsPatternItems &&
                                      this.props.data.fabricsPatternItems?.find(
                                        (fabricPattern: any) =>
                                          fabricPattern.name === item.draperyOrderFabric.pattern
                                      );
                                    trimUnitPrice[index] = this.getPricingSectionPrice(
                                      trimItem || {}
                                    );
                                  }
                                  return item.draperyOrderFabric ? (
                                    <>
                                      {trimUnitPrice[index] &&
                                      item.draperyOrderFabric.orderOrigin &&
                                      item.draperyOrderFabric.orderOrigin === 1 ? (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          {trimUnitPrice[index]}
                                        </div>
                                      ) : item.draperyOrderFabric.orderOrigin === 2 ? (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          COM
                                        </div>
                                      ) : (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          {''}
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    ''
                                  );
                                })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data.trims
                                .filter((item: any) => item.subType === 0)
                                .map((item: any, index: any) => {
                                  let trimShippingPrice: any = [];
                                  if (item.draperyOrderFabric && item.draperyOrderFabric.pattern) {
                                    const trimItem =
                                      this.props.data.fabricsPatternItems &&
                                      this.props.data.fabricsPatternItems?.find(
                                        (fabricPattern: any) =>
                                          fabricPattern.name === item.draperyOrderFabric.pattern
                                      );
                                    trimShippingPrice[index] = trimItem
                                      ? trimItem.shippingCost || '0.00'
                                      : '';
                                  }
                                  return item.draperyOrderFabric ? (
                                    <>
                                      {shippingPriceTrim[index] &&
                                      item.draperyOrderFabric.orderOrigin &&
                                      item.draperyOrderFabric.orderOrigin === 1 ? (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          {shippingPriceTrim[index].price}
                                        </div>
                                      ) : item.draperyOrderFabric.orderOrigin === 2 ? (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          COM
                                        </div>
                                      ) : (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center"></div>
                                      )}
                                    </>
                                  ) : (
                                    ''
                                  );
                                })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data &&
                                this.props.data.trims &&
                                this.props.data.trims
                                  .filter((item: any) => item.subType === 0)
                                  .map((item: any, index: number) => {
                                    let trimShippingPrice: any = [];
                                    let trimUnitPrice: any = [];
                                    let trimItem: any;
                                    if (
                                      item.draperyOrderFabric &&
                                      item.draperyOrderFabric.pattern
                                    ) {
                                      trimItem =
                                        this.props.data.fabricsPatternItems &&
                                        this.props.data.fabricsPatternItems?.find(
                                          (fabricPattern: any) =>
                                            fabricPattern.name === item.draperyOrderFabric.pattern
                                        );

                                      trimUnitPrice[index] = this.getPricingSectionPrice(
                                        trimItem || {}
                                      );
                                      trimShippingPrice[index] =
                                        this.props.data.fabricsPatternItems &&
                                        this.props.data.fabricsPatternItems?.find(
                                          (fabricPattern: any) =>
                                            fabricPattern.name === item.draperyOrderFabric.pattern
                                        )
                                          ? this.props.data.fabricsPatternItems?.find(
                                              (fabricPattern: any) =>
                                                fabricPattern.name ===
                                                item.draperyOrderFabric.pattern
                                            ).shippingCost || '0.00'
                                          : '0.00';
                                    }

                                    return item.draperyOrderFabric ? (
                                      <div>
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          {this.props.workOrderEditMode
                                            ? item.draperyOrderFabric.orderOrigin !== 2
                                              ? 'TBD'
                                              : 'COM'
                                            : this.props.data &&
                                                this.props.data.fabricsPatternItems &&
                                                !['', null, undefined].includes(
                                                  this.props.yardage.trimsPreMadeYardage[index]
                                                )
                                              ? item.draperyOrderFabric.orderOrigin === 1 &&
                                                trimItem
                                                ? (
                                                    parseFloat(trimUnitPrice[index]) *
                                                      (this.props.yardage.trimsPreMadeYardage[
                                                        index
                                                      ] !== '0'
                                                        ? +this.props.yardage.trimsPreMadeYardage[
                                                            index
                                                          ]
                                                        : 1) +
                                                    parseFloat(
                                                      shippingPriceTrim.filter(
                                                        (item: any) => item && item.subType === 0
                                                      )[index].price
                                                    )
                                                  ).toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  })
                                                : item.draperyOrderFabric.orderOrigin !== 2
                                                  ? ''
                                                  : 'COM'
                                              : item.draperyOrderFabric.orderOrigin !== 2
                                                ? 'TBD'
                                                : 'COM'}
                                        </div>
                                      </div>
                                    ) : null;
                                  })}
                            </div>
                          </td>
                          {showBundleColumn && (
                            <td>
                              <div>
                                {this.props.data &&
                                  this.props.data.trims &&
                                  this.props.data.trims
                                    .filter((item: any) => item.subType === 0)
                                    .map((item: any, index: number) => {
                                      return item.draperyOrderFabric ? (
                                        <div>
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            <Checkbox
                                              checked={embellishmentBundleSelected}
                                              onCheckedChange={() => {
                                                handleBundleConfigSettings('embellishments');
                                              }}
                                            />
                                          </div>
                                        </div>
                                      ) : null;
                                    })}
                              </div>
                            </td>
                          )}
                        </tr>

                        <tr>
                          <td>
                            <div>
                              {this.props.data.trims
                                .filter((item: any) => item.subType === 1)
                                .map((item: any, index: number) => {
                                  const newItem =
                                    item &&
                                    item.draperyOrderFabric &&
                                    item.draperyOrderFabric.pattern;
                                  return item.draperyOrderFabric ? (
                                    <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-left">
                                      <div>
                                        <p className="font-bold">{item.draperyOrderFabric.name}</p>
                                        {this.renderEstimateDescriptionParagraphs(
                                          item.draperyOrderFabric,
                                          this.props.data?.fabricsPatternItems
                                        )}
                                        <WorkorderMeasureWrapper>
                                          {this.props.data &&
                                            this.props.data.fabricsPatternItems &&
                                            this.props.data.trims.filter(
                                              (item: any) => item.subType === 1
                                            )[index].draperyOrderFabric &&
                                            this.props.data.trims.filter(
                                              (item: any) => item.subType === 1
                                            )[index].draperyOrderFabric.values &&
                                            Object.entries(
                                              this.props.data.trims.filter(
                                                (item: any) => item.subType === 1
                                              )[index].draperyOrderFabric.values
                                            )
                                              .sort((a, b): any => {
                                                const [keyA] = a;
                                                const [keyB] = b;

                                                if (keyA === 'horizontalRepeat') return 1;
                                                if (keyB === 'horizontalRepeat') return -1;
                                                if (keyA === 'fabricWidth') return -1;
                                                if (keyB === 'fabricWidth') return 1;
                                                return 0;
                                              })
                                              .filter(([key, value]) => key !== 'trimWidth')
                                              .map(([key, value], index) => {
                                                if (
                                                  value === null ||
                                                  value === '' ||
                                                  value === undefined
                                                ) {
                                                  return;
                                                }
                                                return (
                                                  <WorkorderMeasure
                                                    className="last-separator"
                                                    style={{
                                                      color: '#545454',
                                                    }}
                                                  >
                                                    <span> {property[index]}</span>
                                                    <p>
                                                      {value}"<span>/</span>
                                                    </p>
                                                  </WorkorderMeasure>
                                                );
                                              })}
                                        </WorkorderMeasureWrapper>
                                      </div>
                                    </div>
                                  ) : null;
                                })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data.trims
                                .filter((item: any) => item.subType === 1)
                                .map((content: any, index: any) => {
                                  return content.draperyOrderFabric ? (
                                    <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                      {this.props.draperyOrder.newRomanShade ||
                                      !this.props.draperyOrder.id ? (
                                        this.props.workOrderEditMode ? (
                                          <span>TBD</span>
                                        ) : (
                                          <span>
                                            {this.props.yardage.trimsFabricYardage[index] || 'TBD'}
                                          </span>
                                        )
                                      ) : (
                                        <CalculatorFieldInput
                                          uiWidth={180}
                                          style={{
                                            margin: '-24px auto 0px auto',
                                            border: '1px solid #b3b3b3',
                                            borderRadius: '0.5rem',
                                          }}
                                        >
                                          <CalculatorYardageInput
                                            id={`trimsFabricYardage.${index}`}
                                            name={`trimsFabricYardage.${index}`}
                                            type="number"
                                            value={
                                              this.props.yardage.trimsFabricYardage[index] || ''
                                            }
                                            onChange={this.props.setYardage}
                                            disabled={
                                              !(workOrderEditMode || isCreateMode) &&
                                              this.props.workOrder.id !== 0
                                            }
                                            uiDisabled={
                                              !(workOrderEditMode || isCreateMode) &&
                                              this.props.workOrder.id !== 0
                                            }
                                          />
                                        </CalculatorFieldInput>
                                      )}
                                    </div>
                                  ) : null;
                                })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data.trims
                                .filter((item: any) => item.subType === 1)
                                .map((item: any, index: number) => {
                                  let trimUnitPrice: any = [];
                                  if (item.draperyOrderFabric && item.draperyOrderFabric.pattern) {
                                    const trimItem =
                                      this.props.data.fabricsPatternItems &&
                                      this.props.data.fabricsPatternItems?.find(
                                        (fabricPattern: any) =>
                                          fabricPattern.name === item.draperyOrderFabric.pattern
                                      );
                                    trimUnitPrice[index] = this.getPricingSectionPrice(
                                      trimItem || {}
                                    );
                                  }
                                  return item.draperyOrderFabric ? (
                                    <>
                                      {trimUnitPrice[index] &&
                                      item.draperyOrderFabric.orderOrigin &&
                                      item.draperyOrderFabric.orderOrigin === 1 ? (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          {trimUnitPrice[index]}
                                        </div>
                                      ) : item.draperyOrderFabric.orderOrigin === 2 ? (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          COM
                                        </div>
                                      ) : (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center"></div>
                                      )}
                                    </>
                                  ) : (
                                    ''
                                  );
                                })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data.trims
                                .filter((item: any) => item.subType === 1)
                                .map((item: any, index: any) => {
                                  let trimShippingPrice: any = [];
                                  if (item.draperyOrderFabric && item.draperyOrderFabric.pattern) {
                                    const trimItem =
                                      this.props.data.fabricsPatternItems &&
                                      this.props.data.fabricsPatternItems?.find(
                                        (fabricPattern: any) =>
                                          fabricPattern.name === item.draperyOrderFabric.pattern
                                      );
                                    trimShippingPrice[index] = trimItem
                                      ? trimItem.shippingCost || '0.00'
                                      : '';
                                  }
                                  return item.draperyOrderFabric ? (
                                    <>
                                      {shippingPriceTrim[index] &&
                                      item.draperyOrderFabric.orderOrigin &&
                                      item.draperyOrderFabric.orderOrigin === 1 ? (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          {shippingPriceTrim[index].price}
                                        </div>
                                      ) : item.draperyOrderFabric.orderOrigin === 2 ? (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          COM
                                        </div>
                                      ) : (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center"></div>
                                      )}
                                    </>
                                  ) : (
                                    ''
                                  );
                                })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data &&
                                this.props.data.trims &&
                                this.props.data.trims
                                  .filter((item: any) => item.subType === 1)
                                  .map((item: any, index: number) => {
                                    let trimUnitPrice: any = [];
                                    let trimItem: any;
                                    if (
                                      item.draperyOrderFabric &&
                                      item.draperyOrderFabric.pattern
                                    ) {
                                      trimItem =
                                        this.props.data.fabricsPatternItems &&
                                        this.props.data.fabricsPatternItems?.find(
                                          (fabricPattern: any) =>
                                            fabricPattern.name === item.draperyOrderFabric.pattern
                                        );
                                      trimUnitPrice[index] = this.getPricingSectionPrice(
                                        trimItem || {}
                                      );
                                    }

                                    return item.draperyOrderFabric ? (
                                      <div>
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          {this.props.workOrderEditMode
                                            ? item.draperyOrderFabric.orderOrigin !== 2
                                              ? 'TBD'
                                              : 'COM'
                                            : this.props.data &&
                                                this.props.data.fabricsPatternItems &&
                                                !['', null, undefined].includes(
                                                  this.props.yardage.trimsFabricYardage[index]
                                                )
                                              ? item.draperyOrderFabric.orderOrigin === 1 &&
                                                trimItem
                                                ? (
                                                    parseFloat(trimUnitPrice[index]) *
                                                      (this.props.yardage.trimsFabricYardage[
                                                        index
                                                      ] !== '0'
                                                        ? +this.props.yardage.trimsFabricYardage[
                                                            index
                                                          ]
                                                        : 1) +
                                                    parseFloat(shippingPriceTrim[index].price)
                                                  ).toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  })
                                                : item.draperyOrderFabric.orderOrigin !== 2
                                                  ? ''
                                                  : 'COM'
                                              : item.draperyOrderFabric.orderOrigin !== 2
                                                ? 'TBD'
                                                : 'COM'}
                                        </div>
                                      </div>
                                    ) : null;
                                  })}
                            </div>
                          </td>
                          {showBundleColumn && (
                            <td>
                              <div>
                                {this.props.data &&
                                  this.props.data.trims &&
                                  this.props.data.trims
                                    .filter((item: any) => item.subType === 1)
                                    .map((item: any, index: number) => {
                                      return item.draperyOrderFabric ? (
                                        <div>
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            <Checkbox
                                              checked={embellishmentBundleSelected}
                                              onCheckedChange={() => {
                                                handleBundleConfigSettings('embellishments');
                                              }}
                                            />
                                          </div>
                                        </div>
                                      ) : null;
                                    })}
                              </div>
                            </td>
                          )}
                        </tr>

                        <tr>
                          <td>
                            <div>
                              {this.props.data &&
                                this.props.data.liningsList &&
                                this.props.data.liningsList
                                  .filter((item: any, index: number) => {
                                    if (index === 0) {
                                      return item.active || forBackValance;
                                    } else {
                                      return item.active;
                                    }
                                  })
                                  .map((item: any) => {
                                    const newItem =
                                      item &&
                                      item.draperyOrderLiningsFabric &&
                                      item.draperyOrderLiningsFabric.pattern &&
                                      item.draperyOrderLiningsFabric.orderOrigin === 1
                                        ? item.draperyOrderLiningsFabric.pattern
                                        : item.draperyOrderLiningsFabric;
                                    if (newItem) {
                                      return item.draperyOrderLiningsFabric ? (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-left">
                                          <div>
                                            <div className="flex">
                                              <p className="font-bold">
                                                {item.draperyOrderLiningsFabric.name}
                                              </p>
                                              <p className="ml-2">
                                                {' '}
                                                {forBackValance &&
                                                item.draperyOrderLiningsFabric.name ===
                                                  'LINING FABRIC'
                                                  ? ' (for Back Valance)'
                                                  : ''}
                                              </p>
                                            </div>
                                            {this.renderEstimateDescriptionParagraphs(
                                              item.draperyOrderLiningsFabric,
                                              this.props.data?.liningsPatternItems
                                            )}
                                            {this.shouldRenderLegacyComponentMeasurements(
                                              item.draperyOrderLiningsFabric
                                            ) &&
                                              item &&
                                              item.draperyOrderLiningsFabric &&
                                              item.draperyOrderLiningsFabric.values &&
                                              item.draperyOrderLiningsFabric.values.fabricWidth !==
                                                null &&
                                              item.draperyOrderLiningsFabric.values.fabricWidth !==
                                                undefined &&
                                              item.draperyOrderLiningsFabric.values.fabricWidth !==
                                                '' && (
                                                <div>
                                                  <span className="mr-2">W:</span>
                                                  {
                                                    item.draperyOrderLiningsFabric.values
                                                      .fabricWidth
                                                  }
                                                  "
                                                </div>
                                              )}
                                          </div>
                                        </div>
                                      ) : null;
                                    }
                                  })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data &&
                                this.props.data.liningsList &&
                                this.props.data.liningsList.length > 0 &&
                                this.props.data.liningsList.map((item: any, index: any) => {
                                  if (item && item.active) {
                                    if (
                                      item.draperyOrderLiningsFabric &&
                                      item.draperyOrderLiningsFabric.name === 'LINING FABRIC'
                                    ) {
                                      if (
                                        this.props.draperyOrder.newRomanShade ||
                                        !this.props.draperyOrder.id
                                      ) {
                                        return this.props.workOrderEditMode ? (
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            <span>TBD</span>
                                          </div>
                                        ) : (
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            <span>
                                              {this.props.yardage.liningsYardage[index] || 'TBD'}
                                            </span>
                                          </div>
                                        );
                                      } else {
                                        return (
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            <CalculatorFieldInput
                                              uiWidth={180}
                                              style={{
                                                margin: 'auto 0px auto',
                                                border: '1px solid #b3b3b3',
                                                borderRadius: '0.5rem',
                                              }}
                                            >
                                              <CalculatorYardageInput
                                                id={`liningsYardage.${index}`}
                                                name={`liningsYardage.${index}`}
                                                type="number"
                                                value={
                                                  this.props.yardage.liningsYardage[index] || ''
                                                }
                                                onChange={this.props.setYardage}
                                                disabled={
                                                  !(workOrderEditMode || isCreateMode) &&
                                                  this.props.workOrder.id !== 0
                                                }
                                                uiDisabled={
                                                  !(workOrderEditMode || isCreateMode) &&
                                                  this.props.workOrder.id !== 0
                                                }
                                              />
                                            </CalculatorFieldInput>
                                          </div>
                                        );
                                      }
                                    } else if (
                                      item.draperyOrderLiningsFabric &&
                                      item.draperyOrderLiningsFabric.name === 'INTERLINING FABRIC'
                                    ) {
                                      interliningMaterialYardage =
                                        item.draperyOrderLiningsFabric.yardsNeeded;

                                      if (
                                        this.props.draperyOrder.newRomanShade ||
                                        !this.props.draperyOrder.id
                                      ) {
                                        return this.props.workOrderEditMode ? (
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            <span>TBD</span>
                                          </div>
                                        ) : (
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            <span>
                                              {this.props.yardage.liningsYardage[index] || 'TBD'}
                                            </span>
                                          </div>
                                        );
                                      } else {
                                        return (
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            <CalculatorFieldInput
                                              uiWidth={180}
                                              style={{
                                                margin: 'auto 0px auto',
                                                border: '1px solid #b3b3b3',
                                                borderRadius: '0.5rem',
                                              }}
                                            >
                                              <CalculatorYardageInput
                                                id={`liningsYardage.${index}`}
                                                name={`liningsYardage.${index}`}
                                                type="number"
                                                value={
                                                  this.props.yardage.liningsYardage[index] || ''
                                                }
                                                onChange={
                                                  this.props.setYardage
                                                  // this.props
                                                  //     .handleInputChangeForString
                                                }
                                                disabled={
                                                  !(workOrderEditMode || isCreateMode) &&
                                                  this.props.workOrder.id !== 0
                                                }
                                                uiDisabled={
                                                  !(workOrderEditMode || isCreateMode) &&
                                                  this.props.workOrder.id !== 0
                                                }
                                              />
                                            </CalculatorFieldInput>
                                          </div>
                                        );
                                      }
                                    }
                                  }
                                })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data &&
                                this.props.data.liningsList &&
                                this.props.data.liningsList
                                  .filter((item: any, index: number) => {
                                    if (index === 0) {
                                      return item.active || forBackValance;
                                    } else {
                                      return item.active;
                                    }
                                  })
                                  .map((item: any) => {
                                    const newItem =
                                      item &&
                                      item.draperyOrderLiningsFabric &&
                                      item.draperyOrderLiningsFabric;
                                    let liningUnitPrice;
                                    if (
                                      item.draperyOrderLiningsFabric &&
                                      item.draperyOrderLiningsFabric.pattern
                                    ) {
                                      const liningItem =
                                        this.props.data.liningsPatternItems &&
                                        this.props.data.liningsPatternItems?.find(
                                          (fabricPattern: any) =>
                                            fabricPattern.name ===
                                            item.draperyOrderLiningsFabric.pattern
                                        );
                                      liningUnitPrice = this.getPricingSectionPrice(
                                        liningItem || {}
                                      );
                                    }
                                    for (
                                      let i = 0;
                                      i <
                                      this.props.data.liningsList.filter(
                                        (item: any, index: number) => {
                                          if (index === 0) {
                                            return item.active || forBackValance;
                                          } else {
                                            return item.active;
                                          }
                                        }
                                      ).length;
                                      i++
                                    ) {
                                      return newItem ? (
                                        <>
                                          {liningUnitPrice &&
                                          item.draperyOrderLiningsFabric.orderOrigin !== 2 ? (
                                            <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                              {liningUnitPrice}
                                            </div>
                                          ) : item.draperyOrderLiningsFabric.orderOrigin === 2 ? (
                                            <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                              COM
                                            </div>
                                          ) : (
                                            <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center"></div>
                                          )}
                                        </>
                                      ) : (
                                        ''
                                      );
                                    }
                                  })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data &&
                                this.props.data.liningsList &&
                                this.props.data.liningsList
                                  .filter((item: any, index: number) => {
                                    if (index === 0) {
                                      return item.active || forBackValance;
                                    } else {
                                      return item.active;
                                    }
                                  })
                                  .map((item: any) => {
                                    const newItem =
                                      item &&
                                      item.draperyOrderLiningsFabric &&
                                      item.draperyOrderLiningsFabric;

                                    return newItem ? (
                                      <>
                                        {this.props.data &&
                                        this.props.data.liningsPatternItems &&
                                        item.draperyOrderLiningsFabric.orderOrigin === 2 ? (
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            COM
                                          </div>
                                        ) : (
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            {item.name === 'Lining'
                                              ? shippingPriceLiningsFabric
                                              : shippingPriceInterliningsFabric}
                                          </div>
                                        )}
                                      </>
                                    ) : (
                                      ''
                                    );
                                  })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data &&
                                this.props.data.liningsList
                                  .filter((item: any, index: number) => {
                                    if (index === 0) {
                                      return item.active || forBackValance;
                                    } else {
                                      return item.active;
                                    }
                                  })
                                  .map((item: any, index: any) => {
                                    item.draperyOrderLiningsFabric &&
                                      item.draperyOrderLiningsFabric;
                                    let liningUnitPrice: any;
                                    let liningItem: any;
                                    if (
                                      item.draperyOrderLiningsFabric &&
                                      item.draperyOrderLiningsFabric.pattern
                                    ) {
                                      liningItem =
                                        this.props.data.liningsPatternItems &&
                                        this.props.data.liningsPatternItems?.find(
                                          (fabricPattern: any) =>
                                            fabricPattern.name ===
                                            item.draperyOrderLiningsFabric.pattern
                                        );
                                      liningUnitPrice = this.getPricingSectionPrice(
                                        liningItem || {}
                                      );
                                    }

                                    const liningTotal =
                                      item.name === 'Lining'
                                        ? parseFloat(liningUnitPrice) *
                                            (this.props.yardage.liningsYardage[0] !== '0'
                                              ? +this.props.yardage.liningsYardage[index]
                                              : 1) +
                                          parseFloat(shippingPriceLiningsFabric)
                                        : parseFloat(liningUnitPrice) *
                                            (this.props.yardage.liningsYardage[index] !== '0'
                                              ? +this.props.yardage.liningsYardage[index]
                                              : 1) +
                                          parseFloat(shippingPriceInterliningsFabric);
                                    const bundlePriceText =
                                      showBundleColumn &&
                                      liningBundleSelected &&
                                      Number.isFinite(liningTotal)
                                        ? 'included in bundle price'
                                        : '';

                                    const show_text_case =
                                      !this.props.workOrderEditMode &&
                                      this.props.data.workOrder.id > 0 &&
                                      item.draperyOrderLiningsFabric &&
                                      item.draperyOrderLiningsFabric.orderOrigin === 1;

                                    return item.draperyOrderLiningsFabric ? (
                                      <div>
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          {item.name === 'Lining'
                                            ? this.props.workOrderEditMode
                                              ? item.draperyOrderLiningsFabric.orderOrigin !== 2
                                                ? 'TBD'
                                                : 'COM'
                                              : this.props.data &&
                                                  this.props.data.fabricsPatternItems &&
                                                  !['', null, undefined].includes(
                                                    this.props.yardage.liningsYardage[index]
                                                  )
                                                ? item.draperyOrderLiningsFabric.orderOrigin ===
                                                    1 && liningItem
                                                  ? (
                                                      parseFloat(liningUnitPrice) *
                                                        (this.props.yardage.liningsYardage[0] !==
                                                        '0'
                                                          ? +this.props.yardage.liningsYardage[
                                                              index
                                                            ]
                                                          : 1) +
                                                      parseFloat(shippingPriceLiningsFabric)
                                                    ).toLocaleString('en-US', {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    })
                                                  : item.draperyOrderLiningsFabric.orderOrigin !== 2
                                                    ? ''
                                                    : 'COM'
                                                : item.draperyOrderLiningsFabric.orderOrigin !== 2
                                                  ? 'TBD'
                                                  : 'COM'
                                            : this.props.workOrderEditMode
                                              ? item.draperyOrderLiningsFabric.orderOrigin !== 2
                                                ? 'TBD'
                                                : 'COM'
                                              : this.props.data &&
                                                  this.props.data.fabricsPatternItems &&
                                                  !['', null, undefined].includes(
                                                    this.props.yardage.liningsYardage[index]
                                                  )
                                                ? item.draperyOrderLiningsFabric.orderOrigin ===
                                                    1 && liningItem
                                                  ? (
                                                      parseFloat(liningUnitPrice) *
                                                        (this.props.yardage.liningsYardage[
                                                          index
                                                        ] !== '0'
                                                          ? +this.props.yardage.liningsYardage[
                                                              index
                                                            ]
                                                          : 1) +
                                                      parseFloat(shippingPriceInterliningsFabric)
                                                    ).toLocaleString('en-US', {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    })
                                                  : item.draperyOrderLiningsFabric.orderOrigin !== 2
                                                    ? ''
                                                    : 'COM'
                                                : item.draperyOrderLiningsFabric.orderOrigin !== 2
                                                  ? 'TBD'
                                                  : 'COM'}
                                          {show_text_case && (
                                            <p className="text-sm text-slate-400">
                                              {bundlePriceText}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    ) : null;
                                  })}
                            </div>
                          </td>
                          {showBundleColumn && (
                            <td>
                              <div>
                                {this.props.data &&
                                  this.props.data.liningsList
                                    .filter((item: any, index: number) => {
                                      if (index === 0) {
                                        return item.active || forBackValance;
                                      } else {
                                        return item.active;
                                      }
                                    })
                                    .map((item: any, index: any) => {
                                      return item.draperyOrderLiningsFabric ? (
                                        <div>
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            <Checkbox
                                              checked={liningBundleSelected}
                                              onCheckedChange={() => {
                                                handleBundleConfigSettings('linings');
                                              }}
                                            />
                                          </div>
                                        </div>
                                      ) : null;
                                    })}
                              </div>
                            </td>
                          )}
                        </tr>

                        <tr>
                          <td>
                            <div>
                              {this.props.data.othersEmbellishments[0] &&
                                this.props.data.othersEmbellishments[0].draperyOrderFabric &&
                                this.props.data.othersEmbellishments.map((item: any) => {
                                  return item.draperyOrderFabric ? (
                                    <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-left">
                                      <div>
                                        <p className="font-bold">
                                          {item && item.name
                                            ? `${item.name.toUpperCase()} FABRIC`
                                            : `UNSPECIFIED FABRIC`}
                                        </p>
                                        {this.renderEstimateDescriptionParagraphs(
                                          item?.draperyOrderFabric,
                                          this.props.data?.fabricsPatternItems
                                        )}
                                      </div>
                                    </div>
                                  ) : null;
                                })}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data.othersEmbellishments[0] &&
                                this.props.data.othersEmbellishments[0].draperyOrderFabric &&
                                this.props.data.othersEmbellishments.map(
                                  (content: any, index: any) => {
                                    return (
                                      <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                        {this.props.draperyOrder.newRomanShade ||
                                        !this.props.draperyOrder.id ? (
                                          this.props.workOrderEditMode ? (
                                            <span>TBD</span>
                                          ) : (
                                            <span>
                                              {this.props.yardage.otherEmbellishmentsYardage[
                                                index
                                              ] || 'TBD'}
                                            </span>
                                          )
                                        ) : (
                                          <CalculatorFieldInput
                                            uiWidth={180}
                                            style={{
                                              margin: '-24px auto 0px auto',
                                              border: '1px solid #b3b3b3',
                                              borderRadius: '0.5rem',
                                            }}
                                          >
                                            <CalculatorYardageInput
                                              id={`otherEmbellishmentsYardage.${index}`}
                                              name={`otherEmbellishmentsYardage.${index}`}
                                              type="number"
                                              value={
                                                this.props.yardage.otherEmbellishmentsYardage[
                                                  index
                                                ] || ''
                                              }
                                              onChange={this.props.setYardage}
                                              readOnly={true}
                                              disabled={
                                                !(workOrderEditMode || isCreateMode) &&
                                                this.props.workOrder.id !== 0
                                              }
                                              uiDisabled={
                                                !(workOrderEditMode || isCreateMode) &&
                                                this.props.workOrder.id !== 0
                                              }
                                            />
                                          </CalculatorFieldInput>
                                        )}
                                      </div>
                                    );
                                  }
                                )}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data.othersEmbellishments.map(
                                (item: any, index: number) => {
                                  let othersEmbellishmentsUnitPrice: any = [];
                                  if (item.draperyOrderFabric && item.draperyOrderFabric) {
                                    const otherEmbellishmentItem =
                                      this.props.data.fabricsPatternItems &&
                                      this.props.data.fabricsPatternItems?.find(
                                        (fabricPattern: any) =>
                                          fabricPattern.name === item.draperyOrderFabric.pattern
                                      );
                                    othersEmbellishmentsUnitPrice[index] =
                                      this.getPricingSectionPrice(otherEmbellishmentItem || {});
                                  }
                                  return item.draperyOrderFabric ? (
                                    <>
                                      {othersEmbellishmentsUnitPrice[index] &&
                                      item.draperyOrderFabric.orderOrigin &&
                                      item.draperyOrderFabric.orderOrigin === 1 ? (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          {othersEmbellishmentsUnitPrice[index]}
                                        </div>
                                      ) : item.draperyOrderFabric.orderOrigin === 2 ? (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          COM
                                        </div>
                                      ) : (
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center"></div>
                                      )}
                                    </>
                                  ) : (
                                    ''
                                  );
                                }
                              )}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data.othersEmbellishments[0] &&
                                this.props.data.othersEmbellishments[0].draperyOrderFabric &&
                                this.props.data.othersEmbellishments.map(
                                  (item: any, index: number) => {
                                    let othersEmbellishmentsUnitPrice: any = [];
                                    if (
                                      item.draperyOrderFabric &&
                                      item.draperyOrderFabric.pattern
                                    ) {
                                      const otherEmbellishmentItem =
                                        this.props.data.fabricsPatternItems &&
                                        this.props.data.fabricsPatternItems?.find(
                                          (fabricPattern: any) =>
                                            fabricPattern.name === item.draperyOrderFabric.pattern
                                        );
                                      othersEmbellishmentsUnitPrice[index] = otherEmbellishmentItem
                                        ? otherEmbellishmentItem.shippingCost || '0.00'
                                        : '';
                                    }
                                    return (
                                      <>
                                        {shippingOthersEmbellishments[index] &&
                                        item.draperyOrderFabric &&
                                        item.draperyOrderFabric.orderOrigin === 1 ? (
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            {shippingOthersEmbellishments[index].price}
                                          </div>
                                        ) : item.draperyOrderFabric &&
                                          item.draperyOrderFabric.orderOrigin === 2 ? (
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            COM
                                          </div>
                                        ) : (
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center"></div>
                                        )}
                                      </>
                                    );
                                  }
                                )}
                            </div>
                          </td>
                          <td>
                            <div>
                              {this.props.data &&
                                this.props.data.othersEmbellishments &&
                                this.props.data.othersEmbellishments[0] &&
                                this.props.data.othersEmbellishments.map(
                                  (item: any, index: number) => {
                                    let otherEmbellishmentUnitPrice: any = [];
                                    let otherEmbellishmentShippingPrice: any = [];
                                    let otherEmbellishmentItem: any;
                                    if (
                                      item.draperyOrderFabric &&
                                      item.draperyOrderFabric.pattern
                                    ) {
                                      // alert()
                                      otherEmbellishmentItem =
                                        this.props.data.fabricsPatternItems &&
                                        this.props.data.fabricsPatternItems?.find(
                                          (fabricPattern: any) =>
                                            fabricPattern.name === item.draperyOrderFabric.pattern
                                        );
                                      otherEmbellishmentUnitPrice[index] =
                                        this.getPricingSectionPrice(otherEmbellishmentItem || {});
                                      otherEmbellishmentShippingPrice[index] =
                                        otherEmbellishmentItem
                                          ? otherEmbellishmentItem.shippingCost || '0.00'
                                          : '';
                                    }
                                    return item.draperyOrderFabric ? (
                                      <div>
                                        <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                          {this.props.workOrderEditMode
                                            ? item.draperyOrderFabric.orderOrigin !== 2
                                              ? 'TBD'
                                              : 'COM'
                                            : this.props.data &&
                                                this.props.data.fabricsPatternItems &&
                                                !['', null, undefined].includes(
                                                  this.props.yardage.otherEmbellishmentsYardage[
                                                    index
                                                  ]
                                                )
                                              ? item.draperyOrderFabric.orderOrigin === 1 &&
                                                otherEmbellishmentItem
                                                ? (
                                                    parseFloat(otherEmbellishmentUnitPrice[index]) *
                                                      (this.props.yardage
                                                        .otherEmbellishmentsYardage[index] !== '0'
                                                        ? +this.props.yardage
                                                            .otherEmbellishmentsYardage[index]
                                                        : 1) +
                                                    parseFloat(
                                                      shippingOthersEmbellishments[index].price
                                                    )
                                                  ).toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  })
                                                : item.draperyOrderFabric.orderOrigin !== 2
                                                  ? ''
                                                  : 'COM'
                                              : item.draperyOrderFabric.orderOrigin !== 2
                                                ? 'TBD'
                                                : 'COM'}
                                        </div>
                                      </div>
                                    ) : null;
                                  }
                                )}
                            </div>
                          </td>
                          {showBundleColumn && (
                            <td>
                              <div>
                                {this.props.data &&
                                  this.props.data.othersEmbellishments &&
                                  this.props.data.othersEmbellishments[0] &&
                                  this.props.data.othersEmbellishments.map(
                                    (item: any, index: number) => {
                                      return item.draperyOrderFabric ? (
                                        <div>
                                          <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                            <Checkbox
                                              checked={embellishmentBundleSelected}
                                              onCheckedChange={() => {
                                                handleBundleConfigSettings('embellishments');
                                              }}
                                            />
                                          </div>
                                        </div>
                                      ) : null;
                                    }
                                  )}
                              </div>
                            </td>
                          )}
                        </tr>

                        <tr>
                          <td>
                            <div>
                              {headrailShouldDisplay && (
                                <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-left">
                                  <div>
                                    <p className="font-bold">HEADRAIL</p>
                                    {headrailSupplier ? <p>{headrailSupplier}</p> : null}
                                    {headrailEstimateDescription ? (
                                      <p>{headrailEstimateDescription}</p>
                                    ) : null}
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                          <td>
                            <div>
                              {headrailShouldDisplay && (
                                <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                  {headrailQuantity || ''}
                                </div>
                              )}
                            </div>
                          </td>
                          <td>
                            <div>
                              {headrailShouldDisplay && (
                                <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                  {headrailPurchaserIsCom ? 'COM' : headrailUnitDisplay}
                                </div>
                              )}
                            </div>
                          </td>
                          <td>
                            <div>
                              {headrailShouldDisplay && (
                                <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                  {headrailPurchaserIsCom
                                    ? 'COM'
                                    : headrailShippingShouldDisplay &&
                                        headrailShippingPrice !== null
                                      ? Number(headrailShippingPrice).toFixed(2)
                                      : '0.00'}
                                </div>
                              )}
                            </div>
                          </td>
                          <td>
                            <div>
                              {headrailShouldDisplay && (
                                <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                  {headrailPurchaserIsCom ? 'COM' : headrailTotalDisplay}
                                </div>
                              )}
                            </div>
                          </td>
                          {showBundleColumn && (
                            <td>
                              <div>
                                {headrailShouldDisplay && (
                                  <div className="p-[10px_10px_0px_10px] [&_p]:m-0 [&_p]:text-[16px] [&_p]:text-[#545454] min-h-[140px] text-center">
                                    <Checkbox
                                      checked={headrailBundleSelected}
                                      onCheckedChange={() => {
                                        handleBundleConfigSettings('headrail');
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </HContainer>
              ) : (
                <HContainer text="fabrics">
                  <SummaryTable>
                    <SummaryTableCol text="fabrics" color="header">
                      <SummaryTableCell
                        className="fabricHeader"
                        text="title"
                        style={{
                          fontSize: window.innerWidth < 992 ? '10px' : 'inherit',
                        }}
                      >
                        Components
                      </SummaryTableCell>
                      <SummaryTableCell></SummaryTableCell>
                      <SummaryTableCell></SummaryTableCell>
                      <SummaryTableCell></SummaryTableCell>
                    </SummaryTableCol>
                    <SummaryTableCol text="not-fabrics">
                      <SummaryTableCell
                        className="fabricHeader"
                        position="center"
                        style={{
                          fontSize: window.innerWidth < 992 ? '10px' : 'inherit',
                        }}
                      >
                        Quantity
                      </SummaryTableCell>
                    </SummaryTableCol>
                    <SummaryTableCol text="not-fabrics">
                      <SummaryTableCell
                        className="fabricHeader"
                        position="center"
                        style={{
                          whiteSpace: 'nowrap',
                          fontSize: window.innerWidth < 992 ? '10px' : 'inherit',
                        }}
                      >
                        Unit Price ($)
                      </SummaryTableCell>
                    </SummaryTableCol>{' '}
                    <SummaryTableCol text="not-fabrics">
                      <SummaryTableCell
                        className="fabricHeader"
                        position="center"
                        style={{
                          whiteSpace: 'nowrap',
                          fontSize: window.innerWidth < 992 ? '10px' : 'inherit',
                        }}
                      >
                        S+H ($)
                      </SummaryTableCell>
                    </SummaryTableCol>{' '}
                    <SummaryTableCol text="not-fabrics">
                      <SummaryTableCell
                        position="center"
                        style={{
                          whiteSpace: 'nowrap',
                          fontSize: window.innerWidth < 992 ? '10px' : 'inherit',
                        }}
                      >
                        Total Price ($)
                      </SummaryTableCell>
                    </SummaryTableCol>
                  </SummaryTable>
                </HContainer>
              )}
            </SummaryInfoBlock>
            <SummaryInfoBlock>
              <DraperyHeader
                noMarginTop
                uiTimeStatus
                uiTimeStatusChecked={readOnlyEstimateSummary.status.toLowerCase() !== 'not created'}
              >
                ESTIMATE
              </DraperyHeader>
              <SummaryTable>
                <SummaryTableCol>
                  <SummaryTableCell>Number</SummaryTableCell>
                  <SummaryTableCell>
                    {hasQuipaEstimateConnection ? (
                      <ReadOnlyEstimateValue>
                        {readOnlyEstimateSummary.estimateNumber
                          ? `#${String(readOnlyEstimateSummary.estimateNumber).replace(/^#/, '')}`
                          : '-'}
                      </ReadOnlyEstimateValue>
                    ) : (
                      <CalculatorFieldInput uiWidth={150}>
                        <CalculatorInput
                          id="draperyOrder.qbEstimateNumber"
                          name="draperyOrder.qbEstimateNumber"
                          type="text"
                          value={this.props.draperyOrder.qbEstimateNumber || ''}
                          onChange={this.props.handleInputChangeForString}
                          uiDisabled={estimateNumberInputDisabled}
                        />
                      </CalculatorFieldInput>
                    )}
                  </SummaryTableCell>
                </SummaryTableCol>
                <SummaryTableCol>
                  <SummaryTableCell>Description</SummaryTableCell>
                  <SummaryTableCell>
                    <CalculatorFieldInputDesc uiWidth={400}>
                      <CalculatorInputDesc
                        id="draperyOrderSummary.estimateJson.description"
                        name="draperyOrderSummary.estimateJson.description"
                        type="text"
                        value={draperyOrderSummary.estimateJson.description || ''}
                        onChange={this.props.handleInputChangeForString}
                        uiDisabled={this.props.draperyOrder.archived}
                      />
                    </CalculatorFieldInputDesc>
                  </SummaryTableCell>
                </SummaryTableCol>
                <SummaryTableCol>
                  <SummaryTableCell>Status</SummaryTableCell>
                  <SummaryTableCell>
                    <CalculatorFieldInput uiWidth={200}>
                      <SelectList
                        name="draperyOrderSummary.estimateJson.num"
                        selectList={statusList}
                        handleClickSelect={this.props.handleSelectListChange}
                        valueSelect={estimateStatusValue}
                        flexDirection="row"
                        smallPadding
                        noClearBox
                        uiDropArrow
                        disabled={this.props.draperyOrder.archived}
                      />
                    </CalculatorFieldInput>
                  </SummaryTableCell>
                </SummaryTableCol>
                <SummaryTableCol>
                  <SummaryTableCell>Date</SummaryTableCell>
                  <SummaryTableCell>
                    <DatePicker
                      selected={datesForPicker.dateSent}
                      onChange={(v: Date | null) =>
                        this.props.handleChangeDates(v, 'draperyOrderSummary.estimateJson.dateSent')
                      }
                      locale={'en'}
                      isClearable={!this.props.draperyOrder.archived}
                      placeholderText="MM/DD/YYYY"
                      className="custom_date_picker"
                      disabled={this.props.draperyOrder.archived}
                    />
                  </SummaryTableCell>
                </SummaryTableCol>
              </SummaryTable>
            </SummaryInfoBlock>
            <SummaryInfoBlock>
              <DraperyHeader
                noMarginTop
                uiTimeStatus
                uiTimeStatusChecked={!!draperyOrderSummary.invoiceJson.num}
              >
                INVOICE
              </DraperyHeader>
              <SummaryTable>
                <SummaryTableCol>
                  <SummaryTableCell>Number</SummaryTableCell>
                  <SummaryTableCell>
                    <CalculatorFieldInput uiWidth={150}>
                      <CalculatorInput
                        id="draperyOrderSummary.invoiceJson.num"
                        name="draperyOrderSummary.invoiceJson.num"
                        type="text"
                        value={draperyOrderSummary.invoiceJson.num || ''}
                        onChange={this.props.handleInputChangeForString}
                        uiDisabled={this.props.draperyOrder.archived}
                      />
                    </CalculatorFieldInput>
                  </SummaryTableCell>
                </SummaryTableCol>
                <SummaryTableCol>
                  <SummaryTableCell>Description</SummaryTableCell>
                  <SummaryTableCell>
                    <CalculatorFieldInputDesc uiWidth={400}>
                      <CalculatorInputDesc
                        id="draperyOrderSummary.invoiceJson.description"
                        name="draperyOrderSummary.invoiceJson.description"
                        type="text"
                        value={draperyOrderSummary.invoiceJson.description || ''}
                        onChange={this.props.handleInputChangeForString}
                        uiDisabled={this.props.draperyOrder.archived}
                      />
                    </CalculatorFieldInputDesc>
                  </SummaryTableCell>
                </SummaryTableCol>
                <SummaryTableCol>
                  <SummaryTableCell>Status</SummaryTableCell>
                  <SummaryTableCell>
                    <CalculatorFieldInput uiWidth={200}>
                      <SelectList
                        name="draperyOrderSummary.invoiceJson.paid"
                        selectList={paidList}
                        handleClickSelect={this.props.handleSelectListChange}
                        valueSelect={draperyOrderSummary.invoiceJson.paid}
                        flexDirection="row"
                        smallPadding
                        noClearBox
                        uiDropArrow
                        disabled={this.props.draperyOrder.archived}
                      />
                    </CalculatorFieldInput>
                  </SummaryTableCell>
                </SummaryTableCol>
                <SummaryTableCol>
                  <SummaryTableCell>Date Sent</SummaryTableCell>
                  <SummaryTableCell>
                    <DatePicker
                      selected={datesForPicker.invoiceDateSent}
                      onChange={(v: Date | null) =>
                        this.props.handleChangeDates(
                          v,
                          'draperyOrderSummary.invoiceJson.invoiceDateSent'
                        )
                      }
                      locale={'en'}
                      isClearable={!this.props.draperyOrder.archived}
                      placeholderText="MM/DD/YYYY"
                      className="custom_date_picker"
                      disabled={this.props.draperyOrder.archived}
                    />
                  </SummaryTableCell>
                </SummaryTableCol>
              </SummaryTable>
            </SummaryInfoBlock>
            <SummaryInfoBlock>
              <DraperyHeader noMarginTop uiTimeStatus uiTimeStatusChecked={componentChecked}>
                COMPONENTS NEEDED
              </DraperyHeader>

              <SummaryComponentTable>
                <SummaryComponentTableRow>
                  <SummaryComponentTableCell uiFlex={1}>Item</SummaryComponentTableCell>
                  <SummaryComponentTableCell uiFlex={1}>Qty</SummaryComponentTableCell>
                  <SummaryComponentTableCell uiFlex={1}>Order No.</SummaryComponentTableCell>
                  <SummaryComponentTableCell uiFlex={1}>Ordered</SummaryComponentTableCell>
                  <SummaryComponentTableCell uiFlex={1}>ETA</SummaryComponentTableCell>
                  <SummaryComponentTableCell uiFlex={1}>Received</SummaryComponentTableCell>
                  <SummaryComponentTableCell style={{ borderRight: 'none' }} uiFlex={1.5}>
                    Notebook
                  </SummaryComponentTableCell>
                  <SummaryComponentTableCell
                    style={{
                      minWidth: '50px',
                      maxWidth: '50px',
                      padding: '0',
                    }}
                    uiFlex={1}
                  ></SummaryComponentTableCell>
                </SummaryComponentTableRow>

                {this.renderComponentRow(
                  mainFabric.draperyOrderSummaryComponent,
                  `mainFabric`,
                  `mainFabric.draperyOrderSummaryComponent`
                )}
                {embellishmentsList[0].checked &&
                  bandings.length !== 0 &&
                  bandings.map((el, idx) => {
                    if (!el.draperyOrderFabric) {
                      return '';
                    }
                    return this.renderComponentRow(
                      el.draperyOrderFabric.draperyOrderSummaryComponent,
                      `bandings.${idx}`,
                      `bandings.${idx}.draperyOrderFabric.draperyOrderSummaryComponent`
                    );
                  })}
                {embellishmentsList[1].checked &&
                  cordings.length !== 0 &&
                  cordings.map((el, idx) => {
                    if (!el.draperyOrderFabric) {
                      return '';
                    }

                    return this.renderComponentRow(
                      el.draperyOrderFabric.draperyOrderSummaryComponent,
                      `cordings.${idx}`,
                      `cordings.${idx}.draperyOrderFabric.draperyOrderSummaryComponent`
                    );
                  })}
                {embellishmentsList[2].checked &&
                  flanges.length !== 0 &&
                  flanges.map((el, idx) => {
                    if (!el.draperyOrderFabric) {
                      return '';
                    }
                    return this.renderComponentRow(
                      el.draperyOrderFabric.draperyOrderSummaryComponent,
                      `flanges.${idx}`,
                      `flanges.${idx}.draperyOrderFabric.draperyOrderSummaryComponent`
                    );
                  })}
                {embellishmentsList[3].checked &&
                  trims.length !== 0 &&
                  trims.map((el, idx) => {
                    if (!el.draperyOrderFabric) {
                      return '';
                    }
                    return this.renderComponentRow(
                      el.draperyOrderFabric.draperyOrderSummaryComponent,
                      `trims.${idx}`,
                      `trims.${idx}.draperyOrderFabric.draperyOrderSummaryComponent`
                    );
                  })}
                {embellishmentsList[4].checked &&
                  othersEmbellishments.length !== 0 &&
                  othersEmbellishments.map((el, idx) => {
                    if (!el.draperyOrderFabric) {
                      return '';
                    }
                    return this.renderComponentRow(
                      el.draperyOrderFabric.draperyOrderSummaryComponent,
                      `othersEmbellishments.${idx}`,
                      `othersEmbellishments.${idx}.draperyOrderFabric.draperyOrderSummaryComponent`
                    );
                  })}

                {/* {this.renderComponentRow(
                  hardware.draperyOrderSummaryComponent,
                  'hardware',
                  'hardware.draperyOrderSummaryComponent'
                )} */}
                {headrailComponentShouldDisplay &&
                  this.renderComponentRow(
                    headRail.draperyOrderSummaryComponent,
                    'headRail',
                    'headRail.draperyOrderSummaryComponent',
                    this.handleDeleteHeadrailComponent
                  )}
                {draperyOrderSummaryComponents.map((component, id) =>
                  this.renderComponentRow(component, id)
                )}
              </SummaryComponentTable>
              <AddSummaryComponentBtn
                uiColor="primary"
                type="button"
                onClick={this.props.handleAddSummaryComponent}
                uiDisabled={this.props.draperyOrder.archived}
              >
                Add more
              </AddSummaryComponentBtn>
            </SummaryInfoBlock>
            <SummaryInfoBlock>
              <DraperyHeader
                noMarginTop
                uiTimeStatus
                uiTimeStatusChecked={!!draperyOrderSummary.productionJson.finishedDate}
              >
                PRODUCTION
              </DraperyHeader>
              <SummaryTable>
                <SummaryTableCol>
                  <SummaryTableCell>Start Date</SummaryTableCell>
                  <SummaryTableCell>
                    <DatePicker
                      selected={datesForPicker.startDate}
                      onChange={(v: Date | null) =>
                        this.props.handleChangeDates(
                          v,
                          'draperyOrderSummary.productionJson.startDate'
                        )
                      }
                      locale={'en'}
                      isClearable={!this.props.draperyOrder.archived}
                      placeholderText="MM/DD/YYYY"
                      className="custom_date_picker"
                      disabled={this.props.draperyOrder.archived}
                    />
                  </SummaryTableCell>
                </SummaryTableCol>
                <SummaryTableCol>
                  <SummaryTableCell>Due Date</SummaryTableCell>
                  <SummaryTableCell>
                    <DatePicker
                      selected={datesForPicker.dueDate}
                      onChange={(v: Date | null) =>
                        this.props.handleChangeDates(
                          v,
                          'draperyOrderSummary.productionJson.dueDate'
                        )
                      }
                      locale={'en'}
                      isClearable={!this.props.draperyOrder.archived}
                      placeholderText="MM/DD/YYYY"
                      className="custom_date_picker"
                      disabled={this.props.draperyOrder.archived}
                    />
                  </SummaryTableCell>
                </SummaryTableCol>
                <SummaryTableCol>
                  <SummaryTableCell>Finished Date</SummaryTableCell>
                  <SummaryTableCell>
                    <DatePicker
                      selected={datesForPicker.finishedDate}
                      onChange={(v: Date | null) =>
                        this.props.handleChangeDates(
                          v,
                          'draperyOrderSummary.productionJson.finishedDate'
                        )
                      }
                      locale={'en'}
                      isClearable={!this.props.draperyOrder.archived}
                      placeholderText="MM/DD/YYYY"
                      className="custom_date_picker"
                      disabled={this.props.draperyOrder.archived}
                    />
                  </SummaryTableCell>
                </SummaryTableCol>
              </SummaryTable>
            </SummaryInfoBlock>
            <SummaryInfoBlock>
              <DraperyHeader
                noMarginTop
                uiTimeStatus
                uiTimeStatusChecked={!!draperyOrderSummary.installationJson.dateOfInstall}
              >
                INSTALLATION
              </DraperyHeader>
              <SummaryTable>
                <SummaryTableCol>
                  <SummaryTableCell>Order #</SummaryTableCell>
                  <SummaryTableCell>
                    <CalculatorFieldInput uiWidth={100}>
                      <CalculatorInput
                        type="text"
                        id="draperyOrderSummary.installationJson.orderNum"
                        name="draperyOrderSummary.installationJson.orderNum"
                        value={draperyOrderSummary.installationJson.orderNum || ''}
                        onChange={this.props.handleInputChangeForString}
                        uiDisabled={this.props.draperyOrder.archived}
                      />
                    </CalculatorFieldInput>
                  </SummaryTableCell>
                </SummaryTableCol>
                <SummaryTableCol>
                  <SummaryTableCell>Date of Install</SummaryTableCell>
                  <SummaryTableCell>
                    <DatePicker
                      selected={datesForPicker.installDate}
                      onChange={(v: Date | null) =>
                        this.props.handleChangeDates(
                          v,
                          'draperyOrderSummary.installationJson.dateOfInstall'
                        )
                      }
                      locale={'en'}
                      isClearable={!this.props.draperyOrder.archived}
                      placeholderText="MM/DD/YYYY"
                      className="custom_date_picker"
                      disabled={this.props.draperyOrder.archived}
                    />
                  </SummaryTableCell>
                </SummaryTableCol>
              </SummaryTable>
            </SummaryInfoBlock>
          </SummaryContent>
        </SummaryContainer>
        <WarningModal
          uiActive={this.state.isWarningModalOpen}
          uiOnConfirm={() => {
            this.setState({
              isWarningModalOpen: false,
            });
          }}
          uiOnRequestClose={() => {
            this.setState({
              isWarningModalOpen: false,
            });
          }}
          uiCloseOnOutsideClick={true}
          uiCloseOnEsc={true}
          uiHeader="Cannot Duplicate"
        >
          <p>
            {`Some options selected on this Roman Shade Order form are no longer available in our updated form. This order is unable to be duplicated; please create a new order instead.`}
          </p>
        </WarningModal>
      </>
    );
  }

  public findItemNumber(items: any, fabItem: any) {
    const targetCategory = fabItem.draperyOrderFabric
      ? fabItem.draperyOrderFabric.name.includes('PRE-MADE')
        ? 'pre-made'
        : 'welt'
      : '';

    const filteredItems = items.filter((item: any) => {
      const itemName = item.draperyOrderFabric ? item.draperyOrderFabric.name : '';
      const itemCategory = itemName.includes('PRE-MADE') ? 'pre-made' : 'welt';
      return itemCategory === targetCategory;
    });

    const indexInFiltered = filteredItems.findIndex((item: any) => item.id === fabItem.id);

    return indexInFiltered;
  }

  private normalizeSummaryFunctionLabel(rawValue?: string) {
    const trimmedValue = (rawValue || '').toString().trim();
    if (!trimmedValue) {
      return '';
    }

    const withoutPremade = trimmedValue
      .replace(/\(pre-?made\)/gi, '')
      .replace(/\s+/g, ' ')
      .trim();
    const normalized = withoutPremade.toLowerCase();

    if (normalized.includes('headrail')) return 'Headrail';
    if (normalized.includes('main')) return 'Main Fabric';
    if (normalized.includes('lining')) return 'Lining Fabric';
    if (normalized.includes('banding')) return 'Banding Fabric';
    if (normalized.includes('cording')) return 'Cording Fabric';
    if (normalized.includes('flange')) return 'Flange Fabric';
    if (normalized.includes('trim')) return 'Trim Fabric';

    const labelWithSuffix = /fabric/i.test(withoutPremade)
      ? withoutPremade
      : `${withoutPremade} Fabric`;
    return labelWithSuffix
      .split(' ')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');
  }

  private getEstimateDescriptionContextForFabric(fabric: any, functionLabelOverride?: string) {
    const romanShadeItemDetailsSource =
      (Array.isArray(this.props.data?.romanShadeItemDetails) &&
        this.props.data?.romanShadeItemDetails?.[0]) ||
      this.props.data?.romanShadeItemDetails;

    const bundleDefaults = this.props?.draperyOrder?.bundleConfigJson ??
      romanShadeItemDetailsSource?.bundleSelections ?? {
        mainFabric: false,
        embellishments: false,
        linings: false,
        headrail: false,
        shippingAndHandling: false,
      };
    const isBundlingSelected = Boolean(romanShadeItemDetailsSource?.isBundlingSelected);

    const rawFunctionLabel =
      functionLabelOverride ||
      (typeof fabric?.fabric === 'string' ? fabric.fabric : '') ||
      fabric?.draperyOrderFabric?.name ||
      fabric?.draperyOrderLiningsFabric?.name ||
      fabric?.name ||
      '';
    const functionLabel = this.normalizeSummaryFunctionLabel(rawFunctionLabel);
    const normalizedFunction = `${functionLabel}`.toLowerCase();

    let isBundled = false;
    if (isBundlingSelected) {
      if (normalizedFunction.includes('headrail')) {
        isBundled = Boolean(bundleDefaults?.headrail);
      } else if (normalizedFunction.includes('main')) {
        isBundled = Boolean(bundleDefaults?.mainFabric);
      } else if (normalizedFunction.includes('lining')) {
        isBundled = Boolean(bundleDefaults?.linings);
      } else {
        isBundled = Boolean(bundleDefaults?.embellishments);
      }
    }

    return {
      functionLabel,
      isBundled,
      yardsNeeded:
        fabric?.yardsNeeded ??
        fabric?.draperyOrderFabric?.yardsNeeded ??
        fabric?.draperyOrderLiningsFabric?.yardsNeeded,
    };
  }

  private renderEstimateDescriptionInfo(
    fabric: any,
    items?: FabricPatternItem[],
    fallbackMode: 'supplier-and-pattern' | 'pattern-only' = 'supplier-and-pattern',
    functionLabelOverride?: string
  ) {
    if (!this.isEstimateDescriptionReady(items)) {
      return null;
    }

    return resolveEstimateDescriptionLines({
      fabric,
      items: items || [],
      fallbackMode,
      descriptionSettings: this.state.accountDescriptionSettings,
      contextOptions: {
        ...this.getEstimateDescriptionContextForFabric(fabric, functionLabelOverride),
        includeContextLine: false,
      },
    }).map((line, index) => (
      <SummaryComponentItemInfo
        key={`${fabric?.id || fabric?.pattern || fabric?.name || 'desc'}-${index}`}
      >
        {line}
      </SummaryComponentItemInfo>
    ));
  }

  private renderEstimateDescriptionParagraphs(
    fabric: any,
    items?: FabricPatternItem[],
    fallbackMode: 'supplier-and-pattern' | 'pattern-only' = 'supplier-and-pattern',
    functionLabelOverride?: string
  ) {
    if (!this.isEstimateDescriptionReady(items)) {
      return null;
    }

    return resolveEstimateDescriptionLines({
      fabric,
      items: items || [],
      fallbackMode,
      descriptionSettings: this.state.accountDescriptionSettings,
      contextOptions: {
        ...this.getEstimateDescriptionContextForFabric(fabric, functionLabelOverride),
        includeContextLine: false,
      },
    }).map((line, index) => (
      <p key={`${fabric?.id || fabric?.pattern || fabric?.name || 'desc'}-${index}`}>{line}</p>
    ));
  }

  private shouldRenderLegacyComponentMeasurements(fabric: any) {
    if (!this.state.initialSummaryDataLoaded) {
      return false;
    }

    const descriptionItems = this.getEstimateDescriptionItemsForFabric(fabric);
    if (
      this.isEstimateDescriptionReady(descriptionItems) &&
      this.resolvedEstimateDescriptionHasMeasurements(fabric, descriptionItems)
    ) {
      return false;
    }

    return !hasExplicitSalesDescriptionSettings({
      fabric,
      descriptionSettings: this.state.accountDescriptionSettings,
    });
  }

  private getEstimateDescriptionItemsForFabric(fabric: any): FabricPatternItem[] | undefined {
    const fabricLabel = `${fabric?.name || fabric?.fabric || ''}`.toLowerCase();
    if (fabricLabel.includes('lining')) {
      return this.props.data?.liningsPatternItems;
    }

    return this.props.data?.fabricsPatternItems;
  }

  private resolvedEstimateDescriptionHasMeasurements(
    fabric: any,
    items?: FabricPatternItem[]
  ): boolean {
    const measurementPattern = /\b(?:W|VR|HR):\s*[^/]+"/i;

    return resolveEstimateDescriptionLines({
      fabric,
      items: items || [],
      fallbackMode: 'supplier-and-pattern',
      descriptionSettings: this.state.accountDescriptionSettings,
      contextOptions: {
        ...this.getEstimateDescriptionContextForFabric(fabric),
        includeContextLine: false,
      },
    })?.some((line) => measurementPattern.test(line));
  }

  private isEstimateDescriptionReady(items?: FabricPatternItem[]) {
    return this.state.initialSummaryDataLoaded && Array.isArray(items);
  }

  public renderComponentRow(
    component: DraperyModule.DraperyOrderSummaryComponent,
    id: number | string,
    targetName?: string,
    onDelete?: () => void
  ) {
    let supplierName;
    let pattern;
    let descriptionFabric;
    const { mainFabric, trims, othersEmbellishments } = this.props;
    const descriptionItems = this.props.data?.fabricsPatternItems;

    let quantityComp;
    const deleteHandler =
      onDelete ||
      (typeof id === 'number' ? () => this.props.handleDeleteSummaryComponent(id) : undefined);

    if (targetName && targetName.includes('mainFabric')) {
      quantityComp =
        this.props.data &&
        this.props.data.workOrderPdfContentSummery &&
        this.props.data.workOrderPdfContentSummery.mainFabricContent &&
        this.props.data.workOrderPdfContentSummery.mainFabricContent.yardsNeeded &&
        this.props.data.workOrderPdfContentSummery.mainFabricContent.yardsNeeded.toString();
      supplierName = mainFabric.supplierName || 'Unspecified';
      pattern = mainFabric.pattern || 'Unspecified';
      descriptionFabric = mainFabric;
    } else if (targetName) {
      if (
        targetName.includes('trim') &&
        component.item &&
        component.item.toLowerCase().includes('pre-made')
      ) {
        let s = targetName;
        let parts = s.split('.');
        let numberStr = parts[1];
        let number = parseInt(numberStr);

        const fabric = trims[number].draperyOrderFabric;
        supplierName = fabric && fabric.supplierName ? fabric.supplierName : 'Unspecified';
        pattern = fabric && fabric.pattern ? fabric.pattern : 'Unspecified';
        descriptionFabric = fabric;

        const trimItem = this.props.trims[number];
        const myNumber = this.findItemNumber(this.props.trims, trimItem);

        quantityComp =
          this.props.data &&
          this.props.data.workOrderPdfContentSummery &&
          this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents &&
          this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents.length > 0 &&
          this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents.length > myNumber &&
          this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents[myNumber] &&
          this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents[myNumber]
            .yardsNeeded &&
          this.props.data.workOrderPdfContentSummery.premadeTrimFabricContents[
            myNumber
          ].yardsNeeded.toString();
      } else if (targetName.includes('othersEmbellishments') && component.item) {
        let s = targetName;
        let parts = s.split('.');
        let numberStr = parts[1];
        let number = parseInt(numberStr);
        const fabric = othersEmbellishments[number].draperyOrderFabric;
        supplierName = fabric && fabric.supplierName ? fabric.supplierName : 'Unspecified';
        pattern = fabric && fabric.pattern ? fabric.pattern : 'Unspecified';
        descriptionFabric = fabric;
        quantityComp =
          this.props.data &&
          this.props.data.othersEmbellishments &&
          this.props.data.othersEmbellishments &&
          this.props.data.othersEmbellishments.length > 0 &&
          this.props.data.othersEmbellishments.length > number &&
          this.props.data.othersEmbellishments[number] &&
          this.props.data.othersEmbellishments[number].draperyOrderFabric &&
          this.props.data.othersEmbellishments[number].draperyOrderFabric.yardsNeeded &&
          this.props.data.othersEmbellishments[number].draperyOrderFabric.yardsNeeded.toString();
      }
    }

    const componentOrderedDate = !component.orderedDate
      ? null
      : moment(component.orderedDate).isValid()
        ? moment(component.orderedDate).toDate()
        : null;

    const componentETADate = !component.eta
      ? null
      : moment(component.eta).isValid()
        ? moment(component.eta).toDate()
        : null;

    const componentReceivedDate = !component.receivedDate
      ? null
      : moment(component.receivedDate).isValid()
        ? moment(component.receivedDate).toDate()
        : null;

    const hasPoGenerated =
      component?.poGenerated || component?.draperyOrderSummaryComponent?.poGenerated || false;
    const poGenerated =
      component?.po || component?.draperyOrderSummaryComponent?.po || '';

    return (
      <SummaryComponentTableRow key={id}>
        <SummaryComponentTableCell uiFlex={1}>
          {targetName ? (
            component.item && component.item.toUpperCase() === 'HARDWARE' ? (
              <div>
                <p>{component.item.toUpperCase()}</p>
                <p>
                  {this.props.draperyOrderHeadrail ? this.props.draperyOrderHeadrail.supplier : ''}
                </p>
              </div>
            ) : component.item ? (
              <div>
                <p style={{ marginBottom: '5px' }}>{component.item.toUpperCase()}</p>
                {descriptionFabric
                  ? this.renderEstimateDescriptionInfo(
                      descriptionFabric,
                      descriptionItems,
                      'supplier-and-pattern',
                      component.item
                    )
                  : null}
              </div>
            ) : (
              ''
            )
          ) : (
            <CalculatorFieldInput uiWidth={200}>
              <CalculatorInput
                type="text"
                id={`draperyOrderSummaryComponents.${id}.item`}
                name={`draperyOrderSummaryComponents.${id}.item`}
                value={component.item || ''}
                onChange={this.props.handleInputChangeForString}
                uiDisabled={this.props.draperyOrder.archived}
              />
            </CalculatorFieldInput>
          )}
        </SummaryComponentTableCell>
        <SummaryComponentTableCell uiFlex={1}>
          {targetName ? (
            component.item && component.item.toUpperCase() === 'HARDWARE' ? (
              <div>
                {this.props && this.props.draperyOrder && this.props.draperyOrder.id
                  ? this.props.draperyOrder.hardwareQuantity
                  : ''}
              </div>
            ) : component.item && component.item.toUpperCase() === 'HEADRAIL' ? (
              <div>
                {this.props.draperyOrderHeadrail &&
                this.props.draperyOrderHeadrail.quantity !== undefined &&
                this.props.draperyOrderHeadrail.quantity !== null &&
                String(this.props.draperyOrderHeadrail.quantity).trim() !== ''
                  ? this.props.draperyOrderHeadrail.quantity
                  : ''}
              </div>
            ) : quantityComp ? (
              quantityComp.toUpperCase() || ''
            ) : (
              ''
            )
          ) : (
            <CalculatorFieldInput uiWidth={100}>
              <CalculatorInput
                type="text"
                id={`draperyOrderSummaryComponents.${id}.quantity`}
                name={`draperyOrderSummaryComponents.${id}.quantity`}
                value={component.quantity || ''}
                onChange={this.props.handleInputChangeForString}
                uiDisabled={this.props.draperyOrder.archived}
              />
            </CalculatorFieldInput>
          )}
        </SummaryComponentTableCell>
        <SummaryComponentTableCell uiFlex={1}>
          {hasPoGenerated ? (
            <span>{poGenerated}</span>
          ) : (
            <CalculatorFieldInput uiWidth={200}>
              <CalculatorInput
                type="text"
                id={targetName ? `${targetName}.po` : `draperyOrderSummaryComponents.${id}.po`}
                name={targetName ? `${targetName}.po` : `draperyOrderSummaryComponents.${id}.po`}
                value={component.po || ''}
                onChange={this.props.handleInputChangeForString}
                uiDisabled={this.props.draperyOrder.archived}
              />
            </CalculatorFieldInput>
          )}
        </SummaryComponentTableCell>
        <SummaryComponentTableCell uiFlex={1}>
          <DatePicker
            className="w-full custom_date_picker"
            selected={componentOrderedDate}
            isClearable={!this.props.draperyOrder.archived}
            placeholderText="MM/DD/YYYY"
            onChange={(v: Date | null) =>
              this.props.handleChangeDates(
                v,
                targetName
                  ? `${targetName}.orderedDate`
                  : `draperyOrderSummaryComponents.${id}.orderedDate`
              )
            }
            disabled={this.props.draperyOrder.archived}
          />
        </SummaryComponentTableCell>
        <SummaryComponentTableCell uiFlex={1}>
          <DatePicker
            className="w-full custom_date_picker"
            selected={componentETADate}
            isClearable={!this.props.draperyOrder.archived}
            placeholderText="MM/DD/YYYY"
            onChange={(v: Date | null) =>
              this.props.handleChangeDates(
                v,
                targetName ? `${targetName}.eta` : `draperyOrderSummaryComponents.${id}.eta`
              )
            }
            disabled={this.props.draperyOrder.archived}
          />
        </SummaryComponentTableCell>
        <SummaryComponentTableCell uiFlex={1}>
          <DatePicker
            className="w-full custom_date_picker"
            selected={componentReceivedDate}
            isClearable={!this.props.draperyOrder.archived}
            placeholderText="MM/DD/YYYY"
            onChange={(v: Date | null) =>
              this.props.handleChangeDates(
                v,
                targetName
                  ? `${targetName}.receivedDate`
                  : `draperyOrderSummaryComponents.${id}.receivedDate`
              )
            }
            disabled={this.props.draperyOrder.archived}
          />
        </SummaryComponentTableCell>
        <SummaryComponentTableCell style={{ borderRight: 'none' }} uiFlex={1.5}>
          <CalculatorFieldInput uiWidth={150}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Notebook
                row={{
                  id: this.props?.draperyOrder?.id || null,
                  client: this.props?.data?.client || this.props?.draperyOrder?.client || null,
                  orderType: this.props?.draperyOrder?.orderType || null,
                  purchasedGoodsItemType: this.props?.draperyOrder?.purchasedGoodsItemType || null,
                  itemType: this.props?.draperyOrder?.itemType || null,
                  roomName:
                    this.props?.draperyOrder?.roomName ||
                    this.props?.draperyOrder?.room?.name ||
                    '',
                  notebook: this.props?.draperyOrder?.notebook || [],
                  archived: this.props?.draperyOrder?.archived || false,
                }}
                defaultTab={Number(component?.id) > 0 ? 'components' : 'items'}
                notebookTabs={
                  Number(component?.id) > 0
                    ? ['projects', 'items', 'components']
                    : ['projects', 'items']
                }
                user={this.props.accountUser}
                table={'items'}
                canAccessTeamSettings={this.props.canAccessTeamSettings}
                componentContext={{
                  componentId: Number(component?.id) > 0 ? Number(component?.id) : null,
                  componentIdType: Number(component?.id) > 0 ? 'summary_component' : null,
                }}
                closeOnOutsideClick={false}
              />
            </div>
          </CalculatorFieldInput>
        </SummaryComponentTableCell>
        <SummaryComponentTableCell
          style={{ minWidth: '50px', maxWidth: '50px', padding: '10px 0px 0px 0px' }}
        >
          {deleteHandler && (
            <DeleteBtn
              disabled={this.props.draperyOrder.archived}
              uiDisabled={this.props.draperyOrder.archived}
              uiColor="primary"
              type="button"
              onClick={deleteHandler}
            >
              &times;
            </DeleteBtn>
          )}
        </SummaryComponentTableCell>
      </SummaryComponentTableRow>
    );
  }
}

export default RomanShadeSummaryTab;
